var Module = (() => {
  var _scriptDir = import.meta.url

  return function (moduleArg = {}) {
    function GROWABLE_HEAP_I8() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAP8
    }
    function GROWABLE_HEAP_U8() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAPU8
    }
    function GROWABLE_HEAP_I16() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAP16
    }
    function GROWABLE_HEAP_U16() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAPU16
    }
    function GROWABLE_HEAP_I32() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAP32
    }
    function GROWABLE_HEAP_U32() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAPU32
    }
    function GROWABLE_HEAP_F32() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAPF32
    }
    function GROWABLE_HEAP_F64() {
      if (wasmMemory.buffer != HEAP8.buffer) {
        updateMemoryViews()
      }
      return HEAPF64
    }
    var Module = moduleArg
    var readyPromiseResolve, readyPromiseReject
    Module['ready'] = new Promise((resolve, reject) => {
      readyPromiseResolve = resolve
      readyPromiseReject = reject
    })
    var moduleOverrides = Object.assign({}, Module)
    var arguments_ = []
    var thisProgram = './this.program'
    var quit_ = (status, toThrow) => {
      throw toThrow
    }
    var ENVIRONMENT_IS_WEB = typeof window == 'object'
    var ENVIRONMENT_IS_WORKER = typeof importScripts == 'function'
    var ENVIRONMENT_IS_NODE =
      typeof process == 'object' &&
      typeof process.versions == 'object' &&
      typeof process.versions.node == 'string'
    var ENVIRONMENT_IS_PTHREAD = Module['ENVIRONMENT_IS_PTHREAD'] || false
    var scriptDirectory = ''
    function locateFile(path) {
      if (Module['locateFile']) {
        return Module['locateFile'](path, scriptDirectory)
      }
      return scriptDirectory + path
    }
    var read_, readAsync, readBinary
    if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
      if (ENVIRONMENT_IS_WORKER) {
        scriptDirectory = self.location.href
      } else if (typeof document != 'undefined' && document.currentScript) {
        scriptDirectory = document.currentScript.src
      }
      if (_scriptDir) {
        scriptDirectory = _scriptDir
      }
      if (scriptDirectory.indexOf('blob:') !== 0) {
        scriptDirectory = scriptDirectory.substr(
          0,
          scriptDirectory.replace(/[?#].*/, '').lastIndexOf('/') + 1
        )
      } else {
        scriptDirectory = ''
      }
      {
        read_ = (url) => {
          var xhr = new XMLHttpRequest()
          xhr.open('GET', url, false)
          xhr.send(null)
          return xhr.responseText
        }
        if (ENVIRONMENT_IS_WORKER) {
          readBinary = (url) => {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, false)
            xhr.responseType = 'arraybuffer'
            xhr.send(null)
            return new Uint8Array(xhr.response)
          }
        }
        readAsync = (url, onload, onerror) => {
          var xhr = new XMLHttpRequest()
          xhr.open('GET', url, true)
          xhr.responseType = 'arraybuffer'
          xhr.onload = () => {
            if (xhr.status == 200 || (xhr.status == 0 && xhr.response)) {
              onload(xhr.response)
              return
            }
            onerror()
          }
          xhr.onerror = onerror
          xhr.send(null)
        }
      }
    } else {
    }
    var out = Module['print'] || console.log.bind(console)
    var err = Module['printErr'] || console.error.bind(console)
    Object.assign(Module, moduleOverrides)
    moduleOverrides = null
    if (Module['arguments']) arguments_ = Module['arguments']
    if (Module['thisProgram']) thisProgram = Module['thisProgram']
    if (Module['quit']) quit_ = Module['quit']
    var wasmBinary
    if (Module['wasmBinary']) wasmBinary = Module['wasmBinary']
    if (typeof WebAssembly != 'object') {
      abort('no native wasm support detected')
    }
    var wasmMemory
    var wasmModule
    var ABORT = false
    var EXITSTATUS
    function assert(condition, text) {
      if (!condition) {
        abort(text)
      }
    }
    var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64
    function updateMemoryViews() {
      var b = wasmMemory.buffer
      Module['HEAP8'] = HEAP8 = new Int8Array(b)
      Module['HEAP16'] = HEAP16 = new Int16Array(b)
      Module['HEAPU8'] = HEAPU8 = new Uint8Array(b)
      Module['HEAPU16'] = HEAPU16 = new Uint16Array(b)
      Module['HEAP32'] = HEAP32 = new Int32Array(b)
      Module['HEAPU32'] = HEAPU32 = new Uint32Array(b)
      Module['HEAPF32'] = HEAPF32 = new Float32Array(b)
      Module['HEAPF64'] = HEAPF64 = new Float64Array(b)
    }
    var INITIAL_MEMORY = Module['INITIAL_MEMORY'] || 16777216
    assert(
      INITIAL_MEMORY >= 65536,
      'INITIAL_MEMORY should be larger than STACK_SIZE, was ' +
        INITIAL_MEMORY +
        '! (STACK_SIZE=' +
        65536 +
        ')'
    )
    if (ENVIRONMENT_IS_PTHREAD) {
      wasmMemory = Module['wasmMemory']
    } else {
      if (Module['wasmMemory']) {
        wasmMemory = Module['wasmMemory']
      } else {
        wasmMemory = new WebAssembly.Memory({
          initial: INITIAL_MEMORY / 65536,
          maximum: 2147483648 / 65536,
          shared: true
        })
        if (!(wasmMemory.buffer instanceof SharedArrayBuffer)) {
          err(
            'requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag'
          )
          if (ENVIRONMENT_IS_NODE) {
            err(
              '(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)'
            )
          }
          throw Error('bad memory')
        }
      }
    }
    updateMemoryViews()
    INITIAL_MEMORY = wasmMemory.buffer.byteLength
    var __ATPRERUN__ = []
    var __ATINIT__ = []
    var __ATPOSTRUN__ = []
    var runtimeInitialized = false
    function preRun() {
      if (Module['preRun']) {
        if (typeof Module['preRun'] == 'function') Module['preRun'] = [Module['preRun']]
        while (Module['preRun'].length) {
          addOnPreRun(Module['preRun'].shift())
        }
      }
      callRuntimeCallbacks(__ATPRERUN__)
    }
    function initRuntime() {
      runtimeInitialized = true
      if (ENVIRONMENT_IS_PTHREAD) return
      if (!Module['noFSInit'] && !FS.init.initialized) FS.init()
      FS.ignorePermissions = false
      TTY.init()
      SOCKFS.root = FS.mount(SOCKFS, {}, null)
      PIPEFS.root = FS.mount(PIPEFS, {}, null)
      callRuntimeCallbacks(__ATINIT__)
    }
    function postRun() {
      if (ENVIRONMENT_IS_PTHREAD) return
      if (Module['postRun']) {
        if (typeof Module['postRun'] == 'function') Module['postRun'] = [Module['postRun']]
        while (Module['postRun'].length) {
          addOnPostRun(Module['postRun'].shift())
        }
      }
      callRuntimeCallbacks(__ATPOSTRUN__)
    }
    function addOnPreRun(cb) {
      __ATPRERUN__.unshift(cb)
    }
    function addOnInit(cb) {
      __ATINIT__.unshift(cb)
    }
    function addOnPostRun(cb) {
      __ATPOSTRUN__.unshift(cb)
    }
    var runDependencies = 0
    var runDependencyWatcher = null
    var dependenciesFulfilled = null
    function getUniqueRunDependency(id) {
      return id
    }
    function addRunDependency(id) {
      runDependencies++
      if (Module['monitorRunDependencies']) {
        Module['monitorRunDependencies'](runDependencies)
      }
    }
    function removeRunDependency(id) {
      runDependencies--
      if (Module['monitorRunDependencies']) {
        Module['monitorRunDependencies'](runDependencies)
      }
      if (runDependencies == 0) {
        if (runDependencyWatcher !== null) {
          clearInterval(runDependencyWatcher)
          runDependencyWatcher = null
        }
        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled
          dependenciesFulfilled = null
          callback()
        }
      }
    }
    function abort(what) {
      if (Module['onAbort']) {
        Module['onAbort'](what)
      }
      what = 'Aborted(' + what + ')'
      err(what)
      ABORT = true
      EXITSTATUS = 1
      what += '. Build with -sASSERTIONS for more info.'
      var e = new WebAssembly.RuntimeError(what)
      readyPromiseReject(e)
      throw e
    }
    var dataURIPrefix = 'data:application/octet-stream;base64,'
    var isDataURI = (filename) => filename.startsWith(dataURIPrefix)
    var wasmBinaryFile
    if (Module['locateFile']) {
      wasmBinaryFile = 'libapi.wasm'
      if (!isDataURI(wasmBinaryFile)) {
        wasmBinaryFile = locateFile(wasmBinaryFile)
      }
    } else {
      wasmBinaryFile = new URL('libapi.wasm', import.meta.url).href
    }
    function getBinarySync(file) {
      if (file == wasmBinaryFile && wasmBinary) {
        return new Uint8Array(wasmBinary)
      }
      if (readBinary) {
        return readBinary(file)
      }
      throw 'both async and sync fetching of the wasm failed'
    }
    function getBinaryPromise(binaryFile) {
      if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
        if (typeof fetch == 'function') {
          return fetch(binaryFile, { credentials: 'same-origin' })
            .then((response) => {
              if (!response['ok']) {
                throw "failed to load wasm binary file at '" + binaryFile + "'"
              }
              return response['arrayBuffer']()
            })
            .catch(() => getBinarySync(binaryFile))
        }
      }
      return Promise.resolve().then(() => getBinarySync(binaryFile))
    }
    function instantiateArrayBuffer(binaryFile, imports, receiver) {
      return getBinaryPromise(binaryFile)
        .then((binary) => WebAssembly.instantiate(binary, imports))
        .then((instance) => instance)
        .then(receiver, (reason) => {
          err(`failed to asynchronously prepare wasm: ${reason}`)
          abort(reason)
        })
    }
    function instantiateAsync(binary, binaryFile, imports, callback) {
      if (
        !binary &&
        typeof WebAssembly.instantiateStreaming == 'function' &&
        !isDataURI(binaryFile) &&
        typeof fetch == 'function'
      ) {
        return fetch(binaryFile, { credentials: 'same-origin' }).then((response) => {
          var result = WebAssembly.instantiateStreaming(response, imports)
          return result.then(callback, function (reason) {
            err(`wasm streaming compile failed: ${reason}`)
            err('falling back to ArrayBuffer instantiation')
            return instantiateArrayBuffer(binaryFile, imports, callback)
          })
        })
      }
      return instantiateArrayBuffer(binaryFile, imports, callback)
    }
    function createWasm() {
      var info = { a: wasmImports }
      function receiveInstance(instance, module) {
        wasmExports = instance.exports
        wasmExports = Asyncify.instrumentWasmExports(wasmExports)
        registerTLSInit(wasmExports['ab'])
        wasmTable = wasmExports['db']
        addOnInit(wasmExports['Va'])
        wasmModule = module
        removeRunDependency('wasm-instantiate')
        return wasmExports
      }
      addRunDependency('wasm-instantiate')
      function receiveInstantiationResult(result) {
        receiveInstance(result['instance'], result['module'])
      }
      if (Module['instantiateWasm']) {
        try {
          return Module['instantiateWasm'](info, receiveInstance)
        } catch (e) {
          err(`Module.instantiateWasm callback failed with error: ${e}`)
          readyPromiseReject(e)
        }
      }
      instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(
        readyPromiseReject
      )
      return {}
    }
    var tempDouble
    var tempI64
    var ASM_CONSTS = { 473828: ($0, $1, $2) => stringToUTF16(Emval.toValue($0), $1, $2) }
    function em_libusb_notify() {
      dispatchEvent(new Event('em-libusb'))
    }
    function __asyncjs__em_libusb_wait(timeout) {
      return Asyncify.handleAsync(async () => {
        let onEvent, timeoutId
        try {
          return await new Promise((resolve) => {
            onEvent = () => resolve(0)
            addEventListener('em-libusb', onEvent)
            timeoutId = setTimeout(resolve, timeout, -1)
          })
        } finally {
          removeEventListener('em-libusb', onEvent)
          clearTimeout(timeoutId)
        }
      })
    }
    function em_promise_catch_impl(handle) {
      let promise = Emval.toValue(handle)
      promise = promise.then(
        (value) => ({ error: 0, value: value }),
        (error) => {
          const ERROR_CODES = {
            NetworkError: -1,
            DataError: -2,
            TypeMismatchError: -2,
            IndexSizeError: -2,
            SecurityError: -3,
            NotFoundError: -5,
            InvalidStateError: -6,
            TimeoutError: -7,
            AbortError: -10,
            NotSupportedError: -12
          }
          console.error(error)
          let errorCode = -99
          if (error instanceof DOMException) {
            errorCode = ERROR_CODES[error.name] ?? errorCode
          } else if (error instanceof RangeError || error instanceof TypeError) {
            errorCode = -2
          }
          return { error: errorCode, value: undefined }
        }
      )
      return Emval.toHandle(promise)
    }
    function em_start_transfer_impl(transfer, handle) {
      Emval.toValue(handle).then((result) => {
        _em_signal_transfer_completion(transfer, Emval.toHandle(result))
      })
    }
    function ExitStatus(status) {
      this.name = 'ExitStatus'
      this.message = `Program terminated with exit(${status})`
      this.status = status
    }
    var terminateWorker = (worker) => {
      worker.terminate()
      worker.onmessage = (e) => {}
    }
    var killThread = (pthread_ptr) => {
      var worker = PThread.pthreads[pthread_ptr]
      delete PThread.pthreads[pthread_ptr]
      terminateWorker(worker)
      __emscripten_thread_free_data(pthread_ptr)
      PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1)
      worker.pthread_ptr = 0
    }
    var cancelThread = (pthread_ptr) => {
      var worker = PThread.pthreads[pthread_ptr]
      worker.postMessage({ cmd: 'cancel' })
    }
    var cleanupThread = (pthread_ptr) => {
      var worker = PThread.pthreads[pthread_ptr]
      assert(worker)
      PThread.returnWorkerToPool(worker)
    }
    var spawnThread = (threadParams) => {
      var worker = PThread.getNewWorker()
      if (!worker) {
        return 6
      }
      PThread.runningWorkers.push(worker)
      PThread.pthreads[threadParams.pthread_ptr] = worker
      worker.pthread_ptr = threadParams.pthread_ptr
      var msg = {
        cmd: 'run',
        start_routine: threadParams.startRoutine,
        arg: threadParams.arg,
        pthread_ptr: threadParams.pthread_ptr
      }
      worker.postMessage(msg, threadParams.transferList)
      return 0
    }
    var runtimeKeepaliveCounter = 0
    var keepRuntimeAlive = () => noExitRuntime || runtimeKeepaliveCounter > 0
    var PATH = {
      isAbs: (path) => path.charAt(0) === '/',
      splitPath: (filename) => {
        var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/
        return splitPathRe.exec(filename).slice(1)
      },
      normalizeArray: (parts, allowAboveRoot) => {
        var up = 0
        for (var i = parts.length - 1; i >= 0; i--) {
          var last = parts[i]
          if (last === '.') {
            parts.splice(i, 1)
          } else if (last === '..') {
            parts.splice(i, 1)
            up++
          } else if (up) {
            parts.splice(i, 1)
            up--
          }
        }
        if (allowAboveRoot) {
          for (; up; up--) {
            parts.unshift('..')
          }
        }
        return parts
      },
      normalize: (path) => {
        var isAbsolute = PATH.isAbs(path),
          trailingSlash = path.substr(-1) === '/'
        path = PATH.normalizeArray(
          path.split('/').filter((p) => !!p),
          !isAbsolute
        ).join('/')
        if (!path && !isAbsolute) {
          path = '.'
        }
        if (path && trailingSlash) {
          path += '/'
        }
        return (isAbsolute ? '/' : '') + path
      },
      dirname: (path) => {
        var result = PATH.splitPath(path),
          root = result[0],
          dir = result[1]
        if (!root && !dir) {
          return '.'
        }
        if (dir) {
          dir = dir.substr(0, dir.length - 1)
        }
        return root + dir
      },
      basename: (path) => {
        if (path === '/') return '/'
        path = PATH.normalize(path)
        path = path.replace(/\/$/, '')
        var lastSlash = path.lastIndexOf('/')
        if (lastSlash === -1) return path
        return path.substr(lastSlash + 1)
      },
      join: function () {
        var paths = Array.prototype.slice.call(arguments)
        return PATH.normalize(paths.join('/'))
      },
      join2: (l, r) => PATH.normalize(l + '/' + r)
    }
    var initRandomFill = () => {
      if (typeof crypto == 'object' && typeof crypto['getRandomValues'] == 'function') {
        return (view) => (view.set(crypto.getRandomValues(new Uint8Array(view.byteLength))), view)
      } else abort('initRandomDevice')
    }
    var randomFill = (view) => (randomFill = initRandomFill())(view)
    var PATH_FS = {
      resolve: function () {
        var resolvedPath = '',
          resolvedAbsolute = false
        for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
          var path = i >= 0 ? arguments[i] : FS.cwd()
          if (typeof path != 'string') {
            throw new TypeError('Arguments to path.resolve must be strings')
          } else if (!path) {
            return ''
          }
          resolvedPath = path + '/' + resolvedPath
          resolvedAbsolute = PATH.isAbs(path)
        }
        resolvedPath = PATH.normalizeArray(
          resolvedPath.split('/').filter((p) => !!p),
          !resolvedAbsolute
        ).join('/')
        return (resolvedAbsolute ? '/' : '') + resolvedPath || '.'
      },
      relative: (from, to) => {
        from = PATH_FS.resolve(from).substr(1)
        to = PATH_FS.resolve(to).substr(1)
        function trim(arr) {
          var start = 0
          for (; start < arr.length; start++) {
            if (arr[start] !== '') break
          }
          var end = arr.length - 1
          for (; end >= 0; end--) {
            if (arr[end] !== '') break
          }
          if (start > end) return []
          return arr.slice(start, end - start + 1)
        }
        var fromParts = trim(from.split('/'))
        var toParts = trim(to.split('/'))
        var length = Math.min(fromParts.length, toParts.length)
        var samePartsLength = length
        for (var i = 0; i < length; i++) {
          if (fromParts[i] !== toParts[i]) {
            samePartsLength = i
            break
          }
        }
        var outputParts = []
        for (var i = samePartsLength; i < fromParts.length; i++) {
          outputParts.push('..')
        }
        outputParts = outputParts.concat(toParts.slice(samePartsLength))
        return outputParts.join('/')
      }
    }
    var UTF8Decoder = typeof TextDecoder != 'undefined' ? new TextDecoder('utf8') : undefined
    var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead) => {
      var endIdx = idx + maxBytesToRead
      var endPtr = idx
      while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr
      if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
        return UTF8Decoder.decode(
          heapOrArray.buffer instanceof SharedArrayBuffer
            ? heapOrArray.slice(idx, endPtr)
            : heapOrArray.subarray(idx, endPtr)
        )
      }
      var str = ''
      while (idx < endPtr) {
        var u0 = heapOrArray[idx++]
        if (!(u0 & 128)) {
          str += String.fromCharCode(u0)
          continue
        }
        var u1 = heapOrArray[idx++] & 63
        if ((u0 & 224) == 192) {
          str += String.fromCharCode(((u0 & 31) << 6) | u1)
          continue
        }
        var u2 = heapOrArray[idx++] & 63
        if ((u0 & 240) == 224) {
          u0 = ((u0 & 15) << 12) | (u1 << 6) | u2
        } else {
          u0 = ((u0 & 7) << 18) | (u1 << 12) | (u2 << 6) | (heapOrArray[idx++] & 63)
        }
        if (u0 < 65536) {
          str += String.fromCharCode(u0)
        } else {
          var ch = u0 - 65536
          str += String.fromCharCode(55296 | (ch >> 10), 56320 | (ch & 1023))
        }
      }
      return str
    }
    var FS_stdin_getChar_buffer = []
    var lengthBytesUTF8 = (str) => {
      var len = 0
      for (var i = 0; i < str.length; ++i) {
        var c = str.charCodeAt(i)
        if (c <= 127) {
          len++
        } else if (c <= 2047) {
          len += 2
        } else if (c >= 55296 && c <= 57343) {
          len += 4
          ++i
        } else {
          len += 3
        }
      }
      return len
    }
    var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
      if (!(maxBytesToWrite > 0)) return 0
      var startIdx = outIdx
      var endIdx = outIdx + maxBytesToWrite - 1
      for (var i = 0; i < str.length; ++i) {
        var u = str.charCodeAt(i)
        if (u >= 55296 && u <= 57343) {
          var u1 = str.charCodeAt(++i)
          u = (65536 + ((u & 1023) << 10)) | (u1 & 1023)
        }
        if (u <= 127) {
          if (outIdx >= endIdx) break
          heap[outIdx++] = u
        } else if (u <= 2047) {
          if (outIdx + 1 >= endIdx) break
          heap[outIdx++] = 192 | (u >> 6)
          heap[outIdx++] = 128 | (u & 63)
        } else if (u <= 65535) {
          if (outIdx + 2 >= endIdx) break
          heap[outIdx++] = 224 | (u >> 12)
          heap[outIdx++] = 128 | ((u >> 6) & 63)
          heap[outIdx++] = 128 | (u & 63)
        } else {
          if (outIdx + 3 >= endIdx) break
          heap[outIdx++] = 240 | (u >> 18)
          heap[outIdx++] = 128 | ((u >> 12) & 63)
          heap[outIdx++] = 128 | ((u >> 6) & 63)
          heap[outIdx++] = 128 | (u & 63)
        }
      }
      heap[outIdx] = 0
      return outIdx - startIdx
    }
    function intArrayFromString(stringy, dontAddNull, length) {
      var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1
      var u8array = new Array(len)
      var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length)
      if (dontAddNull) u8array.length = numBytesWritten
      return u8array
    }
    var FS_stdin_getChar = () => {
      if (!FS_stdin_getChar_buffer.length) {
        var result = null
        if (typeof window != 'undefined' && typeof window.prompt == 'function') {
          result = window.prompt('Input: ')
          if (result !== null) {
            result += '\n'
          }
        } else if (typeof readline == 'function') {
          result = readline()
          if (result !== null) {
            result += '\n'
          }
        }
        if (!result) {
          return null
        }
        FS_stdin_getChar_buffer = intArrayFromString(result, true)
      }
      return FS_stdin_getChar_buffer.shift()
    }
    var TTY = {
      ttys: [],
      init() {},
      shutdown() {},
      register(dev, ops) {
        TTY.ttys[dev] = { input: [], output: [], ops: ops }
        FS.registerDevice(dev, TTY.stream_ops)
      },
      stream_ops: {
        open(stream) {
          var tty = TTY.ttys[stream.node.rdev]
          if (!tty) {
            throw new FS.ErrnoError(43)
          }
          stream.tty = tty
          stream.seekable = false
        },
        close(stream) {
          stream.tty.ops.fsync(stream.tty)
        },
        fsync(stream) {
          stream.tty.ops.fsync(stream.tty)
        },
        read(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.get_char) {
            throw new FS.ErrnoError(60)
          }
          var bytesRead = 0
          for (var i = 0; i < length; i++) {
            var result
            try {
              result = stream.tty.ops.get_char(stream.tty)
            } catch (e) {
              throw new FS.ErrnoError(29)
            }
            if (result === undefined && bytesRead === 0) {
              throw new FS.ErrnoError(6)
            }
            if (result === null || result === undefined) break
            bytesRead++
            buffer[offset + i] = result
          }
          if (bytesRead) {
            stream.node.timestamp = Date.now()
          }
          return bytesRead
        },
        write(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.put_char) {
            throw new FS.ErrnoError(60)
          }
          try {
            for (var i = 0; i < length; i++) {
              stream.tty.ops.put_char(stream.tty, buffer[offset + i])
            }
          } catch (e) {
            throw new FS.ErrnoError(29)
          }
          if (length) {
            stream.node.timestamp = Date.now()
          }
          return i
        }
      },
      default_tty_ops: {
        get_char(tty) {
          return FS_stdin_getChar()
        },
        put_char(tty, val) {
          if (val === null || val === 10) {
            out(UTF8ArrayToString(tty.output, 0))
            tty.output = []
          } else {
            if (val != 0) tty.output.push(val)
          }
        },
        fsync(tty) {
          if (tty.output && tty.output.length > 0) {
            out(UTF8ArrayToString(tty.output, 0))
            tty.output = []
          }
        },
        ioctl_tcgets(tty) {
          return {
            c_iflag: 25856,
            c_oflag: 5,
            c_cflag: 191,
            c_lflag: 35387,
            c_cc: [
              3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0
            ]
          }
        },
        ioctl_tcsets(tty, optional_actions, data) {
          return 0
        },
        ioctl_tiocgwinsz(tty) {
          return [24, 80]
        }
      },
      default_tty1_ops: {
        put_char(tty, val) {
          if (val === null || val === 10) {
            err(UTF8ArrayToString(tty.output, 0))
            tty.output = []
          } else {
            if (val != 0) tty.output.push(val)
          }
        },
        fsync(tty) {
          if (tty.output && tty.output.length > 0) {
            err(UTF8ArrayToString(tty.output, 0))
            tty.output = []
          }
        }
      }
    }
    var mmapAlloc = (size) => {
      abort()
    }
    var MEMFS = {
      ops_table: null,
      mount(mount) {
        return MEMFS.createNode(null, '/', 16384 | 511, 0)
      },
      createNode(parent, name, mode, dev) {
        if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
          throw new FS.ErrnoError(63)
        }
        if (!MEMFS.ops_table) {
          MEMFS.ops_table = {
            dir: {
              node: {
                getattr: MEMFS.node_ops.getattr,
                setattr: MEMFS.node_ops.setattr,
                lookup: MEMFS.node_ops.lookup,
                mknod: MEMFS.node_ops.mknod,
                rename: MEMFS.node_ops.rename,
                unlink: MEMFS.node_ops.unlink,
                rmdir: MEMFS.node_ops.rmdir,
                readdir: MEMFS.node_ops.readdir,
                symlink: MEMFS.node_ops.symlink
              },
              stream: { llseek: MEMFS.stream_ops.llseek }
            },
            file: {
              node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr },
              stream: {
                llseek: MEMFS.stream_ops.llseek,
                read: MEMFS.stream_ops.read,
                write: MEMFS.stream_ops.write,
                allocate: MEMFS.stream_ops.allocate,
                mmap: MEMFS.stream_ops.mmap,
                msync: MEMFS.stream_ops.msync
              }
            },
            link: {
              node: {
                getattr: MEMFS.node_ops.getattr,
                setattr: MEMFS.node_ops.setattr,
                readlink: MEMFS.node_ops.readlink
              },
              stream: {}
            },
            chrdev: {
              node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr },
              stream: FS.chrdev_stream_ops
            }
          }
        }
        var node = FS.createNode(parent, name, mode, dev)
        if (FS.isDir(node.mode)) {
          node.node_ops = MEMFS.ops_table.dir.node
          node.stream_ops = MEMFS.ops_table.dir.stream
          node.contents = {}
        } else if (FS.isFile(node.mode)) {
          node.node_ops = MEMFS.ops_table.file.node
          node.stream_ops = MEMFS.ops_table.file.stream
          node.usedBytes = 0
          node.contents = null
        } else if (FS.isLink(node.mode)) {
          node.node_ops = MEMFS.ops_table.link.node
          node.stream_ops = MEMFS.ops_table.link.stream
        } else if (FS.isChrdev(node.mode)) {
          node.node_ops = MEMFS.ops_table.chrdev.node
          node.stream_ops = MEMFS.ops_table.chrdev.stream
        }
        node.timestamp = Date.now()
        if (parent) {
          parent.contents[name] = node
          parent.timestamp = node.timestamp
        }
        return node
      },
      getFileDataAsTypedArray(node) {
        if (!node.contents) return new Uint8Array(0)
        if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes)
        return new Uint8Array(node.contents)
      },
      expandFileStorage(node, newCapacity) {
        var prevCapacity = node.contents ? node.contents.length : 0
        if (prevCapacity >= newCapacity) return
        var CAPACITY_DOUBLING_MAX = 1024 * 1024
        newCapacity = Math.max(
          newCapacity,
          (prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125)) >>> 0
        )
        if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256)
        var oldContents = node.contents
        node.contents = new Uint8Array(newCapacity)
        if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0)
      },
      resizeFileStorage(node, newSize) {
        if (node.usedBytes == newSize) return
        if (newSize == 0) {
          node.contents = null
          node.usedBytes = 0
        } else {
          var oldContents = node.contents
          node.contents = new Uint8Array(newSize)
          if (oldContents) {
            node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)))
          }
          node.usedBytes = newSize
        }
      },
      node_ops: {
        getattr(node) {
          var attr = {}
          attr.dev = FS.isChrdev(node.mode) ? node.id : 1
          attr.ino = node.id
          attr.mode = node.mode
          attr.nlink = 1
          attr.uid = 0
          attr.gid = 0
          attr.rdev = node.rdev
          if (FS.isDir(node.mode)) {
            attr.size = 4096
          } else if (FS.isFile(node.mode)) {
            attr.size = node.usedBytes
          } else if (FS.isLink(node.mode)) {
            attr.size = node.link.length
          } else {
            attr.size = 0
          }
          attr.atime = new Date(node.timestamp)
          attr.mtime = new Date(node.timestamp)
          attr.ctime = new Date(node.timestamp)
          attr.blksize = 4096
          attr.blocks = Math.ceil(attr.size / attr.blksize)
          return attr
        },
        setattr(node, attr) {
          if (attr.mode !== undefined) {
            node.mode = attr.mode
          }
          if (attr.timestamp !== undefined) {
            node.timestamp = attr.timestamp
          }
          if (attr.size !== undefined) {
            MEMFS.resizeFileStorage(node, attr.size)
          }
        },
        lookup(parent, name) {
          throw FS.genericErrors[44]
        },
        mknod(parent, name, mode, dev) {
          return MEMFS.createNode(parent, name, mode, dev)
        },
        rename(old_node, new_dir, new_name) {
          if (FS.isDir(old_node.mode)) {
            var new_node
            try {
              new_node = FS.lookupNode(new_dir, new_name)
            } catch (e) {}
            if (new_node) {
              for (var i in new_node.contents) {
                throw new FS.ErrnoError(55)
              }
            }
          }
          delete old_node.parent.contents[old_node.name]
          old_node.parent.timestamp = Date.now()
          old_node.name = new_name
          new_dir.contents[new_name] = old_node
          new_dir.timestamp = old_node.parent.timestamp
          old_node.parent = new_dir
        },
        unlink(parent, name) {
          delete parent.contents[name]
          parent.timestamp = Date.now()
        },
        rmdir(parent, name) {
          var node = FS.lookupNode(parent, name)
          for (var i in node.contents) {
            throw new FS.ErrnoError(55)
          }
          delete parent.contents[name]
          parent.timestamp = Date.now()
        },
        readdir(node) {
          var entries = ['.', '..']
          for (var key in node.contents) {
            if (!node.contents.hasOwnProperty(key)) {
              continue
            }
            entries.push(key)
          }
          return entries
        },
        symlink(parent, newname, oldpath) {
          var node = MEMFS.createNode(parent, newname, 511 | 40960, 0)
          node.link = oldpath
          return node
        },
        readlink(node) {
          if (!FS.isLink(node.mode)) {
            throw new FS.ErrnoError(28)
          }
          return node.link
        }
      },
      stream_ops: {
        read(stream, buffer, offset, length, position) {
          var contents = stream.node.contents
          if (position >= stream.node.usedBytes) return 0
          var size = Math.min(stream.node.usedBytes - position, length)
          if (size > 8 && contents.subarray) {
            buffer.set(contents.subarray(position, position + size), offset)
          } else {
            for (var i = 0; i < size; i++) buffer[offset + i] = contents[position + i]
          }
          return size
        },
        write(stream, buffer, offset, length, position, canOwn) {
          if (buffer.buffer === GROWABLE_HEAP_I8().buffer) {
            canOwn = false
          }
          if (!length) return 0
          var node = stream.node
          node.timestamp = Date.now()
          if (buffer.subarray && (!node.contents || node.contents.subarray)) {
            if (canOwn) {
              node.contents = buffer.subarray(offset, offset + length)
              node.usedBytes = length
              return length
            } else if (node.usedBytes === 0 && position === 0) {
              node.contents = buffer.slice(offset, offset + length)
              node.usedBytes = length
              return length
            } else if (position + length <= node.usedBytes) {
              node.contents.set(buffer.subarray(offset, offset + length), position)
              return length
            }
          }
          MEMFS.expandFileStorage(node, position + length)
          if (node.contents.subarray && buffer.subarray) {
            node.contents.set(buffer.subarray(offset, offset + length), position)
          } else {
            for (var i = 0; i < length; i++) {
              node.contents[position + i] = buffer[offset + i]
            }
          }
          node.usedBytes = Math.max(node.usedBytes, position + length)
          return length
        },
        llseek(stream, offset, whence) {
          var position = offset
          if (whence === 1) {
            position += stream.position
          } else if (whence === 2) {
            if (FS.isFile(stream.node.mode)) {
              position += stream.node.usedBytes
            }
          }
          if (position < 0) {
            throw new FS.ErrnoError(28)
          }
          return position
        },
        allocate(stream, offset, length) {
          MEMFS.expandFileStorage(stream.node, offset + length)
          stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length)
        },
        mmap(stream, length, position, prot, flags) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43)
          }
          var ptr
          var allocated
          var contents = stream.node.contents
          if (!(flags & 2) && contents.buffer === GROWABLE_HEAP_I8().buffer) {
            allocated = false
            ptr = contents.byteOffset
          } else {
            if (position > 0 || position + length < contents.length) {
              if (contents.subarray) {
                contents = contents.subarray(position, position + length)
              } else {
                contents = Array.prototype.slice.call(contents, position, position + length)
              }
            }
            allocated = true
            ptr = mmapAlloc(length)
            if (!ptr) {
              throw new FS.ErrnoError(48)
            }
            GROWABLE_HEAP_I8().set(contents, ptr)
          }
          return { ptr: ptr, allocated: allocated }
        },
        msync(stream, buffer, offset, length, mmapFlags) {
          MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false)
          return 0
        }
      }
    }
    var asyncLoad = (url, onload, onerror, noRunDep) => {
      var dep = !noRunDep ? getUniqueRunDependency(`al ${url}`) : ''
      readAsync(
        url,
        (arrayBuffer) => {
          assert(arrayBuffer, `Loading data file "${url}" failed (no arrayBuffer).`)
          onload(new Uint8Array(arrayBuffer))
          if (dep) removeRunDependency(dep)
        },
        (event) => {
          if (onerror) {
            onerror()
          } else {
            throw `Loading data file "${url}" failed.`
          }
        }
      )
      if (dep) addRunDependency(dep)
    }
    var FS_createDataFile = (parent, name, fileData, canRead, canWrite, canOwn) =>
      FS.createDataFile(parent, name, fileData, canRead, canWrite, canOwn)
    var preloadPlugins = Module['preloadPlugins'] || []
    var FS_handledByPreloadPlugin = (byteArray, fullname, finish, onerror) => {
      if (typeof Browser != 'undefined') Browser.init()
      var handled = false
      preloadPlugins.forEach((plugin) => {
        if (handled) return
        if (plugin['canHandle'](fullname)) {
          plugin['handle'](byteArray, fullname, finish, onerror)
          handled = true
        }
      })
      return handled
    }
    var FS_createPreloadedFile = (
      parent,
      name,
      url,
      canRead,
      canWrite,
      onload,
      onerror,
      dontCreateFile,
      canOwn,
      preFinish
    ) => {
      var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent
      var dep = getUniqueRunDependency(`cp ${fullname}`)
      function processData(byteArray) {
        function finish(byteArray) {
          if (preFinish) preFinish()
          if (!dontCreateFile) {
            FS_createDataFile(parent, name, byteArray, canRead, canWrite, canOwn)
          }
          if (onload) onload()
          removeRunDependency(dep)
        }
        if (
          FS_handledByPreloadPlugin(byteArray, fullname, finish, () => {
            if (onerror) onerror()
            removeRunDependency(dep)
          })
        ) {
          return
        }
        finish(byteArray)
      }
      addRunDependency(dep)
      if (typeof url == 'string') {
        asyncLoad(url, (byteArray) => processData(byteArray), onerror)
      } else {
        processData(url)
      }
    }
    var FS_modeStringToFlags = (str) => {
      var flagModes = {
        r: 0,
        'r+': 2,
        w: 512 | 64 | 1,
        'w+': 512 | 64 | 2,
        a: 1024 | 64 | 1,
        'a+': 1024 | 64 | 2
      }
      var flags = flagModes[str]
      if (typeof flags == 'undefined') {
        throw new Error(`Unknown file open mode: ${str}`)
      }
      return flags
    }
    var FS_getMode = (canRead, canWrite) => {
      var mode = 0
      if (canRead) mode |= 292 | 73
      if (canWrite) mode |= 146
      return mode
    }
    var FS = {
      root: null,
      mounts: [],
      devices: {},
      streams: [],
      nextInode: 1,
      nameTable: null,
      currentPath: '/',
      initialized: false,
      ignorePermissions: true,
      ErrnoError: null,
      genericErrors: {},
      filesystems: null,
      syncFSRequests: 0,
      lookupPath(path, opts = {}) {
        path = PATH_FS.resolve(path)
        if (!path) return { path: '', node: null }
        var defaults = { follow_mount: true, recurse_count: 0 }
        opts = Object.assign(defaults, opts)
        if (opts.recurse_count > 8) {
          throw new FS.ErrnoError(32)
        }
        var parts = path.split('/').filter((p) => !!p)
        var current = FS.root
        var current_path = '/'
        for (var i = 0; i < parts.length; i++) {
          var islast = i === parts.length - 1
          if (islast && opts.parent) {
            break
          }
          current = FS.lookupNode(current, parts[i])
          current_path = PATH.join2(current_path, parts[i])
          if (FS.isMountpoint(current)) {
            if (!islast || (islast && opts.follow_mount)) {
              current = current.mounted.root
            }
          }
          if (!islast || opts.follow) {
            var count = 0
            while (FS.isLink(current.mode)) {
              var link = FS.readlink(current_path)
              current_path = PATH_FS.resolve(PATH.dirname(current_path), link)
              var lookup = FS.lookupPath(current_path, { recurse_count: opts.recurse_count + 1 })
              current = lookup.node
              if (count++ > 40) {
                throw new FS.ErrnoError(32)
              }
            }
          }
        }
        return { path: current_path, node: current }
      },
      getPath(node) {
        var path
        while (true) {
          if (FS.isRoot(node)) {
            var mount = node.mount.mountpoint
            if (!path) return mount
            return mount[mount.length - 1] !== '/' ? `${mount}/${path}` : mount + path
          }
          path = path ? `${node.name}/${path}` : node.name
          node = node.parent
        }
      },
      hashName(parentid, name) {
        var hash = 0
        for (var i = 0; i < name.length; i++) {
          hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0
        }
        return ((parentid + hash) >>> 0) % FS.nameTable.length
      },
      hashAddNode(node) {
        var hash = FS.hashName(node.parent.id, node.name)
        node.name_next = FS.nameTable[hash]
        FS.nameTable[hash] = node
      },
      hashRemoveNode(node) {
        var hash = FS.hashName(node.parent.id, node.name)
        if (FS.nameTable[hash] === node) {
          FS.nameTable[hash] = node.name_next
        } else {
          var current = FS.nameTable[hash]
          while (current) {
            if (current.name_next === node) {
              current.name_next = node.name_next
              break
            }
            current = current.name_next
          }
        }
      },
      lookupNode(parent, name) {
        var errCode = FS.mayLookup(parent)
        if (errCode) {
          throw new FS.ErrnoError(errCode, parent)
        }
        var hash = FS.hashName(parent.id, name)
        for (var node = FS.nameTable[hash]; node; node = node.name_next) {
          var nodeName = node.name
          if (node.parent.id === parent.id && nodeName === name) {
            return node
          }
        }
        return FS.lookup(parent, name)
      },
      createNode(parent, name, mode, rdev) {
        var node = new FS.FSNode(parent, name, mode, rdev)
        FS.hashAddNode(node)
        return node
      },
      destroyNode(node) {
        FS.hashRemoveNode(node)
      },
      isRoot(node) {
        return node === node.parent
      },
      isMountpoint(node) {
        return !!node.mounted
      },
      isFile(mode) {
        return (mode & 61440) === 32768
      },
      isDir(mode) {
        return (mode & 61440) === 16384
      },
      isLink(mode) {
        return (mode & 61440) === 40960
      },
      isChrdev(mode) {
        return (mode & 61440) === 8192
      },
      isBlkdev(mode) {
        return (mode & 61440) === 24576
      },
      isFIFO(mode) {
        return (mode & 61440) === 4096
      },
      isSocket(mode) {
        return (mode & 49152) === 49152
      },
      flagsToPermissionString(flag) {
        var perms = ['r', 'w', 'rw'][flag & 3]
        if (flag & 512) {
          perms += 'w'
        }
        return perms
      },
      nodePermissions(node, perms) {
        if (FS.ignorePermissions) {
          return 0
        }
        if (perms.includes('r') && !(node.mode & 292)) {
          return 2
        } else if (perms.includes('w') && !(node.mode & 146)) {
          return 2
        } else if (perms.includes('x') && !(node.mode & 73)) {
          return 2
        }
        return 0
      },
      mayLookup(dir) {
        var errCode = FS.nodePermissions(dir, 'x')
        if (errCode) return errCode
        if (!dir.node_ops.lookup) return 2
        return 0
      },
      mayCreate(dir, name) {
        try {
          var node = FS.lookupNode(dir, name)
          return 20
        } catch (e) {}
        return FS.nodePermissions(dir, 'wx')
      },
      mayDelete(dir, name, isdir) {
        var node
        try {
          node = FS.lookupNode(dir, name)
        } catch (e) {
          return e.errno
        }
        var errCode = FS.nodePermissions(dir, 'wx')
        if (errCode) {
          return errCode
        }
        if (isdir) {
          if (!FS.isDir(node.mode)) {
            return 54
          }
          if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
            return 10
          }
        } else {
          if (FS.isDir(node.mode)) {
            return 31
          }
        }
        return 0
      },
      mayOpen(node, flags) {
        if (!node) {
          return 44
        }
        if (FS.isLink(node.mode)) {
          return 32
        } else if (FS.isDir(node.mode)) {
          if (FS.flagsToPermissionString(flags) !== 'r' || flags & 512) {
            return 31
          }
        }
        return FS.nodePermissions(node, FS.flagsToPermissionString(flags))
      },
      MAX_OPEN_FDS: 4096,
      nextfd() {
        for (var fd = 0; fd <= FS.MAX_OPEN_FDS; fd++) {
          if (!FS.streams[fd]) {
            return fd
          }
        }
        throw new FS.ErrnoError(33)
      },
      getStreamChecked(fd) {
        var stream = FS.getStream(fd)
        if (!stream) {
          throw new FS.ErrnoError(8)
        }
        return stream
      },
      getStream: (fd) => FS.streams[fd],
      createStream(stream, fd = -1) {
        if (!FS.FSStream) {
          FS.FSStream = function () {
            this.shared = {}
          }
          FS.FSStream.prototype = {}
          Object.defineProperties(FS.FSStream.prototype, {
            object: {
              get() {
                return this.node
              },
              set(val) {
                this.node = val
              }
            },
            isRead: {
              get() {
                return (this.flags & 2097155) !== 1
              }
            },
            isWrite: {
              get() {
                return (this.flags & 2097155) !== 0
              }
            },
            isAppend: {
              get() {
                return this.flags & 1024
              }
            },
            flags: {
              get() {
                return this.shared.flags
              },
              set(val) {
                this.shared.flags = val
              }
            },
            position: {
              get() {
                return this.shared.position
              },
              set(val) {
                this.shared.position = val
              }
            }
          })
        }
        stream = Object.assign(new FS.FSStream(), stream)
        if (fd == -1) {
          fd = FS.nextfd()
        }
        stream.fd = fd
        FS.streams[fd] = stream
        return stream
      },
      closeStream(fd) {
        FS.streams[fd] = null
      },
      chrdev_stream_ops: {
        open(stream) {
          var device = FS.getDevice(stream.node.rdev)
          stream.stream_ops = device.stream_ops
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream)
          }
        },
        llseek() {
          throw new FS.ErrnoError(70)
        }
      },
      major: (dev) => dev >> 8,
      minor: (dev) => dev & 255,
      makedev: (ma, mi) => (ma << 8) | mi,
      registerDevice(dev, ops) {
        FS.devices[dev] = { stream_ops: ops }
      },
      getDevice: (dev) => FS.devices[dev],
      getMounts(mount) {
        var mounts = []
        var check = [mount]
        while (check.length) {
          var m = check.pop()
          mounts.push(m)
          check.push.apply(check, m.mounts)
        }
        return mounts
      },
      syncfs(populate, callback) {
        if (typeof populate == 'function') {
          callback = populate
          populate = false
        }
        FS.syncFSRequests++
        if (FS.syncFSRequests > 1) {
          err(
            `warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`
          )
        }
        var mounts = FS.getMounts(FS.root.mount)
        var completed = 0
        function doCallback(errCode) {
          FS.syncFSRequests--
          return callback(errCode)
        }
        function done(errCode) {
          if (errCode) {
            if (!done.errored) {
              done.errored = true
              return doCallback(errCode)
            }
            return
          }
          if (++completed >= mounts.length) {
            doCallback(null)
          }
        }
        mounts.forEach((mount) => {
          if (!mount.type.syncfs) {
            return done(null)
          }
          mount.type.syncfs(mount, populate, done)
        })
      },
      mount(type, opts, mountpoint) {
        var root = mountpoint === '/'
        var pseudo = !mountpoint
        var node
        if (root && FS.root) {
          throw new FS.ErrnoError(10)
        } else if (!root && !pseudo) {
          var lookup = FS.lookupPath(mountpoint, { follow_mount: false })
          mountpoint = lookup.path
          node = lookup.node
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10)
          }
          if (!FS.isDir(node.mode)) {
            throw new FS.ErrnoError(54)
          }
        }
        var mount = { type: type, opts: opts, mountpoint: mountpoint, mounts: [] }
        var mountRoot = type.mount(mount)
        mountRoot.mount = mount
        mount.root = mountRoot
        if (root) {
          FS.root = mountRoot
        } else if (node) {
          node.mounted = mount
          if (node.mount) {
            node.mount.mounts.push(mount)
          }
        }
        return mountRoot
      },
      unmount(mountpoint) {
        var lookup = FS.lookupPath(mountpoint, { follow_mount: false })
        if (!FS.isMountpoint(lookup.node)) {
          throw new FS.ErrnoError(28)
        }
        var node = lookup.node
        var mount = node.mounted
        var mounts = FS.getMounts(mount)
        Object.keys(FS.nameTable).forEach((hash) => {
          var current = FS.nameTable[hash]
          while (current) {
            var next = current.name_next
            if (mounts.includes(current.mount)) {
              FS.destroyNode(current)
            }
            current = next
          }
        })
        node.mounted = null
        var idx = node.mount.mounts.indexOf(mount)
        node.mount.mounts.splice(idx, 1)
      },
      lookup(parent, name) {
        return parent.node_ops.lookup(parent, name)
      },
      mknod(path, mode, dev) {
        var lookup = FS.lookupPath(path, { parent: true })
        var parent = lookup.node
        var name = PATH.basename(path)
        if (!name || name === '.' || name === '..') {
          throw new FS.ErrnoError(28)
        }
        var errCode = FS.mayCreate(parent, name)
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        if (!parent.node_ops.mknod) {
          throw new FS.ErrnoError(63)
        }
        return parent.node_ops.mknod(parent, name, mode, dev)
      },
      create(path, mode) {
        mode = mode !== undefined ? mode : 438
        mode &= 4095
        mode |= 32768
        return FS.mknod(path, mode, 0)
      },
      mkdir(path, mode) {
        mode = mode !== undefined ? mode : 511
        mode &= 511 | 512
        mode |= 16384
        return FS.mknod(path, mode, 0)
      },
      mkdirTree(path, mode) {
        var dirs = path.split('/')
        var d = ''
        for (var i = 0; i < dirs.length; ++i) {
          if (!dirs[i]) continue
          d += '/' + dirs[i]
          try {
            FS.mkdir(d, mode)
          } catch (e) {
            if (e.errno != 20) throw e
          }
        }
      },
      mkdev(path, mode, dev) {
        if (typeof dev == 'undefined') {
          dev = mode
          mode = 438
        }
        mode |= 8192
        return FS.mknod(path, mode, dev)
      },
      symlink(oldpath, newpath) {
        if (!PATH_FS.resolve(oldpath)) {
          throw new FS.ErrnoError(44)
        }
        var lookup = FS.lookupPath(newpath, { parent: true })
        var parent = lookup.node
        if (!parent) {
          throw new FS.ErrnoError(44)
        }
        var newname = PATH.basename(newpath)
        var errCode = FS.mayCreate(parent, newname)
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        if (!parent.node_ops.symlink) {
          throw new FS.ErrnoError(63)
        }
        return parent.node_ops.symlink(parent, newname, oldpath)
      },
      rename(old_path, new_path) {
        var old_dirname = PATH.dirname(old_path)
        var new_dirname = PATH.dirname(new_path)
        var old_name = PATH.basename(old_path)
        var new_name = PATH.basename(new_path)
        var lookup, old_dir, new_dir
        lookup = FS.lookupPath(old_path, { parent: true })
        old_dir = lookup.node
        lookup = FS.lookupPath(new_path, { parent: true })
        new_dir = lookup.node
        if (!old_dir || !new_dir) throw new FS.ErrnoError(44)
        if (old_dir.mount !== new_dir.mount) {
          throw new FS.ErrnoError(75)
        }
        var old_node = FS.lookupNode(old_dir, old_name)
        var relative = PATH_FS.relative(old_path, new_dirname)
        if (relative.charAt(0) !== '.') {
          throw new FS.ErrnoError(28)
        }
        relative = PATH_FS.relative(new_path, old_dirname)
        if (relative.charAt(0) !== '.') {
          throw new FS.ErrnoError(55)
        }
        var new_node
        try {
          new_node = FS.lookupNode(new_dir, new_name)
        } catch (e) {}
        if (old_node === new_node) {
          return
        }
        var isdir = FS.isDir(old_node.mode)
        var errCode = FS.mayDelete(old_dir, old_name, isdir)
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        errCode = new_node
          ? FS.mayDelete(new_dir, new_name, isdir)
          : FS.mayCreate(new_dir, new_name)
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        if (!old_dir.node_ops.rename) {
          throw new FS.ErrnoError(63)
        }
        if (FS.isMountpoint(old_node) || (new_node && FS.isMountpoint(new_node))) {
          throw new FS.ErrnoError(10)
        }
        if (new_dir !== old_dir) {
          errCode = FS.nodePermissions(old_dir, 'w')
          if (errCode) {
            throw new FS.ErrnoError(errCode)
          }
        }
        FS.hashRemoveNode(old_node)
        try {
          old_dir.node_ops.rename(old_node, new_dir, new_name)
        } catch (e) {
          throw e
        } finally {
          FS.hashAddNode(old_node)
        }
      },
      rmdir(path) {
        var lookup = FS.lookupPath(path, { parent: true })
        var parent = lookup.node
        var name = PATH.basename(path)
        var node = FS.lookupNode(parent, name)
        var errCode = FS.mayDelete(parent, name, true)
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        if (!parent.node_ops.rmdir) {
          throw new FS.ErrnoError(63)
        }
        if (FS.isMountpoint(node)) {
          throw new FS.ErrnoError(10)
        }
        parent.node_ops.rmdir(parent, name)
        FS.destroyNode(node)
      },
      readdir(path) {
        var lookup = FS.lookupPath(path, { follow: true })
        var node = lookup.node
        if (!node.node_ops.readdir) {
          throw new FS.ErrnoError(54)
        }
        return node.node_ops.readdir(node)
      },
      unlink(path) {
        var lookup = FS.lookupPath(path, { parent: true })
        var parent = lookup.node
        if (!parent) {
          throw new FS.ErrnoError(44)
        }
        var name = PATH.basename(path)
        var node = FS.lookupNode(parent, name)
        var errCode = FS.mayDelete(parent, name, false)
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        if (!parent.node_ops.unlink) {
          throw new FS.ErrnoError(63)
        }
        if (FS.isMountpoint(node)) {
          throw new FS.ErrnoError(10)
        }
        parent.node_ops.unlink(parent, name)
        FS.destroyNode(node)
      },
      readlink(path) {
        var lookup = FS.lookupPath(path)
        var link = lookup.node
        if (!link) {
          throw new FS.ErrnoError(44)
        }
        if (!link.node_ops.readlink) {
          throw new FS.ErrnoError(28)
        }
        return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link))
      },
      stat(path, dontFollow) {
        var lookup = FS.lookupPath(path, { follow: !dontFollow })
        var node = lookup.node
        if (!node) {
          throw new FS.ErrnoError(44)
        }
        if (!node.node_ops.getattr) {
          throw new FS.ErrnoError(63)
        }
        return node.node_ops.getattr(node)
      },
      lstat(path) {
        return FS.stat(path, true)
      },
      chmod(path, mode, dontFollow) {
        var node
        if (typeof path == 'string') {
          var lookup = FS.lookupPath(path, { follow: !dontFollow })
          node = lookup.node
        } else {
          node = path
        }
        if (!node.node_ops.setattr) {
          throw new FS.ErrnoError(63)
        }
        node.node_ops.setattr(node, {
          mode: (mode & 4095) | (node.mode & ~4095),
          timestamp: Date.now()
        })
      },
      lchmod(path, mode) {
        FS.chmod(path, mode, true)
      },
      fchmod(fd, mode) {
        var stream = FS.getStreamChecked(fd)
        FS.chmod(stream.node, mode)
      },
      chown(path, uid, gid, dontFollow) {
        var node
        if (typeof path == 'string') {
          var lookup = FS.lookupPath(path, { follow: !dontFollow })
          node = lookup.node
        } else {
          node = path
        }
        if (!node.node_ops.setattr) {
          throw new FS.ErrnoError(63)
        }
        node.node_ops.setattr(node, { timestamp: Date.now() })
      },
      lchown(path, uid, gid) {
        FS.chown(path, uid, gid, true)
      },
      fchown(fd, uid, gid) {
        var stream = FS.getStreamChecked(fd)
        FS.chown(stream.node, uid, gid)
      },
      truncate(path, len) {
        if (len < 0) {
          throw new FS.ErrnoError(28)
        }
        var node
        if (typeof path == 'string') {
          var lookup = FS.lookupPath(path, { follow: true })
          node = lookup.node
        } else {
          node = path
        }
        if (!node.node_ops.setattr) {
          throw new FS.ErrnoError(63)
        }
        if (FS.isDir(node.mode)) {
          throw new FS.ErrnoError(31)
        }
        if (!FS.isFile(node.mode)) {
          throw new FS.ErrnoError(28)
        }
        var errCode = FS.nodePermissions(node, 'w')
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        node.node_ops.setattr(node, { size: len, timestamp: Date.now() })
      },
      ftruncate(fd, len) {
        var stream = FS.getStreamChecked(fd)
        if ((stream.flags & 2097155) === 0) {
          throw new FS.ErrnoError(28)
        }
        FS.truncate(stream.node, len)
      },
      utime(path, atime, mtime) {
        var lookup = FS.lookupPath(path, { follow: true })
        var node = lookup.node
        node.node_ops.setattr(node, { timestamp: Math.max(atime, mtime) })
      },
      open(path, flags, mode) {
        if (path === '') {
          throw new FS.ErrnoError(44)
        }
        flags = typeof flags == 'string' ? FS_modeStringToFlags(flags) : flags
        mode = typeof mode == 'undefined' ? 438 : mode
        if (flags & 64) {
          mode = (mode & 4095) | 32768
        } else {
          mode = 0
        }
        var node
        if (typeof path == 'object') {
          node = path
        } else {
          path = PATH.normalize(path)
          try {
            var lookup = FS.lookupPath(path, { follow: !(flags & 131072) })
            node = lookup.node
          } catch (e) {}
        }
        var created = false
        if (flags & 64) {
          if (node) {
            if (flags & 128) {
              throw new FS.ErrnoError(20)
            }
          } else {
            node = FS.mknod(path, mode, 0)
            created = true
          }
        }
        if (!node) {
          throw new FS.ErrnoError(44)
        }
        if (FS.isChrdev(node.mode)) {
          flags &= ~512
        }
        if (flags & 65536 && !FS.isDir(node.mode)) {
          throw new FS.ErrnoError(54)
        }
        if (!created) {
          var errCode = FS.mayOpen(node, flags)
          if (errCode) {
            throw new FS.ErrnoError(errCode)
          }
        }
        if (flags & 512 && !created) {
          FS.truncate(node, 0)
        }
        flags &= ~(128 | 512 | 131072)
        var stream = FS.createStream({
          node: node,
          path: FS.getPath(node),
          flags: flags,
          seekable: true,
          position: 0,
          stream_ops: node.stream_ops,
          ungotten: [],
          error: false
        })
        if (stream.stream_ops.open) {
          stream.stream_ops.open(stream)
        }
        if (Module['logReadFiles'] && !(flags & 1)) {
          if (!FS.readFiles) FS.readFiles = {}
          if (!(path in FS.readFiles)) {
            FS.readFiles[path] = 1
          }
        }
        return stream
      },
      close(stream) {
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8)
        }
        if (stream.getdents) stream.getdents = null
        try {
          if (stream.stream_ops.close) {
            stream.stream_ops.close(stream)
          }
        } catch (e) {
          throw e
        } finally {
          FS.closeStream(stream.fd)
        }
        stream.fd = null
      },
      isClosed(stream) {
        return stream.fd === null
      },
      llseek(stream, offset, whence) {
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8)
        }
        if (!stream.seekable || !stream.stream_ops.llseek) {
          throw new FS.ErrnoError(70)
        }
        if (whence != 0 && whence != 1 && whence != 2) {
          throw new FS.ErrnoError(28)
        }
        stream.position = stream.stream_ops.llseek(stream, offset, whence)
        stream.ungotten = []
        return stream.position
      },
      read(stream, buffer, offset, length, position) {
        if (length < 0 || position < 0) {
          throw new FS.ErrnoError(28)
        }
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8)
        }
        if ((stream.flags & 2097155) === 1) {
          throw new FS.ErrnoError(8)
        }
        if (FS.isDir(stream.node.mode)) {
          throw new FS.ErrnoError(31)
        }
        if (!stream.stream_ops.read) {
          throw new FS.ErrnoError(28)
        }
        var seeking = typeof position != 'undefined'
        if (!seeking) {
          position = stream.position
        } else if (!stream.seekable) {
          throw new FS.ErrnoError(70)
        }
        var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position)
        if (!seeking) stream.position += bytesRead
        return bytesRead
      },
      write(stream, buffer, offset, length, position, canOwn) {
        if (length < 0 || position < 0) {
          throw new FS.ErrnoError(28)
        }
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8)
        }
        if ((stream.flags & 2097155) === 0) {
          throw new FS.ErrnoError(8)
        }
        if (FS.isDir(stream.node.mode)) {
          throw new FS.ErrnoError(31)
        }
        if (!stream.stream_ops.write) {
          throw new FS.ErrnoError(28)
        }
        if (stream.seekable && stream.flags & 1024) {
          FS.llseek(stream, 0, 2)
        }
        var seeking = typeof position != 'undefined'
        if (!seeking) {
          position = stream.position
        } else if (!stream.seekable) {
          throw new FS.ErrnoError(70)
        }
        var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn)
        if (!seeking) stream.position += bytesWritten
        return bytesWritten
      },
      allocate(stream, offset, length) {
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8)
        }
        if (offset < 0 || length <= 0) {
          throw new FS.ErrnoError(28)
        }
        if ((stream.flags & 2097155) === 0) {
          throw new FS.ErrnoError(8)
        }
        if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
          throw new FS.ErrnoError(43)
        }
        if (!stream.stream_ops.allocate) {
          throw new FS.ErrnoError(138)
        }
        stream.stream_ops.allocate(stream, offset, length)
      },
      mmap(stream, length, position, prot, flags) {
        if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
          throw new FS.ErrnoError(2)
        }
        if ((stream.flags & 2097155) === 1) {
          throw new FS.ErrnoError(2)
        }
        if (!stream.stream_ops.mmap) {
          throw new FS.ErrnoError(43)
        }
        return stream.stream_ops.mmap(stream, length, position, prot, flags)
      },
      msync(stream, buffer, offset, length, mmapFlags) {
        if (!stream.stream_ops.msync) {
          return 0
        }
        return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags)
      },
      munmap: (stream) => 0,
      ioctl(stream, cmd, arg) {
        if (!stream.stream_ops.ioctl) {
          throw new FS.ErrnoError(59)
        }
        return stream.stream_ops.ioctl(stream, cmd, arg)
      },
      readFile(path, opts = {}) {
        opts.flags = opts.flags || 0
        opts.encoding = opts.encoding || 'binary'
        if (opts.encoding !== 'utf8' && opts.encoding !== 'binary') {
          throw new Error(`Invalid encoding type "${opts.encoding}"`)
        }
        var ret
        var stream = FS.open(path, opts.flags)
        var stat = FS.stat(path)
        var length = stat.size
        var buf = new Uint8Array(length)
        FS.read(stream, buf, 0, length, 0)
        if (opts.encoding === 'utf8') {
          ret = UTF8ArrayToString(buf, 0)
        } else if (opts.encoding === 'binary') {
          ret = buf
        }
        FS.close(stream)
        return ret
      },
      writeFile(path, data, opts = {}) {
        opts.flags = opts.flags || 577
        var stream = FS.open(path, opts.flags, opts.mode)
        if (typeof data == 'string') {
          var buf = new Uint8Array(lengthBytesUTF8(data) + 1)
          var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length)
          FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn)
        } else if (ArrayBuffer.isView(data)) {
          FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn)
        } else {
          throw new Error('Unsupported data type')
        }
        FS.close(stream)
      },
      cwd: () => FS.currentPath,
      chdir(path) {
        var lookup = FS.lookupPath(path, { follow: true })
        if (lookup.node === null) {
          throw new FS.ErrnoError(44)
        }
        if (!FS.isDir(lookup.node.mode)) {
          throw new FS.ErrnoError(54)
        }
        var errCode = FS.nodePermissions(lookup.node, 'x')
        if (errCode) {
          throw new FS.ErrnoError(errCode)
        }
        FS.currentPath = lookup.path
      },
      createDefaultDirectories() {
        FS.mkdir('/tmp')
        FS.mkdir('/home')
        FS.mkdir('/home/web_user')
      },
      createDefaultDevices() {
        FS.mkdir('/dev')
        FS.registerDevice(FS.makedev(1, 3), {
          read: () => 0,
          write: (stream, buffer, offset, length, pos) => length
        })
        FS.mkdev('/dev/null', FS.makedev(1, 3))
        TTY.register(FS.makedev(5, 0), TTY.default_tty_ops)
        TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops)
        FS.mkdev('/dev/tty', FS.makedev(5, 0))
        FS.mkdev('/dev/tty1', FS.makedev(6, 0))
        var randomBuffer = new Uint8Array(1024),
          randomLeft = 0
        var randomByte = () => {
          if (randomLeft === 0) {
            randomLeft = randomFill(randomBuffer).byteLength
          }
          return randomBuffer[--randomLeft]
        }
        FS.createDevice('/dev', 'random', randomByte)
        FS.createDevice('/dev', 'urandom', randomByte)
        FS.mkdir('/dev/shm')
        FS.mkdir('/dev/shm/tmp')
      },
      createSpecialDirectories() {
        FS.mkdir('/proc')
        var proc_self = FS.mkdir('/proc/self')
        FS.mkdir('/proc/self/fd')
        FS.mount(
          {
            mount() {
              var node = FS.createNode(proc_self, 'fd', 16384 | 511, 73)
              node.node_ops = {
                lookup(parent, name) {
                  var fd = +name
                  var stream = FS.getStreamChecked(fd)
                  var ret = {
                    parent: null,
                    mount: { mountpoint: 'fake' },
                    node_ops: { readlink: () => stream.path }
                  }
                  ret.parent = ret
                  return ret
                }
              }
              return node
            }
          },
          {},
          '/proc/self/fd'
        )
      },
      createStandardStreams() {
        if (Module['stdin']) {
          FS.createDevice('/dev', 'stdin', Module['stdin'])
        } else {
          FS.symlink('/dev/tty', '/dev/stdin')
        }
        if (Module['stdout']) {
          FS.createDevice('/dev', 'stdout', null, Module['stdout'])
        } else {
          FS.symlink('/dev/tty', '/dev/stdout')
        }
        if (Module['stderr']) {
          FS.createDevice('/dev', 'stderr', null, Module['stderr'])
        } else {
          FS.symlink('/dev/tty1', '/dev/stderr')
        }
        var stdin = FS.open('/dev/stdin', 0)
        var stdout = FS.open('/dev/stdout', 1)
        var stderr = FS.open('/dev/stderr', 1)
      },
      ensureErrnoError() {
        if (FS.ErrnoError) return
        FS.ErrnoError = function ErrnoError(errno, node) {
          this.name = 'ErrnoError'
          this.node = node
          this.setErrno = function (errno) {
            this.errno = errno
          }
          this.setErrno(errno)
          this.message = 'FS error'
        }
        FS.ErrnoError.prototype = new Error()
        FS.ErrnoError.prototype.constructor = FS.ErrnoError
        ;[44].forEach((code) => {
          FS.genericErrors[code] = new FS.ErrnoError(code)
          FS.genericErrors[code].stack = '<generic error, no stack>'
        })
      },
      staticInit() {
        FS.ensureErrnoError()
        FS.nameTable = new Array(4096)
        FS.mount(MEMFS, {}, '/')
        FS.createDefaultDirectories()
        FS.createDefaultDevices()
        FS.createSpecialDirectories()
        FS.filesystems = { MEMFS: MEMFS }
      },
      init(input, output, error) {
        FS.init.initialized = true
        FS.ensureErrnoError()
        Module['stdin'] = input || Module['stdin']
        Module['stdout'] = output || Module['stdout']
        Module['stderr'] = error || Module['stderr']
        FS.createStandardStreams()
      },
      quit() {
        FS.init.initialized = false
        for (var i = 0; i < FS.streams.length; i++) {
          var stream = FS.streams[i]
          if (!stream) {
            continue
          }
          FS.close(stream)
        }
      },
      findObject(path, dontResolveLastLink) {
        var ret = FS.analyzePath(path, dontResolveLastLink)
        if (!ret.exists) {
          return null
        }
        return ret.object
      },
      analyzePath(path, dontResolveLastLink) {
        try {
          var lookup = FS.lookupPath(path, { follow: !dontResolveLastLink })
          path = lookup.path
        } catch (e) {}
        var ret = {
          isRoot: false,
          exists: false,
          error: 0,
          name: null,
          path: null,
          object: null,
          parentExists: false,
          parentPath: null,
          parentObject: null
        }
        try {
          var lookup = FS.lookupPath(path, { parent: true })
          ret.parentExists = true
          ret.parentPath = lookup.path
          ret.parentObject = lookup.node
          ret.name = PATH.basename(path)
          lookup = FS.lookupPath(path, { follow: !dontResolveLastLink })
          ret.exists = true
          ret.path = lookup.path
          ret.object = lookup.node
          ret.name = lookup.node.name
          ret.isRoot = lookup.path === '/'
        } catch (e) {
          ret.error = e.errno
        }
        return ret
      },
      createPath(parent, path, canRead, canWrite) {
        parent = typeof parent == 'string' ? parent : FS.getPath(parent)
        var parts = path.split('/').reverse()
        while (parts.length) {
          var part = parts.pop()
          if (!part) continue
          var current = PATH.join2(parent, part)
          try {
            FS.mkdir(current)
          } catch (e) {}
          parent = current
        }
        return current
      },
      createFile(parent, name, properties, canRead, canWrite) {
        var path = PATH.join2(typeof parent == 'string' ? parent : FS.getPath(parent), name)
        var mode = FS_getMode(canRead, canWrite)
        return FS.create(path, mode)
      },
      createDataFile(parent, name, data, canRead, canWrite, canOwn) {
        var path = name
        if (parent) {
          parent = typeof parent == 'string' ? parent : FS.getPath(parent)
          path = name ? PATH.join2(parent, name) : parent
        }
        var mode = FS_getMode(canRead, canWrite)
        var node = FS.create(path, mode)
        if (data) {
          if (typeof data == 'string') {
            var arr = new Array(data.length)
            for (var i = 0, len = data.length; i < len; ++i) arr[i] = data.charCodeAt(i)
            data = arr
          }
          FS.chmod(node, mode | 146)
          var stream = FS.open(node, 577)
          FS.write(stream, data, 0, data.length, 0, canOwn)
          FS.close(stream)
          FS.chmod(node, mode)
        }
        return node
      },
      createDevice(parent, name, input, output) {
        var path = PATH.join2(typeof parent == 'string' ? parent : FS.getPath(parent), name)
        var mode = FS_getMode(!!input, !!output)
        if (!FS.createDevice.major) FS.createDevice.major = 64
        var dev = FS.makedev(FS.createDevice.major++, 0)
        FS.registerDevice(dev, {
          open(stream) {
            stream.seekable = false
          },
          close(stream) {
            if (output && output.buffer && output.buffer.length) {
              output(10)
            }
          },
          read(stream, buffer, offset, length, pos) {
            var bytesRead = 0
            for (var i = 0; i < length; i++) {
              var result
              try {
                result = input()
              } catch (e) {
                throw new FS.ErrnoError(29)
              }
              if (result === undefined && bytesRead === 0) {
                throw new FS.ErrnoError(6)
              }
              if (result === null || result === undefined) break
              bytesRead++
              buffer[offset + i] = result
            }
            if (bytesRead) {
              stream.node.timestamp = Date.now()
            }
            return bytesRead
          },
          write(stream, buffer, offset, length, pos) {
            for (var i = 0; i < length; i++) {
              try {
                output(buffer[offset + i])
              } catch (e) {
                throw new FS.ErrnoError(29)
              }
            }
            if (length) {
              stream.node.timestamp = Date.now()
            }
            return i
          }
        })
        return FS.mkdev(path, mode, dev)
      },
      forceLoadFile(obj) {
        if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true
        if (typeof XMLHttpRequest != 'undefined') {
          throw new Error(
            'Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.'
          )
        } else if (read_) {
          try {
            obj.contents = intArrayFromString(read_(obj.url), true)
            obj.usedBytes = obj.contents.length
          } catch (e) {
            throw new FS.ErrnoError(29)
          }
        } else {
          throw new Error('Cannot load without read() or XMLHttpRequest.')
        }
      },
      createLazyFile(parent, name, url, canRead, canWrite) {
        function LazyUint8Array() {
          this.lengthKnown = false
          this.chunks = []
        }
        LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
          if (idx > this.length - 1 || idx < 0) {
            return undefined
          }
          var chunkOffset = idx % this.chunkSize
          var chunkNum = (idx / this.chunkSize) | 0
          return this.getter(chunkNum)[chunkOffset]
        }
        LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
          this.getter = getter
        }
        LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
          var xhr = new XMLHttpRequest()
          xhr.open('HEAD', url, false)
          xhr.send(null)
          if (!((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304))
            throw new Error("Couldn't load " + url + '. Status: ' + xhr.status)
          var datalength = Number(xhr.getResponseHeader('Content-length'))
          var header
          var hasByteServing =
            (header = xhr.getResponseHeader('Accept-Ranges')) && header === 'bytes'
          var usesGzip = (header = xhr.getResponseHeader('Content-Encoding')) && header === 'gzip'
          var chunkSize = 1024 * 1024
          if (!hasByteServing) chunkSize = datalength
          var doXHR = (from, to) => {
            if (from > to)
              throw new Error('invalid range (' + from + ', ' + to + ') or no bytes requested!')
            if (to > datalength - 1)
              throw new Error('only ' + datalength + ' bytes available! programmer error!')
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, false)
            if (datalength !== chunkSize) xhr.setRequestHeader('Range', 'bytes=' + from + '-' + to)
            xhr.responseType = 'arraybuffer'
            if (xhr.overrideMimeType) {
              xhr.overrideMimeType('text/plain; charset=x-user-defined')
            }
            xhr.send(null)
            if (!((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304))
              throw new Error("Couldn't load " + url + '. Status: ' + xhr.status)
            if (xhr.response !== undefined) {
              return new Uint8Array(xhr.response || [])
            }
            return intArrayFromString(xhr.responseText || '', true)
          }
          var lazyArray = this
          lazyArray.setDataGetter((chunkNum) => {
            var start = chunkNum * chunkSize
            var end = (chunkNum + 1) * chunkSize - 1
            end = Math.min(end, datalength - 1)
            if (typeof lazyArray.chunks[chunkNum] == 'undefined') {
              lazyArray.chunks[chunkNum] = doXHR(start, end)
            }
            if (typeof lazyArray.chunks[chunkNum] == 'undefined') throw new Error('doXHR failed!')
            return lazyArray.chunks[chunkNum]
          })
          if (usesGzip || !datalength) {
            chunkSize = datalength = 1
            datalength = this.getter(0).length
            chunkSize = datalength
            out('LazyFiles on gzip forces download of the whole file when length is accessed')
          }
          this._length = datalength
          this._chunkSize = chunkSize
          this.lengthKnown = true
        }
        if (typeof XMLHttpRequest != 'undefined') {
          if (!ENVIRONMENT_IS_WORKER)
            throw 'Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc'
          var lazyArray = new LazyUint8Array()
          Object.defineProperties(lazyArray, {
            length: {
              get: function () {
                if (!this.lengthKnown) {
                  this.cacheLength()
                }
                return this._length
              }
            },
            chunkSize: {
              get: function () {
                if (!this.lengthKnown) {
                  this.cacheLength()
                }
                return this._chunkSize
              }
            }
          })
          var properties = { isDevice: false, contents: lazyArray }
        } else {
          var properties = { isDevice: false, url: url }
        }
        var node = FS.createFile(parent, name, properties, canRead, canWrite)
        if (properties.contents) {
          node.contents = properties.contents
        } else if (properties.url) {
          node.contents = null
          node.url = properties.url
        }
        Object.defineProperties(node, {
          usedBytes: {
            get: function () {
              return this.contents.length
            }
          }
        })
        var stream_ops = {}
        var keys = Object.keys(node.stream_ops)
        keys.forEach((key) => {
          var fn = node.stream_ops[key]
          stream_ops[key] = function forceLoadLazyFile() {
            FS.forceLoadFile(node)
            return fn.apply(null, arguments)
          }
        })
        function writeChunks(stream, buffer, offset, length, position) {
          var contents = stream.node.contents
          if (position >= contents.length) return 0
          var size = Math.min(contents.length - position, length)
          if (contents.slice) {
            for (var i = 0; i < size; i++) {
              buffer[offset + i] = contents[position + i]
            }
          } else {
            for (var i = 0; i < size; i++) {
              buffer[offset + i] = contents.get(position + i)
            }
          }
          return size
        }
        stream_ops.read = (stream, buffer, offset, length, position) => {
          FS.forceLoadFile(node)
          return writeChunks(stream, buffer, offset, length, position)
        }
        stream_ops.mmap = (stream, length, position, prot, flags) => {
          FS.forceLoadFile(node)
          var ptr = mmapAlloc(length)
          if (!ptr) {
            throw new FS.ErrnoError(48)
          }
          writeChunks(stream, GROWABLE_HEAP_I8(), ptr, length, position)
          return { ptr: ptr, allocated: true }
        }
        node.stream_ops = stream_ops
        return node
      }
    }
    var UTF8ToString = (ptr, maxBytesToRead) =>
      ptr ? UTF8ArrayToString(GROWABLE_HEAP_U8(), ptr, maxBytesToRead) : ''
    var SYSCALLS = {
      DEFAULT_POLLMASK: 5,
      calculateAt(dirfd, path, allowEmpty) {
        if (PATH.isAbs(path)) {
          return path
        }
        var dir
        if (dirfd === -100) {
          dir = FS.cwd()
        } else {
          var dirstream = SYSCALLS.getStreamFromFD(dirfd)
          dir = dirstream.path
        }
        if (path.length == 0) {
          if (!allowEmpty) {
            throw new FS.ErrnoError(44)
          }
          return dir
        }
        return PATH.join2(dir, path)
      },
      doStat(func, path, buf) {
        try {
          var stat = func(path)
        } catch (e) {
          if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
            return -54
          }
          throw e
        }
        GROWABLE_HEAP_I32()[buf >> 2] = stat.dev
        GROWABLE_HEAP_I32()[(buf + 4) >> 2] = stat.mode
        GROWABLE_HEAP_U32()[(buf + 8) >> 2] = stat.nlink
        GROWABLE_HEAP_I32()[(buf + 12) >> 2] = stat.uid
        GROWABLE_HEAP_I32()[(buf + 16) >> 2] = stat.gid
        GROWABLE_HEAP_I32()[(buf + 20) >> 2] = stat.rdev
        ;((tempI64 = [
          stat.size >>> 0,
          ((tempDouble = stat.size),
          +Math.abs(tempDouble) >= 1
            ? tempDouble > 0
              ? +Math.floor(tempDouble / 4294967296) >>> 0
              : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
            : 0)
        ]),
          (GROWABLE_HEAP_I32()[(buf + 24) >> 2] = tempI64[0]),
          (GROWABLE_HEAP_I32()[(buf + 28) >> 2] = tempI64[1]))
        GROWABLE_HEAP_I32()[(buf + 32) >> 2] = 4096
        GROWABLE_HEAP_I32()[(buf + 36) >> 2] = stat.blocks
        var atime = stat.atime.getTime()
        var mtime = stat.mtime.getTime()
        var ctime = stat.ctime.getTime()
        ;((tempI64 = [
          Math.floor(atime / 1e3) >>> 0,
          ((tempDouble = Math.floor(atime / 1e3)),
          +Math.abs(tempDouble) >= 1
            ? tempDouble > 0
              ? +Math.floor(tempDouble / 4294967296) >>> 0
              : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
            : 0)
        ]),
          (GROWABLE_HEAP_I32()[(buf + 40) >> 2] = tempI64[0]),
          (GROWABLE_HEAP_I32()[(buf + 44) >> 2] = tempI64[1]))
        GROWABLE_HEAP_U32()[(buf + 48) >> 2] = (atime % 1e3) * 1e3
        ;((tempI64 = [
          Math.floor(mtime / 1e3) >>> 0,
          ((tempDouble = Math.floor(mtime / 1e3)),
          +Math.abs(tempDouble) >= 1
            ? tempDouble > 0
              ? +Math.floor(tempDouble / 4294967296) >>> 0
              : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
            : 0)
        ]),
          (GROWABLE_HEAP_I32()[(buf + 56) >> 2] = tempI64[0]),
          (GROWABLE_HEAP_I32()[(buf + 60) >> 2] = tempI64[1]))
        GROWABLE_HEAP_U32()[(buf + 64) >> 2] = (mtime % 1e3) * 1e3
        ;((tempI64 = [
          Math.floor(ctime / 1e3) >>> 0,
          ((tempDouble = Math.floor(ctime / 1e3)),
          +Math.abs(tempDouble) >= 1
            ? tempDouble > 0
              ? +Math.floor(tempDouble / 4294967296) >>> 0
              : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
            : 0)
        ]),
          (GROWABLE_HEAP_I32()[(buf + 72) >> 2] = tempI64[0]),
          (GROWABLE_HEAP_I32()[(buf + 76) >> 2] = tempI64[1]))
        GROWABLE_HEAP_U32()[(buf + 80) >> 2] = (ctime % 1e3) * 1e3
        ;((tempI64 = [
          stat.ino >>> 0,
          ((tempDouble = stat.ino),
          +Math.abs(tempDouble) >= 1
            ? tempDouble > 0
              ? +Math.floor(tempDouble / 4294967296) >>> 0
              : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
            : 0)
        ]),
          (GROWABLE_HEAP_I32()[(buf + 88) >> 2] = tempI64[0]),
          (GROWABLE_HEAP_I32()[(buf + 92) >> 2] = tempI64[1]))
        return 0
      },
      doMsync(addr, stream, len, flags, offset) {
        if (!FS.isFile(stream.node.mode)) {
          throw new FS.ErrnoError(43)
        }
        if (flags & 2) {
          return 0
        }
        var buffer = GROWABLE_HEAP_U8().slice(addr, addr + len)
        FS.msync(stream, buffer, offset, len, flags)
      },
      varargs: undefined,
      get() {
        var ret = GROWABLE_HEAP_I32()[+SYSCALLS.varargs >> 2]
        SYSCALLS.varargs += 4
        return ret
      },
      getp() {
        return SYSCALLS.get()
      },
      getStr(ptr) {
        var ret = UTF8ToString(ptr)
        return ret
      },
      getStreamFromFD(fd) {
        var stream = FS.getStreamChecked(fd)
        return stream
      }
    }
    function _proc_exit(code) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(0, 1, code)
      EXITSTATUS = code
      if (!keepRuntimeAlive()) {
        PThread.terminateAllThreads()
        if (Module['onExit']) Module['onExit'](code)
        ABORT = true
      }
      quit_(code, new ExitStatus(code))
    }
    var exitJS = (status, implicit) => {
      EXITSTATUS = status
      if (ENVIRONMENT_IS_PTHREAD) {
        exitOnMainThread(status)
        throw 'unwind'
      }
      _proc_exit(status)
    }
    var _exit = exitJS
    var handleException = (e) => {
      if (e instanceof ExitStatus || e == 'unwind') {
        return EXITSTATUS
      }
      quit_(1, e)
    }
    var PThread = {
      unusedWorkers: [],
      runningWorkers: [],
      tlsInitFunctions: [],
      pthreads: {},
      init() {
        if (ENVIRONMENT_IS_PTHREAD) {
          PThread.initWorker()
        } else {
          PThread.initMainThread()
        }
      },
      initMainThread() {
        addOnPreRun(() => {
          addRunDependency('loading-workers')
          PThread.loadWasmModuleToAllWorkers(() => removeRunDependency('loading-workers'))
        })
      },
      initWorker() {
        noExitRuntime = false
      },
      setExitStatus: (status) => {
        EXITSTATUS = status
      },
      terminateAllThreads__deps: ['$terminateWorker'],
      terminateAllThreads: () => {
        for (var worker of PThread.runningWorkers) {
          terminateWorker(worker)
        }
        for (var worker of PThread.unusedWorkers) {
          terminateWorker(worker)
        }
        PThread.unusedWorkers = []
        PThread.runningWorkers = []
        PThread.pthreads = []
      },
      returnWorkerToPool: (worker) => {
        var pthread_ptr = worker.pthread_ptr
        delete PThread.pthreads[pthread_ptr]
        PThread.unusedWorkers.push(worker)
        PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1)
        worker.pthread_ptr = 0
        __emscripten_thread_free_data(pthread_ptr)
      },
      receiveObjectTransfer(data) {},
      threadInitTLS() {
        PThread.tlsInitFunctions.forEach((f) => f())
      },
      loadWasmModuleToWorker: (worker) =>
        new Promise((onFinishedLoading) => {
          worker.onmessage = (e) => {
            var d = e['data']
            var cmd = d['cmd']
            if (d['targetThread'] && d['targetThread'] != _pthread_self()) {
              var targetWorker = PThread.pthreads[d['targetThread']]
              if (targetWorker) {
                targetWorker.postMessage(d, d['transferList'])
              } else {
                err(
                  `Internal error! Worker sent a message "${cmd}" to target pthread ${d['targetThread']}, but that thread no longer exists!`
                )
              }
              return
            }
            if (cmd === 'checkMailbox') {
              checkMailbox()
            } else if (cmd === 'spawnThread') {
              spawnThread(d)
            } else if (cmd === 'cleanupThread') {
              cleanupThread(d['thread'])
            } else if (cmd === 'killThread') {
              killThread(d['thread'])
            } else if (cmd === 'cancelThread') {
              cancelThread(d['thread'])
            } else if (cmd === 'loaded') {
              worker.loaded = true
              onFinishedLoading(worker)
            } else if (cmd === 'alert') {
              alert(`Thread ${d['threadId']}: ${d['text']}`)
            } else if (d.target === 'setimmediate') {
              worker.postMessage(d)
            } else if (cmd === 'callHandler') {
              Module[d['handler']](...d['args'])
            } else if (cmd) {
              err(`worker sent an unknown command ${cmd}`)
            }
          }
          worker.onerror = (e) => {
            var message = 'worker sent an error!'
            err(`${message} ${e.filename}:${e.lineno}: ${e.message}`)
            throw e
          }
          var handlers = []
          var knownHandlers = ['onExit', 'onAbort', 'print', 'printErr']
          for (var handler of knownHandlers) {
            if (Module.hasOwnProperty(handler)) {
              handlers.push(handler)
            }
          }
          worker.postMessage({
            cmd: 'load',
            handlers: handlers,
            urlOrBlob: Module['mainScriptUrlOrBlob'],
            wasmMemory: wasmMemory,
            wasmModule: wasmModule
          })
        }),
      loadWasmModuleToAllWorkers(onMaybeReady) {
        onMaybeReady()
      },
      allocateUnusedWorker() {
        var worker
        if (!Module['locateFile']) {
          worker = new Worker(new URL('libapi.worker.js', import.meta.url), { type: 'module' })
        } else {
          var pthreadMainJs = locateFile('libapi.worker.js')
          worker = new Worker(pthreadMainJs)
        }
        PThread.unusedWorkers.push(worker)
      },
      getNewWorker() {
        if (PThread.unusedWorkers.length == 0) {
          PThread.allocateUnusedWorker()
          PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0])
        }
        return PThread.unusedWorkers.pop()
      }
    }
    Module['PThread'] = PThread
    var callRuntimeCallbacks = (callbacks) => {
      while (callbacks.length > 0) {
        callbacks.shift()(Module)
      }
    }
    var establishStackSpace = () => {
      var pthread_ptr = _pthread_self()
      var stackHigh = GROWABLE_HEAP_U32()[(pthread_ptr + 52) >> 2]
      var stackSize = GROWABLE_HEAP_U32()[(pthread_ptr + 56) >> 2]
      var stackLow = stackHigh - stackSize
      _emscripten_stack_set_limits(stackHigh, stackLow)
      stackRestore(stackHigh)
    }
    Module['establishStackSpace'] = establishStackSpace
    function exitOnMainThread(returnCode) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(1, 0, returnCode)
      _exit(returnCode)
    }
    var invokeEntryPoint = (ptr, arg) => {
      var result = ((a1) => dynCall_ii.apply(null, [ptr, a1]))(arg)
      function finish(result) {
        if (keepRuntimeAlive()) {
          PThread.setExitStatus(result)
        } else {
          __emscripten_thread_exit(result)
        }
      }
      finish(result)
    }
    Module['invokeEntryPoint'] = invokeEntryPoint
    var noExitRuntime = Module['noExitRuntime'] || true
    var registerTLSInit = (tlsInitFunc) => {
      PThread.tlsInitFunctions.push(tlsInitFunc)
    }
    var ___assert_fail = (condition, filename, line, func) => {
      abort(
        `Assertion failed: ${UTF8ToString(condition)}, at: ` +
          [
            filename ? UTF8ToString(filename) : 'unknown filename',
            line,
            func ? UTF8ToString(func) : 'unknown function'
          ]
      )
    }
    var exceptionCaught = []
    var uncaughtExceptionCount = 0
    var ___cxa_begin_catch = (ptr) => {
      var info = new ExceptionInfo(ptr)
      if (!info.get_caught()) {
        info.set_caught(true)
        uncaughtExceptionCount--
      }
      info.set_rethrown(false)
      exceptionCaught.push(info)
      ___cxa_increment_exception_refcount(info.excPtr)
      return info.get_exception_ptr()
    }
    var exceptionLast = 0
    var ___cxa_end_catch = () => {
      _setThrew(0, 0)
      var info = exceptionCaught.pop()
      ___cxa_decrement_exception_refcount(info.excPtr)
      exceptionLast = 0
    }
    function ExceptionInfo(excPtr) {
      this.excPtr = excPtr
      this.ptr = excPtr - 24
      this.set_type = function (type) {
        GROWABLE_HEAP_U32()[(this.ptr + 4) >> 2] = type
      }
      this.get_type = function () {
        return GROWABLE_HEAP_U32()[(this.ptr + 4) >> 2]
      }
      this.set_destructor = function (destructor) {
        GROWABLE_HEAP_U32()[(this.ptr + 8) >> 2] = destructor
      }
      this.get_destructor = function () {
        return GROWABLE_HEAP_U32()[(this.ptr + 8) >> 2]
      }
      this.set_caught = function (caught) {
        caught = caught ? 1 : 0
        GROWABLE_HEAP_I8()[(this.ptr + 12) >> 0] = caught
      }
      this.get_caught = function () {
        return GROWABLE_HEAP_I8()[(this.ptr + 12) >> 0] != 0
      }
      this.set_rethrown = function (rethrown) {
        rethrown = rethrown ? 1 : 0
        GROWABLE_HEAP_I8()[(this.ptr + 13) >> 0] = rethrown
      }
      this.get_rethrown = function () {
        return GROWABLE_HEAP_I8()[(this.ptr + 13) >> 0] != 0
      }
      this.init = function (type, destructor) {
        this.set_adjusted_ptr(0)
        this.set_type(type)
        this.set_destructor(destructor)
      }
      this.set_adjusted_ptr = function (adjustedPtr) {
        GROWABLE_HEAP_U32()[(this.ptr + 16) >> 2] = adjustedPtr
      }
      this.get_adjusted_ptr = function () {
        return GROWABLE_HEAP_U32()[(this.ptr + 16) >> 2]
      }
      this.get_exception_ptr = function () {
        var isPointer = ___cxa_is_pointer_type(this.get_type())
        if (isPointer) {
          return GROWABLE_HEAP_U32()[this.excPtr >> 2]
        }
        var adjusted = this.get_adjusted_ptr()
        if (adjusted !== 0) return adjusted
        return this.excPtr
      }
    }
    var ___resumeException = (ptr) => {
      if (!exceptionLast) {
        exceptionLast = ptr
      }
      throw exceptionLast
    }
    var findMatchingCatch = (args) => {
      var thrown = exceptionLast
      if (!thrown) {
        setTempRet0(0)
        return 0
      }
      var info = new ExceptionInfo(thrown)
      info.set_adjusted_ptr(thrown)
      var thrownType = info.get_type()
      if (!thrownType) {
        setTempRet0(0)
        return thrown
      }
      for (var arg in args) {
        var caughtType = args[arg]
        if (caughtType === 0 || caughtType === thrownType) {
          break
        }
        var adjusted_ptr_addr = info.ptr + 16
        if (___cxa_can_catch(caughtType, thrownType, adjusted_ptr_addr)) {
          setTempRet0(caughtType)
          return thrown
        }
      }
      setTempRet0(thrownType)
      return thrown
    }
    var ___cxa_find_matching_catch_2 = () => findMatchingCatch([])
    var ___cxa_find_matching_catch_3 = (arg0) => findMatchingCatch([arg0])
    var ___cxa_rethrow = () => {
      var info = exceptionCaught.pop()
      if (!info) {
        abort('no exception to throw')
      }
      var ptr = info.excPtr
      if (!info.get_rethrown()) {
        exceptionCaught.push(info)
        info.set_rethrown(true)
        info.set_caught(false)
        uncaughtExceptionCount++
      }
      exceptionLast = ptr
      throw exceptionLast
    }
    var ___cxa_throw = (ptr, type, destructor) => {
      var info = new ExceptionInfo(ptr)
      info.init(type, destructor)
      exceptionLast = ptr
      uncaughtExceptionCount++
      throw exceptionLast
    }
    var ___cxa_uncaught_exceptions = () => uncaughtExceptionCount
    var ___emscripten_init_main_thread_js = (tb) => {
      __emscripten_thread_init(tb, !ENVIRONMENT_IS_WORKER, 1, !ENVIRONMENT_IS_WEB, 65536, false)
      PThread.threadInitTLS()
    }
    var ___emscripten_thread_cleanup = (thread) => {
      if (!ENVIRONMENT_IS_PTHREAD) cleanupThread(thread)
      else postMessage({ cmd: 'cleanupThread', thread: thread })
    }
    function ___syscall__newselect(nfds, readfds, writefds, exceptfds, timeout) {
      if (ENVIRONMENT_IS_PTHREAD)
        return proxyToMainThread(2, 1, nfds, readfds, writefds, exceptfds, timeout)
      try {
        var total = 0
        var srcReadLow = readfds ? GROWABLE_HEAP_I32()[readfds >> 2] : 0,
          srcReadHigh = readfds ? GROWABLE_HEAP_I32()[(readfds + 4) >> 2] : 0
        var srcWriteLow = writefds ? GROWABLE_HEAP_I32()[writefds >> 2] : 0,
          srcWriteHigh = writefds ? GROWABLE_HEAP_I32()[(writefds + 4) >> 2] : 0
        var srcExceptLow = exceptfds ? GROWABLE_HEAP_I32()[exceptfds >> 2] : 0,
          srcExceptHigh = exceptfds ? GROWABLE_HEAP_I32()[(exceptfds + 4) >> 2] : 0
        var dstReadLow = 0,
          dstReadHigh = 0
        var dstWriteLow = 0,
          dstWriteHigh = 0
        var dstExceptLow = 0,
          dstExceptHigh = 0
        var allLow =
          (readfds ? GROWABLE_HEAP_I32()[readfds >> 2] : 0) |
          (writefds ? GROWABLE_HEAP_I32()[writefds >> 2] : 0) |
          (exceptfds ? GROWABLE_HEAP_I32()[exceptfds >> 2] : 0)
        var allHigh =
          (readfds ? GROWABLE_HEAP_I32()[(readfds + 4) >> 2] : 0) |
          (writefds ? GROWABLE_HEAP_I32()[(writefds + 4) >> 2] : 0) |
          (exceptfds ? GROWABLE_HEAP_I32()[(exceptfds + 4) >> 2] : 0)
        var check = function (fd, low, high, val) {
          return fd < 32 ? low & val : high & val
        }
        for (var fd = 0; fd < nfds; fd++) {
          var mask = 1 << fd % 32
          if (!check(fd, allLow, allHigh, mask)) {
            continue
          }
          var stream = SYSCALLS.getStreamFromFD(fd)
          var flags = SYSCALLS.DEFAULT_POLLMASK
          if (stream.stream_ops.poll) {
            var timeoutInMillis = -1
            if (timeout) {
              var tv_sec = readfds ? GROWABLE_HEAP_I32()[timeout >> 2] : 0,
                tv_usec = readfds ? GROWABLE_HEAP_I32()[(timeout + 8) >> 2] : 0
              timeoutInMillis = (tv_sec + tv_usec / 1e6) * 1e3
            }
            flags = stream.stream_ops.poll(stream, timeoutInMillis)
          }
          if (flags & 1 && check(fd, srcReadLow, srcReadHigh, mask)) {
            fd < 32 ? (dstReadLow = dstReadLow | mask) : (dstReadHigh = dstReadHigh | mask)
            total++
          }
          if (flags & 4 && check(fd, srcWriteLow, srcWriteHigh, mask)) {
            fd < 32 ? (dstWriteLow = dstWriteLow | mask) : (dstWriteHigh = dstWriteHigh | mask)
            total++
          }
          if (flags & 2 && check(fd, srcExceptLow, srcExceptHigh, mask)) {
            fd < 32 ? (dstExceptLow = dstExceptLow | mask) : (dstExceptHigh = dstExceptHigh | mask)
            total++
          }
        }
        if (readfds) {
          GROWABLE_HEAP_I32()[readfds >> 2] = dstReadLow
          GROWABLE_HEAP_I32()[(readfds + 4) >> 2] = dstReadHigh
        }
        if (writefds) {
          GROWABLE_HEAP_I32()[writefds >> 2] = dstWriteLow
          GROWABLE_HEAP_I32()[(writefds + 4) >> 2] = dstWriteHigh
        }
        if (exceptfds) {
          GROWABLE_HEAP_I32()[exceptfds >> 2] = dstExceptLow
          GROWABLE_HEAP_I32()[(exceptfds + 4) >> 2] = dstExceptHigh
        }
        return total
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    var SOCKFS = {
      mount(mount) {
        Module['websocket'] =
          Module['websocket'] && 'object' === typeof Module['websocket'] ? Module['websocket'] : {}
        Module['websocket']._callbacks = {}
        Module['websocket']['on'] = function (event, callback) {
          if ('function' === typeof callback) {
            this._callbacks[event] = callback
          }
          return this
        }
        Module['websocket'].emit = function (event, param) {
          if ('function' === typeof this._callbacks[event]) {
            this._callbacks[event].call(this, param)
          }
        }
        return FS.createNode(null, '/', 16384 | 511, 0)
      },
      createSocket(family, type, protocol) {
        type &= ~526336
        var streaming = type == 1
        if (streaming && protocol && protocol != 6) {
          throw new FS.ErrnoError(66)
        }
        var sock = {
          family: family,
          type: type,
          protocol: protocol,
          server: null,
          error: null,
          peers: {},
          pending: [],
          recv_queue: [],
          sock_ops: SOCKFS.websocket_sock_ops
        }
        var name = SOCKFS.nextname()
        var node = FS.createNode(SOCKFS.root, name, 49152, 0)
        node.sock = sock
        var stream = FS.createStream({
          path: name,
          node: node,
          flags: 2,
          seekable: false,
          stream_ops: SOCKFS.stream_ops
        })
        sock.stream = stream
        return sock
      },
      getSocket(fd) {
        var stream = FS.getStream(fd)
        if (!stream || !FS.isSocket(stream.node.mode)) {
          return null
        }
        return stream.node.sock
      },
      stream_ops: {
        poll(stream) {
          var sock = stream.node.sock
          return sock.sock_ops.poll(sock)
        },
        ioctl(stream, request, varargs) {
          var sock = stream.node.sock
          return sock.sock_ops.ioctl(sock, request, varargs)
        },
        read(stream, buffer, offset, length, position) {
          var sock = stream.node.sock
          var msg = sock.sock_ops.recvmsg(sock, length)
          if (!msg) {
            return 0
          }
          buffer.set(msg.buffer, offset)
          return msg.buffer.length
        },
        write(stream, buffer, offset, length, position) {
          var sock = stream.node.sock
          return sock.sock_ops.sendmsg(sock, buffer, offset, length)
        },
        close(stream) {
          var sock = stream.node.sock
          sock.sock_ops.close(sock)
        }
      },
      nextname() {
        if (!SOCKFS.nextname.current) {
          SOCKFS.nextname.current = 0
        }
        return 'socket[' + SOCKFS.nextname.current++ + ']'
      },
      websocket_sock_ops: {
        createPeer(sock, addr, port) {
          var ws
          if (typeof addr == 'object') {
            ws = addr
            addr = null
            port = null
          }
          if (ws) {
            if (ws._socket) {
              addr = ws._socket.remoteAddress
              port = ws._socket.remotePort
            } else {
              var result = /ws[s]?:\/\/([^:]+):(\d+)/.exec(ws.url)
              if (!result) {
                throw new Error('WebSocket URL must be in the format ws(s)://address:port')
              }
              addr = result[1]
              port = parseInt(result[2], 10)
            }
          } else {
            try {
              var runtimeConfig = Module['websocket'] && 'object' === typeof Module['websocket']
              var url = 'ws:#'.replace('#', '//')
              if (runtimeConfig) {
                if ('string' === typeof Module['websocket']['url']) {
                  url = Module['websocket']['url']
                }
              }
              if (url === 'ws://' || url === 'wss://') {
                var parts = addr.split('/')
                url = url + parts[0] + ':' + port + '/' + parts.slice(1).join('/')
              }
              var subProtocols = 'binary'
              if (runtimeConfig) {
                if ('string' === typeof Module['websocket']['subprotocol']) {
                  subProtocols = Module['websocket']['subprotocol']
                }
              }
              var opts = undefined
              if (subProtocols !== 'null') {
                subProtocols = subProtocols.replace(/^ +| +$/g, '').split(/ *, */)
                opts = subProtocols
              }
              if (runtimeConfig && null === Module['websocket']['subprotocol']) {
                subProtocols = 'null'
                opts = undefined
              }
              var WebSocketConstructor
              {
                WebSocketConstructor = WebSocket
              }
              ws = new WebSocketConstructor(url, opts)
              ws.binaryType = 'arraybuffer'
            } catch (e) {
              throw new FS.ErrnoError(23)
            }
          }
          var peer = { addr: addr, port: port, socket: ws, dgram_send_queue: [] }
          SOCKFS.websocket_sock_ops.addPeer(sock, peer)
          SOCKFS.websocket_sock_ops.handlePeerEvents(sock, peer)
          if (sock.type === 2 && typeof sock.sport != 'undefined') {
            peer.dgram_send_queue.push(
              new Uint8Array([
                255,
                255,
                255,
                255,
                'p'.charCodeAt(0),
                'o'.charCodeAt(0),
                'r'.charCodeAt(0),
                't'.charCodeAt(0),
                (sock.sport & 65280) >> 8,
                sock.sport & 255
              ])
            )
          }
          return peer
        },
        getPeer(sock, addr, port) {
          return sock.peers[addr + ':' + port]
        },
        addPeer(sock, peer) {
          sock.peers[peer.addr + ':' + peer.port] = peer
        },
        removePeer(sock, peer) {
          delete sock.peers[peer.addr + ':' + peer.port]
        },
        handlePeerEvents(sock, peer) {
          var first = true
          var handleOpen = function () {
            Module['websocket'].emit('open', sock.stream.fd)
            try {
              var queued = peer.dgram_send_queue.shift()
              while (queued) {
                peer.socket.send(queued)
                queued = peer.dgram_send_queue.shift()
              }
            } catch (e) {
              peer.socket.close()
            }
          }
          function handleMessage(data) {
            if (typeof data == 'string') {
              var encoder = new TextEncoder()
              data = encoder.encode(data)
            } else {
              assert(data.byteLength !== undefined)
              if (data.byteLength == 0) {
                return
              }
              data = new Uint8Array(data)
            }
            var wasfirst = first
            first = false
            if (
              wasfirst &&
              data.length === 10 &&
              data[0] === 255 &&
              data[1] === 255 &&
              data[2] === 255 &&
              data[3] === 255 &&
              data[4] === 'p'.charCodeAt(0) &&
              data[5] === 'o'.charCodeAt(0) &&
              data[6] === 'r'.charCodeAt(0) &&
              data[7] === 't'.charCodeAt(0)
            ) {
              var newport = (data[8] << 8) | data[9]
              SOCKFS.websocket_sock_ops.removePeer(sock, peer)
              peer.port = newport
              SOCKFS.websocket_sock_ops.addPeer(sock, peer)
              return
            }
            sock.recv_queue.push({ addr: peer.addr, port: peer.port, data: data })
            Module['websocket'].emit('message', sock.stream.fd)
          }
          if (ENVIRONMENT_IS_NODE) {
            peer.socket.on('open', handleOpen)
            peer.socket.on('message', function (data, isBinary) {
              if (!isBinary) {
                return
              }
              handleMessage(new Uint8Array(data).buffer)
            })
            peer.socket.on('close', function () {
              Module['websocket'].emit('close', sock.stream.fd)
            })
            peer.socket.on('error', function (error) {
              sock.error = 14
              Module['websocket'].emit('error', [
                sock.stream.fd,
                sock.error,
                'ECONNREFUSED: Connection refused'
              ])
            })
          } else {
            peer.socket.onopen = handleOpen
            peer.socket.onclose = function () {
              Module['websocket'].emit('close', sock.stream.fd)
            }
            peer.socket.onmessage = function peer_socket_onmessage(event) {
              handleMessage(event.data)
            }
            peer.socket.onerror = function (error) {
              sock.error = 14
              Module['websocket'].emit('error', [
                sock.stream.fd,
                sock.error,
                'ECONNREFUSED: Connection refused'
              ])
            }
          }
        },
        poll(sock) {
          if (sock.type === 1 && sock.server) {
            return sock.pending.length ? 64 | 1 : 0
          }
          var mask = 0
          var dest =
            sock.type === 1 ? SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport) : null
          if (
            sock.recv_queue.length ||
            !dest ||
            (dest && dest.socket.readyState === dest.socket.CLOSING) ||
            (dest && dest.socket.readyState === dest.socket.CLOSED)
          ) {
            mask |= 64 | 1
          }
          if (!dest || (dest && dest.socket.readyState === dest.socket.OPEN)) {
            mask |= 4
          }
          if (
            (dest && dest.socket.readyState === dest.socket.CLOSING) ||
            (dest && dest.socket.readyState === dest.socket.CLOSED)
          ) {
            mask |= 16
          }
          return mask
        },
        ioctl(sock, request, arg) {
          switch (request) {
            case 21531:
              var bytes = 0
              if (sock.recv_queue.length) {
                bytes = sock.recv_queue[0].data.length
              }
              GROWABLE_HEAP_I32()[arg >> 2] = bytes
              return 0
            default:
              return 28
          }
        },
        close(sock) {
          if (sock.server) {
            try {
              sock.server.close()
            } catch (e) {}
            sock.server = null
          }
          var peers = Object.keys(sock.peers)
          for (var i = 0; i < peers.length; i++) {
            var peer = sock.peers[peers[i]]
            try {
              peer.socket.close()
            } catch (e) {}
            SOCKFS.websocket_sock_ops.removePeer(sock, peer)
          }
          return 0
        },
        bind(sock, addr, port) {
          if (typeof sock.saddr != 'undefined' || typeof sock.sport != 'undefined') {
            throw new FS.ErrnoError(28)
          }
          sock.saddr = addr
          sock.sport = port
          if (sock.type === 2) {
            if (sock.server) {
              sock.server.close()
              sock.server = null
            }
            try {
              sock.sock_ops.listen(sock, 0)
            } catch (e) {
              if (!(e.name === 'ErrnoError')) throw e
              if (e.errno !== 138) throw e
            }
          }
        },
        connect(sock, addr, port) {
          if (sock.server) {
            throw new FS.ErrnoError(138)
          }
          if (typeof sock.daddr != 'undefined' && typeof sock.dport != 'undefined') {
            var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport)
            if (dest) {
              if (dest.socket.readyState === dest.socket.CONNECTING) {
                throw new FS.ErrnoError(7)
              } else {
                throw new FS.ErrnoError(30)
              }
            }
          }
          var peer = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port)
          sock.daddr = peer.addr
          sock.dport = peer.port
          throw new FS.ErrnoError(26)
        },
        listen(sock, backlog) {
          if (!ENVIRONMENT_IS_NODE) {
            throw new FS.ErrnoError(138)
          }
        },
        accept(listensock) {
          if (!listensock.server || !listensock.pending.length) {
            throw new FS.ErrnoError(28)
          }
          var newsock = listensock.pending.shift()
          newsock.stream.flags = listensock.stream.flags
          return newsock
        },
        getname(sock, peer) {
          var addr, port
          if (peer) {
            if (sock.daddr === undefined || sock.dport === undefined) {
              throw new FS.ErrnoError(53)
            }
            addr = sock.daddr
            port = sock.dport
          } else {
            addr = sock.saddr || 0
            port = sock.sport || 0
          }
          return { addr: addr, port: port }
        },
        sendmsg(sock, buffer, offset, length, addr, port) {
          if (sock.type === 2) {
            if (addr === undefined || port === undefined) {
              addr = sock.daddr
              port = sock.dport
            }
            if (addr === undefined || port === undefined) {
              throw new FS.ErrnoError(17)
            }
          } else {
            addr = sock.daddr
            port = sock.dport
          }
          var dest = SOCKFS.websocket_sock_ops.getPeer(sock, addr, port)
          if (sock.type === 1) {
            if (
              !dest ||
              dest.socket.readyState === dest.socket.CLOSING ||
              dest.socket.readyState === dest.socket.CLOSED
            ) {
              throw new FS.ErrnoError(53)
            } else if (dest.socket.readyState === dest.socket.CONNECTING) {
              throw new FS.ErrnoError(6)
            }
          }
          if (ArrayBuffer.isView(buffer)) {
            offset += buffer.byteOffset
            buffer = buffer.buffer
          }
          var data
          if (buffer instanceof SharedArrayBuffer) {
            data = new Uint8Array(new Uint8Array(buffer.slice(offset, offset + length))).buffer
          } else {
            data = buffer.slice(offset, offset + length)
          }
          if (sock.type === 2) {
            if (!dest || dest.socket.readyState !== dest.socket.OPEN) {
              if (
                !dest ||
                dest.socket.readyState === dest.socket.CLOSING ||
                dest.socket.readyState === dest.socket.CLOSED
              ) {
                dest = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port)
              }
              dest.dgram_send_queue.push(data)
              return length
            }
          }
          try {
            dest.socket.send(data)
            return length
          } catch (e) {
            throw new FS.ErrnoError(28)
          }
        },
        recvmsg(sock, length) {
          if (sock.type === 1 && sock.server) {
            throw new FS.ErrnoError(53)
          }
          var queued = sock.recv_queue.shift()
          if (!queued) {
            if (sock.type === 1) {
              var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport)
              if (!dest) {
                throw new FS.ErrnoError(53)
              }
              if (
                dest.socket.readyState === dest.socket.CLOSING ||
                dest.socket.readyState === dest.socket.CLOSED
              ) {
                return null
              }
              throw new FS.ErrnoError(6)
            }
            throw new FS.ErrnoError(6)
          }
          var queuedLength = queued.data.byteLength || queued.data.length
          var queuedOffset = queued.data.byteOffset || 0
          var queuedBuffer = queued.data.buffer || queued.data
          var bytesRead = Math.min(length, queuedLength)
          var res = {
            buffer: new Uint8Array(queuedBuffer, queuedOffset, bytesRead),
            addr: queued.addr,
            port: queued.port
          }
          if (sock.type === 1 && bytesRead < queuedLength) {
            var bytesRemaining = queuedLength - bytesRead
            queued.data = new Uint8Array(queuedBuffer, queuedOffset + bytesRead, bytesRemaining)
            sock.recv_queue.unshift(queued)
          }
          return res
        }
      }
    }
    var getSocketFromFD = (fd) => {
      var socket = SOCKFS.getSocket(fd)
      if (!socket) throw new FS.ErrnoError(8)
      return socket
    }
    var setErrNo = (value) => {
      GROWABLE_HEAP_I32()[___errno_location() >> 2] = value
      return value
    }
    var inetNtop4 = (addr) =>
      (addr & 255) +
      '.' +
      ((addr >> 8) & 255) +
      '.' +
      ((addr >> 16) & 255) +
      '.' +
      ((addr >> 24) & 255)
    var inetNtop6 = (ints) => {
      var str = ''
      var word = 0
      var longest = 0
      var lastzero = 0
      var zstart = 0
      var len = 0
      var i = 0
      var parts = [
        ints[0] & 65535,
        ints[0] >> 16,
        ints[1] & 65535,
        ints[1] >> 16,
        ints[2] & 65535,
        ints[2] >> 16,
        ints[3] & 65535,
        ints[3] >> 16
      ]
      var hasipv4 = true
      var v4part = ''
      for (i = 0; i < 5; i++) {
        if (parts[i] !== 0) {
          hasipv4 = false
          break
        }
      }
      if (hasipv4) {
        v4part = inetNtop4(parts[6] | (parts[7] << 16))
        if (parts[5] === -1) {
          str = '::ffff:'
          str += v4part
          return str
        }
        if (parts[5] === 0) {
          str = '::'
          if (v4part === '0.0.0.0') v4part = ''
          if (v4part === '0.0.0.1') v4part = '1'
          str += v4part
          return str
        }
      }
      for (word = 0; word < 8; word++) {
        if (parts[word] === 0) {
          if (word - lastzero > 1) {
            len = 0
          }
          lastzero = word
          len++
        }
        if (len > longest) {
          longest = len
          zstart = word - longest + 1
        }
      }
      for (word = 0; word < 8; word++) {
        if (longest > 1) {
          if (parts[word] === 0 && word >= zstart && word < zstart + longest) {
            if (word === zstart) {
              str += ':'
              if (zstart === 0) str += ':'
            }
            continue
          }
        }
        str += Number(_ntohs(parts[word] & 65535)).toString(16)
        str += word < 7 ? ':' : ''
      }
      return str
    }
    var readSockaddr = (sa, salen) => {
      var family = GROWABLE_HEAP_I16()[sa >> 1]
      var port = _ntohs(GROWABLE_HEAP_U16()[(sa + 2) >> 1])
      var addr
      switch (family) {
        case 2:
          if (salen !== 16) {
            return { errno: 28 }
          }
          addr = GROWABLE_HEAP_I32()[(sa + 4) >> 2]
          addr = inetNtop4(addr)
          break
        case 10:
          if (salen !== 28) {
            return { errno: 28 }
          }
          addr = [
            GROWABLE_HEAP_I32()[(sa + 8) >> 2],
            GROWABLE_HEAP_I32()[(sa + 12) >> 2],
            GROWABLE_HEAP_I32()[(sa + 16) >> 2],
            GROWABLE_HEAP_I32()[(sa + 20) >> 2]
          ]
          addr = inetNtop6(addr)
          break
        default:
          return { errno: 5 }
      }
      return { family: family, addr: addr, port: port }
    }
    var inetPton4 = (str) => {
      var b = str.split('.')
      for (var i = 0; i < 4; i++) {
        var tmp = Number(b[i])
        if (isNaN(tmp)) return null
        b[i] = tmp
      }
      return (b[0] | (b[1] << 8) | (b[2] << 16) | (b[3] << 24)) >>> 0
    }
    var jstoi_q = (str) => parseInt(str)
    var inetPton6 = (str) => {
      var words
      var w, offset, z
      var valid6regx =
        /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i
      var parts = []
      if (!valid6regx.test(str)) {
        return null
      }
      if (str === '::') {
        return [0, 0, 0, 0, 0, 0, 0, 0]
      }
      if (str.startsWith('::')) {
        str = str.replace('::', 'Z:')
      } else {
        str = str.replace('::', ':Z:')
      }
      if (str.indexOf('.') > 0) {
        str = str.replace(new RegExp('[.]', 'g'), ':')
        words = str.split(':')
        words[words.length - 4] =
          jstoi_q(words[words.length - 4]) + jstoi_q(words[words.length - 3]) * 256
        words[words.length - 3] =
          jstoi_q(words[words.length - 2]) + jstoi_q(words[words.length - 1]) * 256
        words = words.slice(0, words.length - 2)
      } else {
        words = str.split(':')
      }
      offset = 0
      z = 0
      for (w = 0; w < words.length; w++) {
        if (typeof words[w] == 'string') {
          if (words[w] === 'Z') {
            for (z = 0; z < 8 - words.length + 1; z++) {
              parts[w + z] = 0
            }
            offset = z - 1
          } else {
            parts[w + offset] = _htons(parseInt(words[w], 16))
          }
        } else {
          parts[w + offset] = words[w]
        }
      }
      return [
        (parts[1] << 16) | parts[0],
        (parts[3] << 16) | parts[2],
        (parts[5] << 16) | parts[4],
        (parts[7] << 16) | parts[6]
      ]
    }
    var DNS = {
      address_map: { id: 1, addrs: {}, names: {} },
      lookup_name(name) {
        var res = inetPton4(name)
        if (res !== null) {
          return name
        }
        res = inetPton6(name)
        if (res !== null) {
          return name
        }
        var addr
        if (DNS.address_map.addrs[name]) {
          addr = DNS.address_map.addrs[name]
        } else {
          var id = DNS.address_map.id++
          assert(id < 65535, 'exceeded max address mappings of 65535')
          addr = '172.29.' + (id & 255) + '.' + (id & 65280)
          DNS.address_map.names[addr] = name
          DNS.address_map.addrs[name] = addr
        }
        return addr
      },
      lookup_addr(addr) {
        if (DNS.address_map.names[addr]) {
          return DNS.address_map.names[addr]
        }
        return null
      }
    }
    var getSocketAddress = (addrp, addrlen, allowNull) => {
      if (allowNull && addrp === 0) return null
      var info = readSockaddr(addrp, addrlen)
      if (info.errno) throw new FS.ErrnoError(info.errno)
      info.addr = DNS.lookup_addr(info.addr) || info.addr
      return info
    }
    function ___syscall_connect(fd, addr, addrlen, d1, d2, d3) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(3, 1, fd, addr, addrlen, d1, d2, d3)
      try {
        var sock = getSocketFromFD(fd)
        var info = getSocketAddress(addr, addrlen)
        sock.sock_ops.connect(sock, info.addr, info.port)
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_faccessat(dirfd, path, amode, flags) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(4, 1, dirfd, path, amode, flags)
      try {
        path = SYSCALLS.getStr(path)
        path = SYSCALLS.calculateAt(dirfd, path)
        if (amode & ~7) {
          return -28
        }
        var lookup = FS.lookupPath(path, { follow: true })
        var node = lookup.node
        if (!node) {
          return -44
        }
        var perms = ''
        if (amode & 4) perms += 'r'
        if (amode & 2) perms += 'w'
        if (amode & 1) perms += 'x'
        if (perms && FS.nodePermissions(node, perms)) {
          return -2
        }
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_fcntl64(fd, cmd, varargs) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(5, 1, fd, cmd, varargs)
      SYSCALLS.varargs = varargs
      try {
        var stream = SYSCALLS.getStreamFromFD(fd)
        switch (cmd) {
          case 0: {
            var arg = SYSCALLS.get()
            if (arg < 0) {
              return -28
            }
            while (FS.streams[arg]) {
              arg++
            }
            var newStream
            newStream = FS.createStream(stream, arg)
            return newStream.fd
          }
          case 1:
          case 2:
            return 0
          case 3:
            return stream.flags
          case 4: {
            var arg = SYSCALLS.get()
            stream.flags |= arg
            return 0
          }
          case 5: {
            var arg = SYSCALLS.getp()
            var offset = 0
            GROWABLE_HEAP_I16()[(arg + offset) >> 1] = 2
            return 0
          }
          case 6:
          case 7:
            return 0
          case 16:
          case 8:
            return -28
          case 9:
            setErrNo(28)
            return -1
          default: {
            return -28
          }
        }
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_fstat64(fd, buf) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(6, 1, fd, buf)
      try {
        var stream = SYSCALLS.getStreamFromFD(fd)
        return SYSCALLS.doStat(FS.stat, stream.path, buf)
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    var convertI32PairToI53Checked = (lo, hi) =>
      (hi + 2097152) >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN
    function ___syscall_ftruncate64(fd, length_low, length_high) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(7, 1, fd, length_low, length_high)
      var length = convertI32PairToI53Checked(length_low, length_high)
      try {
        if (isNaN(length)) return 61
        FS.ftruncate(fd, length)
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_getsockopt(fd, level, optname, optval, optlen, d1) {
      if (ENVIRONMENT_IS_PTHREAD)
        return proxyToMainThread(8, 1, fd, level, optname, optval, optlen, d1)
      try {
        var sock = getSocketFromFD(fd)
        if (level === 1) {
          if (optname === 4) {
            GROWABLE_HEAP_I32()[optval >> 2] = sock.error
            GROWABLE_HEAP_I32()[optlen >> 2] = 4
            sock.error = null
            return 0
          }
        }
        return -50
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_ioctl(fd, op, varargs) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(9, 1, fd, op, varargs)
      SYSCALLS.varargs = varargs
      try {
        var stream = SYSCALLS.getStreamFromFD(fd)
        switch (op) {
          case 21509: {
            if (!stream.tty) return -59
            return 0
          }
          case 21505: {
            if (!stream.tty) return -59
            if (stream.tty.ops.ioctl_tcgets) {
              var termios = stream.tty.ops.ioctl_tcgets(stream)
              var argp = SYSCALLS.getp()
              GROWABLE_HEAP_I32()[argp >> 2] = termios.c_iflag || 0
              GROWABLE_HEAP_I32()[(argp + 4) >> 2] = termios.c_oflag || 0
              GROWABLE_HEAP_I32()[(argp + 8) >> 2] = termios.c_cflag || 0
              GROWABLE_HEAP_I32()[(argp + 12) >> 2] = termios.c_lflag || 0
              for (var i = 0; i < 32; i++) {
                GROWABLE_HEAP_I8()[(argp + i + 17) >> 0] = termios.c_cc[i] || 0
              }
              return 0
            }
            return 0
          }
          case 21510:
          case 21511:
          case 21512: {
            if (!stream.tty) return -59
            return 0
          }
          case 21506:
          case 21507:
          case 21508: {
            if (!stream.tty) return -59
            if (stream.tty.ops.ioctl_tcsets) {
              var argp = SYSCALLS.getp()
              var c_iflag = GROWABLE_HEAP_I32()[argp >> 2]
              var c_oflag = GROWABLE_HEAP_I32()[(argp + 4) >> 2]
              var c_cflag = GROWABLE_HEAP_I32()[(argp + 8) >> 2]
              var c_lflag = GROWABLE_HEAP_I32()[(argp + 12) >> 2]
              var c_cc = []
              for (var i = 0; i < 32; i++) {
                c_cc.push(GROWABLE_HEAP_I8()[(argp + i + 17) >> 0])
              }
              return stream.tty.ops.ioctl_tcsets(stream.tty, op, {
                c_iflag: c_iflag,
                c_oflag: c_oflag,
                c_cflag: c_cflag,
                c_lflag: c_lflag,
                c_cc: c_cc
              })
            }
            return 0
          }
          case 21519: {
            if (!stream.tty) return -59
            var argp = SYSCALLS.getp()
            GROWABLE_HEAP_I32()[argp >> 2] = 0
            return 0
          }
          case 21520: {
            if (!stream.tty) return -59
            return -28
          }
          case 21531: {
            var argp = SYSCALLS.getp()
            return FS.ioctl(stream, op, argp)
          }
          case 21523: {
            if (!stream.tty) return -59
            if (stream.tty.ops.ioctl_tiocgwinsz) {
              var winsize = stream.tty.ops.ioctl_tiocgwinsz(stream.tty)
              var argp = SYSCALLS.getp()
              GROWABLE_HEAP_I16()[argp >> 1] = winsize[0]
              GROWABLE_HEAP_I16()[(argp + 2) >> 1] = winsize[1]
            }
            return 0
          }
          case 21524: {
            if (!stream.tty) return -59
            return 0
          }
          case 21515: {
            if (!stream.tty) return -59
            return 0
          }
          default:
            return -28
        }
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_lstat64(path, buf) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(10, 1, path, buf)
      try {
        path = SYSCALLS.getStr(path)
        return SYSCALLS.doStat(FS.lstat, path, buf)
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_mkdirat(dirfd, path, mode) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(11, 1, dirfd, path, mode)
      try {
        path = SYSCALLS.getStr(path)
        path = SYSCALLS.calculateAt(dirfd, path)
        path = PATH.normalize(path)
        if (path[path.length - 1] === '/') path = path.substr(0, path.length - 1)
        FS.mkdir(path, mode, 0)
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_newfstatat(dirfd, path, buf, flags) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(12, 1, dirfd, path, buf, flags)
      try {
        path = SYSCALLS.getStr(path)
        var nofollow = flags & 256
        var allowEmpty = flags & 4096
        flags = flags & ~6400
        path = SYSCALLS.calculateAt(dirfd, path, allowEmpty)
        return SYSCALLS.doStat(nofollow ? FS.lstat : FS.stat, path, buf)
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_openat(dirfd, path, flags, varargs) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(13, 1, dirfd, path, flags, varargs)
      SYSCALLS.varargs = varargs
      try {
        path = SYSCALLS.getStr(path)
        path = SYSCALLS.calculateAt(dirfd, path)
        var mode = varargs ? SYSCALLS.get() : 0
        return FS.open(path, flags, mode).fd
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    var PIPEFS = {
      BUCKET_BUFFER_SIZE: 8192,
      mount(mount) {
        return FS.createNode(null, '/', 16384 | 511, 0)
      },
      createPipe() {
        var pipe = { buckets: [], refcnt: 2 }
        pipe.buckets.push({
          buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
          offset: 0,
          roffset: 0
        })
        var rName = PIPEFS.nextname()
        var wName = PIPEFS.nextname()
        var rNode = FS.createNode(PIPEFS.root, rName, 4096, 0)
        var wNode = FS.createNode(PIPEFS.root, wName, 4096, 0)
        rNode.pipe = pipe
        wNode.pipe = pipe
        var readableStream = FS.createStream({
          path: rName,
          node: rNode,
          flags: 0,
          seekable: false,
          stream_ops: PIPEFS.stream_ops
        })
        rNode.stream = readableStream
        var writableStream = FS.createStream({
          path: wName,
          node: wNode,
          flags: 1,
          seekable: false,
          stream_ops: PIPEFS.stream_ops
        })
        wNode.stream = writableStream
        return { readable_fd: readableStream.fd, writable_fd: writableStream.fd }
      },
      stream_ops: {
        poll(stream) {
          var pipe = stream.node.pipe
          if ((stream.flags & 2097155) === 1) {
            return 256 | 4
          }
          if (pipe.buckets.length > 0) {
            for (var i = 0; i < pipe.buckets.length; i++) {
              var bucket = pipe.buckets[i]
              if (bucket.offset - bucket.roffset > 0) {
                return 64 | 1
              }
            }
          }
          return 0
        },
        ioctl(stream, request, varargs) {
          return 28
        },
        fsync(stream) {
          return 28
        },
        read(stream, buffer, offset, length, position) {
          var pipe = stream.node.pipe
          var currentLength = 0
          for (var i = 0; i < pipe.buckets.length; i++) {
            var bucket = pipe.buckets[i]
            currentLength += bucket.offset - bucket.roffset
          }
          var data = buffer.subarray(offset, offset + length)
          if (length <= 0) {
            return 0
          }
          if (currentLength == 0) {
            throw new FS.ErrnoError(6)
          }
          var toRead = Math.min(currentLength, length)
          var totalRead = toRead
          var toRemove = 0
          for (var i = 0; i < pipe.buckets.length; i++) {
            var currBucket = pipe.buckets[i]
            var bucketSize = currBucket.offset - currBucket.roffset
            if (toRead <= bucketSize) {
              var tmpSlice = currBucket.buffer.subarray(currBucket.roffset, currBucket.offset)
              if (toRead < bucketSize) {
                tmpSlice = tmpSlice.subarray(0, toRead)
                currBucket.roffset += toRead
              } else {
                toRemove++
              }
              data.set(tmpSlice)
              break
            } else {
              var tmpSlice = currBucket.buffer.subarray(currBucket.roffset, currBucket.offset)
              data.set(tmpSlice)
              data = data.subarray(tmpSlice.byteLength)
              toRead -= tmpSlice.byteLength
              toRemove++
            }
          }
          if (toRemove && toRemove == pipe.buckets.length) {
            toRemove--
            pipe.buckets[toRemove].offset = 0
            pipe.buckets[toRemove].roffset = 0
          }
          pipe.buckets.splice(0, toRemove)
          return totalRead
        },
        write(stream, buffer, offset, length, position) {
          var pipe = stream.node.pipe
          var data = buffer.subarray(offset, offset + length)
          var dataLen = data.byteLength
          if (dataLen <= 0) {
            return 0
          }
          var currBucket = null
          if (pipe.buckets.length == 0) {
            currBucket = {
              buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
              offset: 0,
              roffset: 0
            }
            pipe.buckets.push(currBucket)
          } else {
            currBucket = pipe.buckets[pipe.buckets.length - 1]
          }
          assert(currBucket.offset <= PIPEFS.BUCKET_BUFFER_SIZE)
          var freeBytesInCurrBuffer = PIPEFS.BUCKET_BUFFER_SIZE - currBucket.offset
          if (freeBytesInCurrBuffer >= dataLen) {
            currBucket.buffer.set(data, currBucket.offset)
            currBucket.offset += dataLen
            return dataLen
          } else if (freeBytesInCurrBuffer > 0) {
            currBucket.buffer.set(data.subarray(0, freeBytesInCurrBuffer), currBucket.offset)
            currBucket.offset += freeBytesInCurrBuffer
            data = data.subarray(freeBytesInCurrBuffer, data.byteLength)
          }
          var numBuckets = (data.byteLength / PIPEFS.BUCKET_BUFFER_SIZE) | 0
          var remElements = data.byteLength % PIPEFS.BUCKET_BUFFER_SIZE
          for (var i = 0; i < numBuckets; i++) {
            var newBucket = {
              buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
              offset: PIPEFS.BUCKET_BUFFER_SIZE,
              roffset: 0
            }
            pipe.buckets.push(newBucket)
            newBucket.buffer.set(data.subarray(0, PIPEFS.BUCKET_BUFFER_SIZE))
            data = data.subarray(PIPEFS.BUCKET_BUFFER_SIZE, data.byteLength)
          }
          if (remElements > 0) {
            var newBucket = {
              buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
              offset: data.byteLength,
              roffset: 0
            }
            pipe.buckets.push(newBucket)
            newBucket.buffer.set(data)
          }
          return dataLen
        },
        close(stream) {
          var pipe = stream.node.pipe
          pipe.refcnt--
          if (pipe.refcnt === 0) {
            pipe.buckets = null
          }
        }
      },
      nextname() {
        if (!PIPEFS.nextname.current) {
          PIPEFS.nextname.current = 0
        }
        return 'pipe[' + PIPEFS.nextname.current++ + ']'
      }
    }
    function ___syscall_pipe(fdPtr) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(14, 1, fdPtr)
      try {
        if (fdPtr == 0) {
          throw new FS.ErrnoError(21)
        }
        var res = PIPEFS.createPipe()
        GROWABLE_HEAP_I32()[fdPtr >> 2] = res.readable_fd
        GROWABLE_HEAP_I32()[(fdPtr + 4) >> 2] = res.writable_fd
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_poll(fds, nfds, timeout) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(15, 1, fds, nfds, timeout)
      try {
        var nonzero = 0
        for (var i = 0; i < nfds; i++) {
          var pollfd = fds + 8 * i
          var fd = GROWABLE_HEAP_I32()[pollfd >> 2]
          var events = GROWABLE_HEAP_I16()[(pollfd + 4) >> 1]
          var mask = 32
          var stream = FS.getStream(fd)
          if (stream) {
            mask = SYSCALLS.DEFAULT_POLLMASK
            if (stream.stream_ops.poll) {
              mask = stream.stream_ops.poll(stream, -1)
            }
          }
          mask &= events | 8 | 16
          if (mask) nonzero++
          GROWABLE_HEAP_I16()[(pollfd + 6) >> 1] = mask
        }
        return nonzero
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_socket(domain, type, protocol) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(16, 1, domain, type, protocol)
      try {
        var sock = SOCKFS.createSocket(domain, type, protocol)
        return sock.stream.fd
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_stat64(path, buf) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(17, 1, path, buf)
      try {
        path = SYSCALLS.getStr(path)
        return SYSCALLS.doStat(FS.stat, path, buf)
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    function ___syscall_unlinkat(dirfd, path, flags) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(18, 1, dirfd, path, flags)
      try {
        path = SYSCALLS.getStr(path)
        path = SYSCALLS.calculateAt(dirfd, path)
        if (flags === 0) {
          FS.unlink(path)
        } else if (flags === 512) {
          FS.rmdir(path)
        } else {
          abort('Invalid flags passed to unlinkat')
        }
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return -e.errno
      }
    }
    var __embind_register_bigint = (primitiveType, name, size, minRange, maxRange) => {}
    var embind_init_charCodes = () => {
      var codes = new Array(256)
      for (var i = 0; i < 256; ++i) {
        codes[i] = String.fromCharCode(i)
      }
      embind_charCodes = codes
    }
    var embind_charCodes
    var readLatin1String = (ptr) => {
      var ret = ''
      var c = ptr
      while (GROWABLE_HEAP_U8()[c]) {
        ret += embind_charCodes[GROWABLE_HEAP_U8()[c++]]
      }
      return ret
    }
    var awaitingDependencies = {}
    var registeredTypes = {}
    var typeDependencies = {}
    var BindingError
    var throwBindingError = (message) => {
      throw new BindingError(message)
    }
    var InternalError
    var throwInternalError = (message) => {
      throw new InternalError(message)
    }
    var whenDependentTypesAreResolved = (myTypes, dependentTypes, getTypeConverters) => {
      myTypes.forEach(function (type) {
        typeDependencies[type] = dependentTypes
      })
      function onComplete(typeConverters) {
        var myTypeConverters = getTypeConverters(typeConverters)
        if (myTypeConverters.length !== myTypes.length) {
          throwInternalError('Mismatched type converter count')
        }
        for (var i = 0; i < myTypes.length; ++i) {
          registerType(myTypes[i], myTypeConverters[i])
        }
      }
      var typeConverters = new Array(dependentTypes.length)
      var unregisteredTypes = []
      var registered = 0
      dependentTypes.forEach((dt, i) => {
        if (registeredTypes.hasOwnProperty(dt)) {
          typeConverters[i] = registeredTypes[dt]
        } else {
          unregisteredTypes.push(dt)
          if (!awaitingDependencies.hasOwnProperty(dt)) {
            awaitingDependencies[dt] = []
          }
          awaitingDependencies[dt].push(() => {
            typeConverters[i] = registeredTypes[dt]
            ++registered
            if (registered === unregisteredTypes.length) {
              onComplete(typeConverters)
            }
          })
        }
      })
      if (0 === unregisteredTypes.length) {
        onComplete(typeConverters)
      }
    }
    function sharedRegisterType(rawType, registeredInstance, options = {}) {
      var name = registeredInstance.name
      if (!rawType) {
        throwBindingError(`type "${name}" must have a positive integer typeid pointer`)
      }
      if (registeredTypes.hasOwnProperty(rawType)) {
        if (options.ignoreDuplicateRegistrations) {
          return
        } else {
          throwBindingError(`Cannot register type '${name}' twice`)
        }
      }
      registeredTypes[rawType] = registeredInstance
      delete typeDependencies[rawType]
      if (awaitingDependencies.hasOwnProperty(rawType)) {
        var callbacks = awaitingDependencies[rawType]
        delete awaitingDependencies[rawType]
        callbacks.forEach((cb) => cb())
      }
    }
    function registerType(rawType, registeredInstance, options = {}) {
      if (!('argPackAdvance' in registeredInstance)) {
        throw new TypeError('registerType registeredInstance requires argPackAdvance')
      }
      return sharedRegisterType(rawType, registeredInstance, options)
    }
    var GenericWireTypeSize = 8
    var __embind_register_bool = (rawType, name, trueValue, falseValue) => {
      name = readLatin1String(name)
      registerType(rawType, {
        name: name,
        fromWireType: function (wt) {
          return !!wt
        },
        toWireType: function (destructors, o) {
          return o ? trueValue : falseValue
        },
        argPackAdvance: GenericWireTypeSize,
        readValueFromPointer: function (pointer) {
          return this['fromWireType'](GROWABLE_HEAP_U8()[pointer])
        },
        destructorFunction: null
      })
    }
    var shallowCopyInternalPointer = (o) => ({
      count: o.count,
      deleteScheduled: o.deleteScheduled,
      preservePointerOnDelete: o.preservePointerOnDelete,
      ptr: o.ptr,
      ptrType: o.ptrType,
      smartPtr: o.smartPtr,
      smartPtrType: o.smartPtrType
    })
    var throwInstanceAlreadyDeleted = (obj) => {
      function getInstanceTypeName(handle) {
        return handle.$$.ptrType.registeredClass.name
      }
      throwBindingError(getInstanceTypeName(obj) + ' instance already deleted')
    }
    var finalizationRegistry = false
    var detachFinalizer = (handle) => {}
    var runDestructor = ($$) => {
      if ($$.smartPtr) {
        $$.smartPtrType.rawDestructor($$.smartPtr)
      } else {
        $$.ptrType.registeredClass.rawDestructor($$.ptr)
      }
    }
    var releaseClassHandle = ($$) => {
      $$.count.value -= 1
      var toDelete = 0 === $$.count.value
      if (toDelete) {
        runDestructor($$)
      }
    }
    var downcastPointer = (ptr, ptrClass, desiredClass) => {
      if (ptrClass === desiredClass) {
        return ptr
      }
      if (undefined === desiredClass.baseClass) {
        return null
      }
      var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass)
      if (rv === null) {
        return null
      }
      return desiredClass.downcast(rv)
    }
    var registeredPointers = {}
    var getInheritedInstanceCount = () => Object.keys(registeredInstances).length
    var getLiveInheritedInstances = () => {
      var rv = []
      for (var k in registeredInstances) {
        if (registeredInstances.hasOwnProperty(k)) {
          rv.push(registeredInstances[k])
        }
      }
      return rv
    }
    var deletionQueue = []
    var flushPendingDeletes = () => {
      while (deletionQueue.length) {
        var obj = deletionQueue.pop()
        obj.$$.deleteScheduled = false
        obj['delete']()
      }
    }
    var delayFunction
    var setDelayFunction = (fn) => {
      delayFunction = fn
      if (deletionQueue.length && delayFunction) {
        delayFunction(flushPendingDeletes)
      }
    }
    var init_embind = () => {
      Module['getInheritedInstanceCount'] = getInheritedInstanceCount
      Module['getLiveInheritedInstances'] = getLiveInheritedInstances
      Module['flushPendingDeletes'] = flushPendingDeletes
      Module['setDelayFunction'] = setDelayFunction
    }
    var registeredInstances = {}
    var getBasestPointer = (class_, ptr) => {
      if (ptr === undefined) {
        throwBindingError('ptr should not be undefined')
      }
      while (class_.baseClass) {
        ptr = class_.upcast(ptr)
        class_ = class_.baseClass
      }
      return ptr
    }
    var getInheritedInstance = (class_, ptr) => {
      ptr = getBasestPointer(class_, ptr)
      return registeredInstances[ptr]
    }
    var makeClassHandle = (prototype, record) => {
      if (!record.ptrType || !record.ptr) {
        throwInternalError('makeClassHandle requires ptr and ptrType')
      }
      var hasSmartPtrType = !!record.smartPtrType
      var hasSmartPtr = !!record.smartPtr
      if (hasSmartPtrType !== hasSmartPtr) {
        throwInternalError('Both smartPtrType and smartPtr must be specified')
      }
      record.count = { value: 1 }
      return attachFinalizer(Object.create(prototype, { $$: { value: record } }))
    }
    function RegisteredPointer_fromWireType(ptr) {
      var rawPointer = this.getPointee(ptr)
      if (!rawPointer) {
        this.destructor(ptr)
        return null
      }
      var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer)
      if (undefined !== registeredInstance) {
        if (0 === registeredInstance.$$.count.value) {
          registeredInstance.$$.ptr = rawPointer
          registeredInstance.$$.smartPtr = ptr
          return registeredInstance['clone']()
        } else {
          var rv = registeredInstance['clone']()
          this.destructor(ptr)
          return rv
        }
      }
      function makeDefaultHandle() {
        if (this.isSmartPointer) {
          return makeClassHandle(this.registeredClass.instancePrototype, {
            ptrType: this.pointeeType,
            ptr: rawPointer,
            smartPtrType: this,
            smartPtr: ptr
          })
        } else {
          return makeClassHandle(this.registeredClass.instancePrototype, {
            ptrType: this,
            ptr: ptr
          })
        }
      }
      var actualType = this.registeredClass.getActualType(rawPointer)
      var registeredPointerRecord = registeredPointers[actualType]
      if (!registeredPointerRecord) {
        return makeDefaultHandle.call(this)
      }
      var toType
      if (this.isConst) {
        toType = registeredPointerRecord.constPointerType
      } else {
        toType = registeredPointerRecord.pointerType
      }
      var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass)
      if (dp === null) {
        return makeDefaultHandle.call(this)
      }
      if (this.isSmartPointer) {
        return makeClassHandle(toType.registeredClass.instancePrototype, {
          ptrType: toType,
          ptr: dp,
          smartPtrType: this,
          smartPtr: ptr
        })
      } else {
        return makeClassHandle(toType.registeredClass.instancePrototype, {
          ptrType: toType,
          ptr: dp
        })
      }
    }
    var attachFinalizer = (handle) => {
      if ('undefined' === typeof FinalizationRegistry) {
        attachFinalizer = (handle) => handle
        return handle
      }
      finalizationRegistry = new FinalizationRegistry((info) => {
        releaseClassHandle(info.$$)
      })
      attachFinalizer = (handle) => {
        var $$ = handle.$$
        var hasSmartPtr = !!$$.smartPtr
        if (hasSmartPtr) {
          var info = { $$: $$ }
          finalizationRegistry.register(handle, info, handle)
        }
        return handle
      }
      detachFinalizer = (handle) => finalizationRegistry.unregister(handle)
      return attachFinalizer(handle)
    }
    var init_ClassHandle = () => {
      Object.assign(ClassHandle.prototype, {
        isAliasOf(other) {
          if (!(this instanceof ClassHandle)) {
            return false
          }
          if (!(other instanceof ClassHandle)) {
            return false
          }
          var leftClass = this.$$.ptrType.registeredClass
          var left = this.$$.ptr
          other.$$ = other.$$
          var rightClass = other.$$.ptrType.registeredClass
          var right = other.$$.ptr
          while (leftClass.baseClass) {
            left = leftClass.upcast(left)
            leftClass = leftClass.baseClass
          }
          while (rightClass.baseClass) {
            right = rightClass.upcast(right)
            rightClass = rightClass.baseClass
          }
          return leftClass === rightClass && left === right
        },
        clone() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this)
          }
          if (this.$$.preservePointerOnDelete) {
            this.$$.count.value += 1
            return this
          } else {
            var clone = attachFinalizer(
              Object.create(Object.getPrototypeOf(this), {
                $$: { value: shallowCopyInternalPointer(this.$$) }
              })
            )
            clone.$$.count.value += 1
            clone.$$.deleteScheduled = false
            return clone
          }
        },
        delete() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this)
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError('Object already scheduled for deletion')
          }
          detachFinalizer(this)
          releaseClassHandle(this.$$)
          if (!this.$$.preservePointerOnDelete) {
            this.$$.smartPtr = undefined
            this.$$.ptr = undefined
          }
        },
        isDeleted() {
          return !this.$$.ptr
        },
        deleteLater() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this)
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError('Object already scheduled for deletion')
          }
          deletionQueue.push(this)
          if (deletionQueue.length === 1 && delayFunction) {
            delayFunction(flushPendingDeletes)
          }
          this.$$.deleteScheduled = true
          return this
        }
      })
    }
    function ClassHandle() {}
    var char_0 = 48
    var char_9 = 57
    var makeLegalFunctionName = (name) => {
      if (undefined === name) {
        return '_unknown'
      }
      name = name.replace(/[^a-zA-Z0-9_]/g, '$')
      var f = name.charCodeAt(0)
      if (f >= char_0 && f <= char_9) {
        return `_${name}`
      }
      return name
    }
    function createNamedFunction(name, body) {
      name = makeLegalFunctionName(name)
      return {
        [name]: function () {
          return body.apply(this, arguments)
        }
      }[name]
    }
    var ensureOverloadTable = (proto, methodName, humanName) => {
      if (undefined === proto[methodName].overloadTable) {
        var prevFunc = proto[methodName]
        proto[methodName] = function () {
          if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
            throwBindingError(
              `Function '${humanName}' called with an invalid number of arguments (${arguments.length}) - expects one of (${proto[methodName].overloadTable})!`
            )
          }
          return proto[methodName].overloadTable[arguments.length].apply(this, arguments)
        }
        proto[methodName].overloadTable = []
        proto[methodName].overloadTable[prevFunc.argCount] = prevFunc
      }
    }
    var exposePublicSymbol = (name, value, numArguments) => {
      if (Module.hasOwnProperty(name)) {
        if (
          undefined === numArguments ||
          (undefined !== Module[name].overloadTable &&
            undefined !== Module[name].overloadTable[numArguments])
        ) {
          throwBindingError(`Cannot register public name '${name}' twice`)
        }
        ensureOverloadTable(Module, name, name)
        if (Module.hasOwnProperty(numArguments)) {
          throwBindingError(
            `Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`
          )
        }
        Module[name].overloadTable[numArguments] = value
      } else {
        Module[name] = value
        if (undefined !== numArguments) {
          Module[name].numArguments = numArguments
        }
      }
    }
    function RegisteredClass(
      name,
      constructor,
      instancePrototype,
      rawDestructor,
      baseClass,
      getActualType,
      upcast,
      downcast
    ) {
      this.name = name
      this.constructor = constructor
      this.instancePrototype = instancePrototype
      this.rawDestructor = rawDestructor
      this.baseClass = baseClass
      this.getActualType = getActualType
      this.upcast = upcast
      this.downcast = downcast
      this.pureVirtualFunctions = []
    }
    var upcastPointer = (ptr, ptrClass, desiredClass) => {
      while (ptrClass !== desiredClass) {
        if (!ptrClass.upcast) {
          throwBindingError(
            `Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`
          )
        }
        ptr = ptrClass.upcast(ptr)
        ptrClass = ptrClass.baseClass
      }
      return ptr
    }
    function constNoSmartPtrRawPointerToWireType(destructors, handle) {
      if (handle === null) {
        if (this.isReference) {
          throwBindingError(`null is not a valid ${this.name}`)
        }
        return 0
      }
      if (!handle.$$) {
        throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`)
      }
      if (!handle.$$.ptr) {
        throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`)
      }
      var handleClass = handle.$$.ptrType.registeredClass
      var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass)
      return ptr
    }
    function genericPointerToWireType(destructors, handle) {
      var ptr
      if (handle === null) {
        if (this.isReference) {
          throwBindingError(`null is not a valid ${this.name}`)
        }
        if (this.isSmartPointer) {
          ptr = this.rawConstructor()
          if (destructors !== null) {
            destructors.push(this.rawDestructor, ptr)
          }
          return ptr
        } else {
          return 0
        }
      }
      if (!handle.$$) {
        throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`)
      }
      if (!handle.$$.ptr) {
        throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`)
      }
      if (!this.isConst && handle.$$.ptrType.isConst) {
        throwBindingError(
          `Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`
        )
      }
      var handleClass = handle.$$.ptrType.registeredClass
      ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass)
      if (this.isSmartPointer) {
        if (undefined === handle.$$.smartPtr) {
          throwBindingError('Passing raw pointer to smart pointer is illegal')
        }
        switch (this.sharingPolicy) {
          case 0:
            if (handle.$$.smartPtrType === this) {
              ptr = handle.$$.smartPtr
            } else {
              throwBindingError(
                `Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`
              )
            }
            break
          case 1:
            ptr = handle.$$.smartPtr
            break
          case 2:
            if (handle.$$.smartPtrType === this) {
              ptr = handle.$$.smartPtr
            } else {
              var clonedHandle = handle['clone']()
              ptr = this.rawShare(
                ptr,
                Emval.toHandle(() => clonedHandle['delete']())
              )
              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr)
              }
            }
            break
          default:
            throwBindingError('Unsupporting sharing policy')
        }
      }
      return ptr
    }
    function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
      if (handle === null) {
        if (this.isReference) {
          throwBindingError(`null is not a valid ${this.name}`)
        }
        return 0
      }
      if (!handle.$$) {
        throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`)
      }
      if (!handle.$$.ptr) {
        throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`)
      }
      if (handle.$$.ptrType.isConst) {
        throwBindingError(
          `Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`
        )
      }
      var handleClass = handle.$$.ptrType.registeredClass
      var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass)
      return ptr
    }
    function readPointer(pointer) {
      return this['fromWireType'](GROWABLE_HEAP_U32()[pointer >> 2])
    }
    var init_RegisteredPointer = () => {
      Object.assign(RegisteredPointer.prototype, {
        getPointee(ptr) {
          if (this.rawGetPointee) {
            ptr = this.rawGetPointee(ptr)
          }
          return ptr
        },
        destructor(ptr) {
          if (this.rawDestructor) {
            this.rawDestructor(ptr)
          }
        },
        argPackAdvance: GenericWireTypeSize,
        readValueFromPointer: readPointer,
        deleteObject(handle) {
          if (handle !== null) {
            handle['delete']()
          }
        },
        fromWireType: RegisteredPointer_fromWireType
      })
    }
    function RegisteredPointer(
      name,
      registeredClass,
      isReference,
      isConst,
      isSmartPointer,
      pointeeType,
      sharingPolicy,
      rawGetPointee,
      rawConstructor,
      rawShare,
      rawDestructor
    ) {
      this.name = name
      this.registeredClass = registeredClass
      this.isReference = isReference
      this.isConst = isConst
      this.isSmartPointer = isSmartPointer
      this.pointeeType = pointeeType
      this.sharingPolicy = sharingPolicy
      this.rawGetPointee = rawGetPointee
      this.rawConstructor = rawConstructor
      this.rawShare = rawShare
      this.rawDestructor = rawDestructor
      if (!isSmartPointer && registeredClass.baseClass === undefined) {
        if (isConst) {
          this['toWireType'] = constNoSmartPtrRawPointerToWireType
          this.destructorFunction = null
        } else {
          this['toWireType'] = nonConstNoSmartPtrRawPointerToWireType
          this.destructorFunction = null
        }
      } else {
        this['toWireType'] = genericPointerToWireType
      }
    }
    var replacePublicSymbol = (name, value, numArguments) => {
      if (!Module.hasOwnProperty(name)) {
        throwInternalError('Replacing nonexistant public symbol')
      }
      if (undefined !== Module[name].overloadTable && undefined !== numArguments) {
        Module[name].overloadTable[numArguments] = value
      } else {
        Module[name] = value
        Module[name].argCount = numArguments
      }
    }
    var dynCallLegacy = (sig, ptr, args) => {
      var f = Module['dynCall_' + sig]
      return args && args.length ? f.apply(null, [ptr].concat(args)) : f.call(null, ptr)
    }
    var wasmTable
    var dynCall = (sig, ptr, args) => {
      var rtn = dynCallLegacy(sig, ptr, args)
      return rtn
    }
    var getDynCaller = (sig, ptr) => {
      var argCache = []
      return function () {
        argCache.length = 0
        Object.assign(argCache, arguments)
        return dynCall(sig, ptr, argCache)
      }
    }
    var embind__requireFunction = (signature, rawFunction) => {
      signature = readLatin1String(signature)
      function makeDynCaller() {
        return getDynCaller(signature, rawFunction)
      }
      var fp = makeDynCaller()
      if (typeof fp != 'function') {
        throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`)
      }
      return fp
    }
    var extendError = (baseErrorType, errorName) => {
      var errorClass = createNamedFunction(errorName, function (message) {
        this.name = errorName
        this.message = message
        var stack = new Error(message).stack
        if (stack !== undefined) {
          this.stack = this.toString() + '\n' + stack.replace(/^Error(:[^\n]*)?\n/, '')
        }
      })
      errorClass.prototype = Object.create(baseErrorType.prototype)
      errorClass.prototype.constructor = errorClass
      errorClass.prototype.toString = function () {
        if (this.message === undefined) {
          return this.name
        } else {
          return `${this.name}: ${this.message}`
        }
      }
      return errorClass
    }
    var UnboundTypeError
    var getTypeName = (type) => {
      var ptr = ___getTypeName(type)
      var rv = readLatin1String(ptr)
      _free(ptr)
      return rv
    }
    var throwUnboundTypeError = (message, types) => {
      var unboundTypes = []
      var seen = {}
      function visit(type) {
        if (seen[type]) {
          return
        }
        if (registeredTypes[type]) {
          return
        }
        if (typeDependencies[type]) {
          typeDependencies[type].forEach(visit)
          return
        }
        unboundTypes.push(type)
        seen[type] = true
      }
      types.forEach(visit)
      throw new UnboundTypeError(`${message}: ` + unboundTypes.map(getTypeName).join([', ']))
    }
    var __embind_register_class = (
      rawType,
      rawPointerType,
      rawConstPointerType,
      baseClassRawType,
      getActualTypeSignature,
      getActualType,
      upcastSignature,
      upcast,
      downcastSignature,
      downcast,
      name,
      destructorSignature,
      rawDestructor
    ) => {
      name = readLatin1String(name)
      getActualType = embind__requireFunction(getActualTypeSignature, getActualType)
      if (upcast) {
        upcast = embind__requireFunction(upcastSignature, upcast)
      }
      if (downcast) {
        downcast = embind__requireFunction(downcastSignature, downcast)
      }
      rawDestructor = embind__requireFunction(destructorSignature, rawDestructor)
      var legalFunctionName = makeLegalFunctionName(name)
      exposePublicSymbol(legalFunctionName, function () {
        throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [baseClassRawType])
      })
      whenDependentTypesAreResolved(
        [rawType, rawPointerType, rawConstPointerType],
        baseClassRawType ? [baseClassRawType] : [],
        function (base) {
          base = base[0]
          var baseClass
          var basePrototype
          if (baseClassRawType) {
            baseClass = base.registeredClass
            basePrototype = baseClass.instancePrototype
          } else {
            basePrototype = ClassHandle.prototype
          }
          var constructor = createNamedFunction(legalFunctionName, function () {
            if (Object.getPrototypeOf(this) !== instancePrototype) {
              throw new BindingError("Use 'new' to construct " + name)
            }
            if (undefined === registeredClass.constructor_body) {
              throw new BindingError(name + ' has no accessible constructor')
            }
            var body = registeredClass.constructor_body[arguments.length]
            if (undefined === body) {
              throw new BindingError(
                `Tried to invoke ctor of ${name} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`
              )
            }
            return body.apply(this, arguments)
          })
          var instancePrototype = Object.create(basePrototype, {
            constructor: { value: constructor }
          })
          constructor.prototype = instancePrototype
          var registeredClass = new RegisteredClass(
            name,
            constructor,
            instancePrototype,
            rawDestructor,
            baseClass,
            getActualType,
            upcast,
            downcast
          )
          if (registeredClass.baseClass) {
            if (registeredClass.baseClass.__derivedClasses === undefined) {
              registeredClass.baseClass.__derivedClasses = []
            }
            registeredClass.baseClass.__derivedClasses.push(registeredClass)
          }
          var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false)
          var pointerConverter = new RegisteredPointer(
            name + '*',
            registeredClass,
            false,
            false,
            false
          )
          var constPointerConverter = new RegisteredPointer(
            name + ' const*',
            registeredClass,
            false,
            true,
            false
          )
          registeredPointers[rawType] = {
            pointerType: pointerConverter,
            constPointerType: constPointerConverter
          }
          replacePublicSymbol(legalFunctionName, constructor)
          return [referenceConverter, pointerConverter, constPointerConverter]
        }
      )
    }
    var heap32VectorToArray = (count, firstElement) => {
      var array = []
      for (var i = 0; i < count; i++) {
        array.push(GROWABLE_HEAP_U32()[(firstElement + i * 4) >> 2])
      }
      return array
    }
    var runDestructors = (destructors) => {
      while (destructors.length) {
        var ptr = destructors.pop()
        var del = destructors.pop()
        del(ptr)
      }
    }
    var runAndAbortIfError = (func) => {
      try {
        return func()
      } catch (e) {
        abort(e)
      }
    }
    var maybeExit = () => {
      if (!keepRuntimeAlive()) {
        try {
          if (ENVIRONMENT_IS_PTHREAD) __emscripten_thread_exit(EXITSTATUS)
          else _exit(EXITSTATUS)
        } catch (e) {
          handleException(e)
        }
      }
    }
    var callUserCallback = (func) => {
      if (ABORT) {
        return
      }
      try {
        func()
        maybeExit()
      } catch (e) {
        handleException(e)
      }
    }
    var runtimeKeepalivePush = () => {
      runtimeKeepaliveCounter += 1
    }
    var runtimeKeepalivePop = () => {
      runtimeKeepaliveCounter -= 1
    }
    var Asyncify = {
      instrumentWasmImports(imports) {
        var importPattern = /^(invoke_.*|__asyncjs__.*)$/
        for (var x in imports) {
          (function (x) {
            var original = imports[x]
            var sig = original.sig
            if (typeof original == 'function') {
              var isAsyncifyImport = original.isAsync || importPattern.test(x)
            }
          })(x)
        }
      },
      instrumentWasmExports(exports) {
        var ret = {}
        for (var x in exports) {
          (function (x) {
            var original = exports[x]
            if (typeof original == 'function') {
              ret[x] = function () {
                Asyncify.exportCallStack.push(x)
                try {
                  return original.apply(null, arguments)
                } finally {
                  if (!ABORT) {
                    var y = Asyncify.exportCallStack.pop()
                    assert(y === x)
                    Asyncify.maybeStopUnwind()
                  }
                }
              }
            } else {
              ret[x] = original
            }
          })(x)
        }
        return ret
      },
      State: { Normal: 0, Unwinding: 1, Rewinding: 2, Disabled: 3 },
      state: 0,
      StackSize: 4096,
      currData: null,
      handleSleepReturnValue: 0,
      exportCallStack: [],
      callStackNameToId: {},
      callStackIdToName: {},
      callStackId: 0,
      asyncPromiseHandlers: null,
      sleepCallbacks: [],
      getCallStackId(funcName) {
        var id = Asyncify.callStackNameToId[funcName]
        if (id === undefined) {
          id = Asyncify.callStackId++
          Asyncify.callStackNameToId[funcName] = id
          Asyncify.callStackIdToName[id] = funcName
        }
        return id
      },
      maybeStopUnwind() {
        if (
          Asyncify.currData &&
          Asyncify.state === Asyncify.State.Unwinding &&
          Asyncify.exportCallStack.length === 0
        ) {
          Asyncify.state = Asyncify.State.Normal
          runtimeKeepalivePush()
          runAndAbortIfError(_asyncify_stop_unwind)
          if (typeof Fibers != 'undefined') {
            Fibers.trampoline()
          }
        }
      },
      whenDone() {
        return new Promise((resolve, reject) => {
          Asyncify.asyncPromiseHandlers = { resolve: resolve, reject: reject }
        })
      },
      allocateData() {
        var ptr = _malloc(12 + Asyncify.StackSize)
        Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize)
        Asyncify.setDataRewindFunc(ptr)
        return ptr
      },
      setDataHeader(ptr, stack, stackSize) {
        GROWABLE_HEAP_U32()[ptr >> 2] = stack
        GROWABLE_HEAP_U32()[(ptr + 4) >> 2] = stack + stackSize
      },
      setDataRewindFunc(ptr) {
        var bottomOfCallStack = Asyncify.exportCallStack[0]
        var rewindId = Asyncify.getCallStackId(bottomOfCallStack)
        GROWABLE_HEAP_I32()[(ptr + 8) >> 2] = rewindId
      },
      getDataRewindFunc(ptr) {
        var id = GROWABLE_HEAP_I32()[(ptr + 8) >> 2]
        var name = Asyncify.callStackIdToName[id]
        var func = wasmExports[name]
        return func
      },
      doRewind(ptr) {
        var start = Asyncify.getDataRewindFunc(ptr)
        runtimeKeepalivePop()
        return start()
      },
      handleSleep(startAsync) {
        if (ABORT) return
        if (Asyncify.state === Asyncify.State.Normal) {
          var reachedCallback = false
          var reachedAfterCallback = false
          startAsync((handleSleepReturnValue = 0) => {
            if (ABORT) return
            Asyncify.handleSleepReturnValue = handleSleepReturnValue
            reachedCallback = true
            if (!reachedAfterCallback) {
              return
            }
            Asyncify.state = Asyncify.State.Rewinding
            runAndAbortIfError(() => _asyncify_start_rewind(Asyncify.currData))
            if (typeof Browser != 'undefined' && Browser.mainLoop.func) {
              Browser.mainLoop.resume()
            }
            var asyncWasmReturnValue,
              isError = false
            try {
              asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData)
            } catch (err) {
              asyncWasmReturnValue = err
              isError = true
            }
            var handled = false
            if (!Asyncify.currData) {
              var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers
              if (asyncPromiseHandlers) {
                Asyncify.asyncPromiseHandlers = null
                ;(isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(
                  asyncWasmReturnValue
                )
                handled = true
              }
            }
            if (isError && !handled) {
              throw asyncWasmReturnValue
            }
          })
          reachedAfterCallback = true
          if (!reachedCallback) {
            Asyncify.state = Asyncify.State.Unwinding
            Asyncify.currData = Asyncify.allocateData()
            if (typeof Browser != 'undefined' && Browser.mainLoop.func) {
              Browser.mainLoop.pause()
            }
            runAndAbortIfError(() => _asyncify_start_unwind(Asyncify.currData))
          }
        } else if (Asyncify.state === Asyncify.State.Rewinding) {
          Asyncify.state = Asyncify.State.Normal
          runAndAbortIfError(_asyncify_stop_rewind)
          _free(Asyncify.currData)
          Asyncify.currData = null
          Asyncify.sleepCallbacks.forEach((func) => callUserCallback(func))
        } else {
          abort(`invalid state: ${Asyncify.state}`)
        }
        return Asyncify.handleSleepReturnValue
      },
      handleAsync(startAsync) {
        return Asyncify.handleSleep((wakeUp) => {
          startAsync().then(wakeUp)
        })
      }
    }
    function craftInvokerFunction(
      humanName,
      argTypes,
      classType,
      cppInvokerFunc,
      cppTargetFunc,
      isAsync
    ) {
      var argCount = argTypes.length
      if (argCount < 2) {
        throwBindingError(
          "argTypes array size mismatch! Must at least get return value and 'this' types!"
        )
      }
      var isClassMethodFunc = argTypes[1] !== null && classType !== null
      var needsDestructorStack = false
      for (var i = 1; i < argTypes.length; ++i) {
        if (argTypes[i] !== null && argTypes[i].destructorFunction === undefined) {
          needsDestructorStack = true
          break
        }
      }
      var returns = argTypes[0].name !== 'void'
      var expectedArgCount = argCount - 2
      var argsWired = new Array(expectedArgCount)
      var invokerFuncArgs = []
      var destructors = []
      return function () {
        if (arguments.length !== expectedArgCount) {
          throwBindingError(
            `function ${humanName} called with ${arguments.length} arguments, expected ${expectedArgCount}`
          )
        }
        destructors.length = 0
        var thisWired
        invokerFuncArgs.length = isClassMethodFunc ? 2 : 1
        invokerFuncArgs[0] = cppTargetFunc
        if (isClassMethodFunc) {
          thisWired = argTypes[1]['toWireType'](destructors, this)
          invokerFuncArgs[1] = thisWired
        }
        for (var i = 0; i < expectedArgCount; ++i) {
          argsWired[i] = argTypes[i + 2]['toWireType'](destructors, arguments[i])
          invokerFuncArgs.push(argsWired[i])
        }
        var rv = cppInvokerFunc.apply(null, invokerFuncArgs)
        function onDone(rv) {
          if (needsDestructorStack) {
            runDestructors(destructors)
          } else {
            for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; i++) {
              var param = i === 1 ? thisWired : argsWired[i - 2]
              if (argTypes[i].destructorFunction !== null) {
                argTypes[i].destructorFunction(param)
              }
            }
          }
          if (returns) {
            return argTypes[0]['fromWireType'](rv)
          }
        }
        if (Asyncify.currData) {
          return Asyncify.whenDone().then(onDone)
        }
        return onDone(rv)
      }
    }
    var __embind_register_class_constructor = (
      rawClassType,
      argCount,
      rawArgTypesAddr,
      invokerSignature,
      invoker,
      rawConstructor
    ) => {
      var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr)
      invoker = embind__requireFunction(invokerSignature, invoker)
      whenDependentTypesAreResolved([], [rawClassType], function (classType) {
        classType = classType[0]
        var humanName = `constructor ${classType.name}`
        if (undefined === classType.registeredClass.constructor_body) {
          classType.registeredClass.constructor_body = []
        }
        if (undefined !== classType.registeredClass.constructor_body[argCount - 1]) {
          throw new BindingError(
            `Cannot register multiple constructors with identical number of parameters (${argCount - 1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`
          )
        }
        classType.registeredClass.constructor_body[argCount - 1] = () => {
          throwUnboundTypeError(
            `Cannot construct ${classType.name} due to unbound types`,
            rawArgTypes
          )
        }
        whenDependentTypesAreResolved([], rawArgTypes, (argTypes) => {
          argTypes.splice(1, 0, null)
          classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(
            humanName,
            argTypes,
            null,
            invoker,
            rawConstructor
          )
          return []
        })
        return []
      })
    }
    var getFunctionName = (signature) => {
      signature = signature.trim()
      const argsIndex = signature.indexOf('(')
      if (argsIndex !== -1) {
        assert(
          signature[signature.length - 1] == ')',
          'Parentheses for argument names should match.'
        )
        return signature.substr(0, argsIndex)
      } else {
        return signature
      }
    }
    var __embind_register_class_function = (
      rawClassType,
      methodName,
      argCount,
      rawArgTypesAddr,
      invokerSignature,
      rawInvoker,
      context,
      isPureVirtual,
      isAsync
    ) => {
      var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr)
      methodName = readLatin1String(methodName)
      methodName = getFunctionName(methodName)
      rawInvoker = embind__requireFunction(invokerSignature, rawInvoker)
      whenDependentTypesAreResolved([], [rawClassType], function (classType) {
        classType = classType[0]
        var humanName = `${classType.name}.${methodName}`
        if (methodName.startsWith('@@')) {
          methodName = Symbol[methodName.substring(2)]
        }
        if (isPureVirtual) {
          classType.registeredClass.pureVirtualFunctions.push(methodName)
        }
        function unboundTypesHandler() {
          throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes)
        }
        var proto = classType.registeredClass.instancePrototype
        var method = proto[methodName]
        if (
          undefined === method ||
          (undefined === method.overloadTable &&
            method.className !== classType.name &&
            method.argCount === argCount - 2)
        ) {
          unboundTypesHandler.argCount = argCount - 2
          unboundTypesHandler.className = classType.name
          proto[methodName] = unboundTypesHandler
        } else {
          ensureOverloadTable(proto, methodName, humanName)
          proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler
        }
        whenDependentTypesAreResolved([], rawArgTypes, function (argTypes) {
          var memberFunction = craftInvokerFunction(
            humanName,
            argTypes,
            classType,
            rawInvoker,
            context,
            isAsync
          )
          if (undefined === proto[methodName].overloadTable) {
            memberFunction.argCount = argCount - 2
            proto[methodName] = memberFunction
          } else {
            proto[methodName].overloadTable[argCount - 2] = memberFunction
          }
          return []
        })
        return []
      })
    }
    function handleAllocatorInit() {
      Object.assign(HandleAllocator.prototype, {
        get(id) {
          return this.allocated[id]
        },
        has(id) {
          return this.allocated[id] !== undefined
        },
        allocate(handle) {
          var id = this.freelist.pop() || this.allocated.length
          this.allocated[id] = handle
          return id
        },
        free(id) {
          this.allocated[id] = undefined
          this.freelist.push(id)
        }
      })
    }
    function HandleAllocator() {
      this.allocated = [undefined]
      this.freelist = []
    }
    var emval_handles = new HandleAllocator()
    var __emval_decref = (handle) => {
      if (handle >= emval_handles.reserved && 0 === --emval_handles.get(handle).refcount) {
        emval_handles.free(handle)
      }
    }
    var count_emval_handles = () => {
      var count = 0
      for (var i = emval_handles.reserved; i < emval_handles.allocated.length; ++i) {
        if (emval_handles.allocated[i] !== undefined) {
          ++count
        }
      }
      return count
    }
    var init_emval = () => {
      emval_handles.allocated.push(
        { value: undefined },
        { value: null },
        { value: true },
        { value: false }
      )
      emval_handles.reserved = emval_handles.allocated.length
      Module['count_emval_handles'] = count_emval_handles
    }
    var Emval = {
      toValue: (handle) => {
        if (!handle) {
          throwBindingError('Cannot use deleted val. handle = ' + handle)
        }
        return emval_handles.get(handle).value
      },
      toHandle: (value) => {
        switch (value) {
          case undefined:
            return 1
          case null:
            return 2
          case true:
            return 3
          case false:
            return 4
          default: {
            return emval_handles.allocate({ refcount: 1, value: value })
          }
        }
      }
    }
    function simpleReadValueFromPointer(pointer) {
      return this['fromWireType'](GROWABLE_HEAP_I32()[pointer >> 2])
    }
    var __embind_register_emval = (rawType, name) => {
      name = readLatin1String(name)
      registerType(rawType, {
        name: name,
        fromWireType: (handle) => {
          var rv = Emval.toValue(handle)
          __emval_decref(handle)
          return rv
        },
        toWireType: (destructors, value) => Emval.toHandle(value),
        argPackAdvance: GenericWireTypeSize,
        readValueFromPointer: simpleReadValueFromPointer,
        destructorFunction: null
      })
    }
    var embindRepr = (v) => {
      if (v === null) {
        return 'null'
      }
      var t = typeof v
      if (t === 'object' || t === 'array' || t === 'function') {
        return v.toString()
      } else {
        return '' + v
      }
    }
    var floatReadValueFromPointer = (name, width) => {
      switch (width) {
        case 4:
          return function (pointer) {
            return this['fromWireType'](GROWABLE_HEAP_F32()[pointer >> 2])
          }
        case 8:
          return function (pointer) {
            return this['fromWireType'](GROWABLE_HEAP_F64()[pointer >> 3])
          }
        default:
          throw new TypeError(`invalid float width (${width}): ${name}`)
      }
    }
    var __embind_register_float = (rawType, name, size) => {
      name = readLatin1String(name)
      registerType(rawType, {
        name: name,
        fromWireType: (value) => value,
        toWireType: (destructors, value) => value,
        argPackAdvance: GenericWireTypeSize,
        readValueFromPointer: floatReadValueFromPointer(name, size),
        destructorFunction: null
      })
    }
    var integerReadValueFromPointer = (name, width, signed) => {
      switch (width) {
        case 1:
          return signed
            ? (pointer) => GROWABLE_HEAP_I8()[pointer >> 0]
            : (pointer) => GROWABLE_HEAP_U8()[pointer >> 0]
        case 2:
          return signed
            ? (pointer) => GROWABLE_HEAP_I16()[pointer >> 1]
            : (pointer) => GROWABLE_HEAP_U16()[pointer >> 1]
        case 4:
          return signed
            ? (pointer) => GROWABLE_HEAP_I32()[pointer >> 2]
            : (pointer) => GROWABLE_HEAP_U32()[pointer >> 2]
        default:
          throw new TypeError(`invalid integer width (${width}): ${name}`)
      }
    }
    var __embind_register_integer = (primitiveType, name, size, minRange, maxRange) => {
      name = readLatin1String(name)
      if (maxRange === -1) {
        maxRange = 4294967295
      }
      var fromWireType = (value) => value
      if (minRange === 0) {
        var bitshift = 32 - 8 * size
        fromWireType = (value) => (value << bitshift) >>> bitshift
      }
      var isUnsignedType = name.includes('unsigned')
      var checkAssertions = (value, toTypeName) => {}
      var toWireType
      if (isUnsignedType) {
        toWireType = function (destructors, value) {
          checkAssertions(value, this.name)
          return value >>> 0
        }
      } else {
        toWireType = function (destructors, value) {
          checkAssertions(value, this.name)
          return value
        }
      }
      registerType(primitiveType, {
        name: name,
        fromWireType: fromWireType,
        toWireType: toWireType,
        argPackAdvance: GenericWireTypeSize,
        readValueFromPointer: integerReadValueFromPointer(name, size, minRange !== 0),
        destructorFunction: null
      })
    }
    var __embind_register_memory_view = (rawType, dataTypeIndex, name) => {
      var typeMapping = [
        Int8Array,
        Uint8Array,
        Int16Array,
        Uint16Array,
        Int32Array,
        Uint32Array,
        Float32Array,
        Float64Array
      ]
      var TA = typeMapping[dataTypeIndex]
      function decodeMemoryView(handle) {
        var size = GROWABLE_HEAP_U32()[handle >> 2]
        var data = GROWABLE_HEAP_U32()[(handle + 4) >> 2]
        return new TA(GROWABLE_HEAP_I8().buffer, data, size)
      }
      name = readLatin1String(name)
      registerType(
        rawType,
        {
          name: name,
          fromWireType: decodeMemoryView,
          argPackAdvance: GenericWireTypeSize,
          readValueFromPointer: decodeMemoryView
        },
        { ignoreDuplicateRegistrations: true }
      )
    }
    var stringToUTF8 = (str, outPtr, maxBytesToWrite) =>
      stringToUTF8Array(str, GROWABLE_HEAP_U8(), outPtr, maxBytesToWrite)
    var __embind_register_std_string = (rawType, name) => {
      name = readLatin1String(name)
      var stdStringIsUTF8 = name === 'std::string'
      registerType(rawType, {
        name: name,
        fromWireType(value) {
          var length = GROWABLE_HEAP_U32()[value >> 2]
          var payload = value + 4
          var str
          if (stdStringIsUTF8) {
            var decodeStartPtr = payload
            for (var i = 0; i <= length; ++i) {
              var currentBytePtr = payload + i
              if (i == length || GROWABLE_HEAP_U8()[currentBytePtr] == 0) {
                var maxRead = currentBytePtr - decodeStartPtr
                var stringSegment = UTF8ToString(decodeStartPtr, maxRead)
                if (str === undefined) {
                  str = stringSegment
                } else {
                  str += String.fromCharCode(0)
                  str += stringSegment
                }
                decodeStartPtr = currentBytePtr + 1
              }
            }
          } else {
            var a = new Array(length)
            for (var i = 0; i < length; ++i) {
              a[i] = String.fromCharCode(GROWABLE_HEAP_U8()[payload + i])
            }
            str = a.join('')
          }
          _free(value)
          return str
        },
        toWireType(destructors, value) {
          if (value instanceof ArrayBuffer) {
            value = new Uint8Array(value)
          }
          var length
          var valueIsOfTypeString = typeof value == 'string'
          if (
            !(
              valueIsOfTypeString ||
              value instanceof Uint8Array ||
              value instanceof Uint8ClampedArray ||
              value instanceof Int8Array
            )
          ) {
            throwBindingError('Cannot pass non-string to std::string')
          }
          if (stdStringIsUTF8 && valueIsOfTypeString) {
            length = lengthBytesUTF8(value)
          } else {
            length = value.length
          }
          var base = _malloc(4 + length + 1)
          var ptr = base + 4
          GROWABLE_HEAP_U32()[base >> 2] = length
          if (stdStringIsUTF8 && valueIsOfTypeString) {
            stringToUTF8(value, ptr, length + 1)
          } else {
            if (valueIsOfTypeString) {
              for (var i = 0; i < length; ++i) {
                var charCode = value.charCodeAt(i)
                if (charCode > 255) {
                  _free(ptr)
                  throwBindingError('String has UTF-16 code units that do not fit in 8 bits')
                }
                GROWABLE_HEAP_U8()[ptr + i] = charCode
              }
            } else {
              for (var i = 0; i < length; ++i) {
                GROWABLE_HEAP_U8()[ptr + i] = value[i]
              }
            }
          }
          if (destructors !== null) {
            destructors.push(_free, base)
          }
          return base
        },
        argPackAdvance: GenericWireTypeSize,
        readValueFromPointer: readPointer,
        destructorFunction(ptr) {
          _free(ptr)
        }
      })
    }
    var UTF16Decoder = typeof TextDecoder != 'undefined' ? new TextDecoder('utf-16le') : undefined
    var UTF16ToString = (ptr, maxBytesToRead) => {
      var endPtr = ptr
      var idx = endPtr >> 1
      var maxIdx = idx + maxBytesToRead / 2
      while (!(idx >= maxIdx) && GROWABLE_HEAP_U16()[idx]) ++idx
      endPtr = idx << 1
      if (endPtr - ptr > 32 && UTF16Decoder)
        return UTF16Decoder.decode(GROWABLE_HEAP_U8().slice(ptr, endPtr))
      var str = ''
      for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
        var codeUnit = GROWABLE_HEAP_I16()[(ptr + i * 2) >> 1]
        if (codeUnit == 0) break
        str += String.fromCharCode(codeUnit)
      }
      return str
    }
    var stringToUTF16 = (str, outPtr, maxBytesToWrite) => {
      if (maxBytesToWrite === undefined) {
        maxBytesToWrite = 2147483647
      }
      if (maxBytesToWrite < 2) return 0
      maxBytesToWrite -= 2
      var startPtr = outPtr
      var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length
      for (var i = 0; i < numCharsToWrite; ++i) {
        var codeUnit = str.charCodeAt(i)
        GROWABLE_HEAP_I16()[outPtr >> 1] = codeUnit
        outPtr += 2
      }
      GROWABLE_HEAP_I16()[outPtr >> 1] = 0
      return outPtr - startPtr
    }
    var lengthBytesUTF16 = (str) => str.length * 2
    var UTF32ToString = (ptr, maxBytesToRead) => {
      var i = 0
      var str = ''
      while (!(i >= maxBytesToRead / 4)) {
        var utf32 = GROWABLE_HEAP_I32()[(ptr + i * 4) >> 2]
        if (utf32 == 0) break
        ++i
        if (utf32 >= 65536) {
          var ch = utf32 - 65536
          str += String.fromCharCode(55296 | (ch >> 10), 56320 | (ch & 1023))
        } else {
          str += String.fromCharCode(utf32)
        }
      }
      return str
    }
    var stringToUTF32 = (str, outPtr, maxBytesToWrite) => {
      if (maxBytesToWrite === undefined) {
        maxBytesToWrite = 2147483647
      }
      if (maxBytesToWrite < 4) return 0
      var startPtr = outPtr
      var endPtr = startPtr + maxBytesToWrite - 4
      for (var i = 0; i < str.length; ++i) {
        var codeUnit = str.charCodeAt(i)
        if (codeUnit >= 55296 && codeUnit <= 57343) {
          var trailSurrogate = str.charCodeAt(++i)
          codeUnit = (65536 + ((codeUnit & 1023) << 10)) | (trailSurrogate & 1023)
        }
        GROWABLE_HEAP_I32()[outPtr >> 2] = codeUnit
        outPtr += 4
        if (outPtr + 4 > endPtr) break
      }
      GROWABLE_HEAP_I32()[outPtr >> 2] = 0
      return outPtr - startPtr
    }
    var lengthBytesUTF32 = (str) => {
      var len = 0
      for (var i = 0; i < str.length; ++i) {
        var codeUnit = str.charCodeAt(i)
        if (codeUnit >= 55296 && codeUnit <= 57343) ++i
        len += 4
      }
      return len
    }
    var __embind_register_std_wstring = (rawType, charSize, name) => {
      name = readLatin1String(name)
      var decodeString, encodeString, getHeap, lengthBytesUTF, shift
      if (charSize === 2) {
        decodeString = UTF16ToString
        encodeString = stringToUTF16
        lengthBytesUTF = lengthBytesUTF16
        getHeap = () => GROWABLE_HEAP_U16()
        shift = 1
      } else if (charSize === 4) {
        decodeString = UTF32ToString
        encodeString = stringToUTF32
        lengthBytesUTF = lengthBytesUTF32
        getHeap = () => GROWABLE_HEAP_U32()
        shift = 2
      }
      registerType(rawType, {
        name: name,
        fromWireType: (value) => {
          var length = GROWABLE_HEAP_U32()[value >> 2]
          var HEAP = getHeap()
          var str
          var decodeStartPtr = value + 4
          for (var i = 0; i <= length; ++i) {
            var currentBytePtr = value + 4 + i * charSize
            if (i == length || HEAP[currentBytePtr >> shift] == 0) {
              var maxReadBytes = currentBytePtr - decodeStartPtr
              var stringSegment = decodeString(decodeStartPtr, maxReadBytes)
              if (str === undefined) {
                str = stringSegment
              } else {
                str += String.fromCharCode(0)
                str += stringSegment
              }
              decodeStartPtr = currentBytePtr + charSize
            }
          }
          _free(value)
          return str
        },
        toWireType: (destructors, value) => {
          if (!(typeof value == 'string')) {
            throwBindingError(`Cannot pass non-string to C++ string type ${name}`)
          }
          var length = lengthBytesUTF(value)
          var ptr = _malloc(4 + length + charSize)
          GROWABLE_HEAP_U32()[ptr >> 2] = length >> shift
          encodeString(value, ptr + 4, length + charSize)
          if (destructors !== null) {
            destructors.push(_free, ptr)
          }
          return ptr
        },
        argPackAdvance: GenericWireTypeSize,
        readValueFromPointer: simpleReadValueFromPointer,
        destructorFunction(ptr) {
          _free(ptr)
        }
      })
    }
    var __embind_register_void = (rawType, name) => {
      name = readLatin1String(name)
      registerType(rawType, {
        isVoid: true,
        name: name,
        argPackAdvance: 0,
        fromWireType: () => undefined,
        toWireType: (destructors, o) => undefined
      })
    }
    var nowIsMonotonic = true
    var __emscripten_get_now_is_monotonic = () => nowIsMonotonic
    var __emscripten_thread_mailbox_await = (pthread_ptr) => {
      if (typeof Atomics.waitAsync === 'function') {
        var wait = Atomics.waitAsync(GROWABLE_HEAP_I32(), pthread_ptr >> 2, pthread_ptr)
        wait.value.then(checkMailbox)
        var waitingAsync = pthread_ptr + 128
        Atomics.store(GROWABLE_HEAP_I32(), waitingAsync >> 2, 1)
      }
    }
    Module['__emscripten_thread_mailbox_await'] = __emscripten_thread_mailbox_await
    var checkMailbox = () => {
      var pthread_ptr = _pthread_self()
      if (pthread_ptr) {
        __emscripten_thread_mailbox_await(pthread_ptr)
        callUserCallback(() => __emscripten_check_mailbox())
      }
    }
    Module['checkMailbox'] = checkMailbox
    var __emscripten_notify_mailbox_postmessage = (targetThreadId, currThreadId, mainThreadId) => {
      if (targetThreadId == currThreadId) {
        setTimeout(() => checkMailbox())
      } else if (ENVIRONMENT_IS_PTHREAD) {
        postMessage({ targetThread: targetThreadId, cmd: 'checkMailbox' })
      } else {
        var worker = PThread.pthreads[targetThreadId]
        if (!worker) {
          return
        }
        worker.postMessage({ cmd: 'checkMailbox' })
      }
    }
    var withStackSave = (f) => {
      var stack = stackSave()
      var ret = f()
      stackRestore(stack)
      return ret
    }
    var proxyToMainThread = function (index, sync) {
      var numCallArgs = arguments.length - 2
      var outerArgs = arguments
      return withStackSave(() => {
        var serializedNumCallArgs = numCallArgs
        var args = stackAlloc(serializedNumCallArgs * 8)
        var b = args >> 3
        for (var i = 0; i < numCallArgs; i++) {
          var arg = outerArgs[2 + i]
          GROWABLE_HEAP_F64()[b + i] = arg
        }
        return __emscripten_run_on_main_thread_js(index, serializedNumCallArgs, args, sync)
      })
    }
    var proxiedJSCallArgs = []
    var __emscripten_receive_on_main_thread_js = (index, callingThread, numCallArgs, args) => {
      proxiedJSCallArgs.length = numCallArgs
      var b = args >> 3
      for (var i = 0; i < numCallArgs; i++) {
        proxiedJSCallArgs[i] = GROWABLE_HEAP_F64()[b + i]
      }
      var isEmAsmConst = index < 0
      var func = !isEmAsmConst ? proxiedFunctionTable[index] : ASM_CONSTS[-index - 1]
      PThread.currentProxiedOperationCallerThread = callingThread
      var rtn = func.apply(null, proxiedJSCallArgs)
      PThread.currentProxiedOperationCallerThread = 0
      return rtn
    }
    var __emscripten_thread_set_strongref = (thread) => {}
    var requireRegisteredType = (rawType, humanName) => {
      var impl = registeredTypes[rawType]
      if (undefined === impl) {
        throwBindingError(humanName + ' has unknown type ' + getTypeName(rawType))
      }
      return impl
    }
    var __emval_as = (handle, returnType, destructorsRef) => {
      handle = Emval.toValue(handle)
      returnType = requireRegisteredType(returnType, 'emval::as')
      var destructors = []
      var rd = Emval.toHandle(destructors)
      GROWABLE_HEAP_U32()[destructorsRef >> 2] = rd
      return returnType['toWireType'](destructors, handle)
    }
    var __emval_await = (promise) =>
      Asyncify.handleAsync(() => {
        promise = Emval.toValue(promise)
        return promise.then(Emval.toHandle)
      })
    __emval_await.isAsync = true
    var emval_lookupTypes = (argCount, argTypes) => {
      var a = new Array(argCount)
      for (var i = 0; i < argCount; ++i) {
        a[i] = requireRegisteredType(GROWABLE_HEAP_U32()[(argTypes + i * 4) >> 2], 'parameter ' + i)
      }
      return a
    }
    var __emval_call = (handle, argCount, argTypes, argv) => {
      handle = Emval.toValue(handle)
      var types = emval_lookupTypes(argCount, argTypes)
      var args = new Array(argCount)
      for (var i = 0; i < argCount; ++i) {
        var type = types[i]
        args[i] = type['readValueFromPointer'](argv)
        argv += type['argPackAdvance']
      }
      var rv = handle.apply(undefined, args)
      return Emval.toHandle(rv)
    }
    var emval_symbols = {}
    var getStringOrSymbol = (address) => {
      var symbol = emval_symbols[address]
      if (symbol === undefined) {
        return readLatin1String(address)
      }
      return symbol
    }
    var emval_methodCallers = []
    var __emval_call_method = (caller, handle, methodName, destructorsRef, args) => {
      caller = emval_methodCallers[caller]
      handle = Emval.toValue(handle)
      methodName = getStringOrSymbol(methodName)
      var destructors = []
      var result = caller(handle, methodName, destructors, args)
      if (destructors.length) {
        GROWABLE_HEAP_U32()[destructorsRef >> 2] = Emval.toHandle(destructors)
      }
      return result
    }
    var emval_get_global = () => {
      if (typeof globalThis == 'object') {
        return globalThis
      }
      function testGlobal(obj) {
        obj['$$$embind_global$$$'] = obj
        var success = typeof $$$embind_global$$$ == 'object' && obj['$$$embind_global$$$'] == obj
        if (!success) {
          delete obj['$$$embind_global$$$']
        }
        return success
      }
      if (typeof $$$embind_global$$$ == 'object') {
        return $$$embind_global$$$
      }
      if (typeof global == 'object' && testGlobal(global)) {
        $$$embind_global$$$ = global
      } else if (typeof self == 'object' && testGlobal(self)) {
        $$$embind_global$$$ = self
      }
      if (typeof $$$embind_global$$$ == 'object') {
        return $$$embind_global$$$
      }
      throw Error('unable to get global object.')
    }
    var __emval_get_global = (name) => {
      if (name === 0) {
        return Emval.toHandle(emval_get_global())
      } else {
        name = getStringOrSymbol(name)
        return Emval.toHandle(emval_get_global()[name])
      }
    }
    var emval_addMethodCaller = (caller) => {
      var id = emval_methodCallers.length
      emval_methodCallers.push(caller)
      return id
    }
    var __emval_get_method_caller = (argCount, argTypes) => {
      var types = emval_lookupTypes(argCount, argTypes)
      var retType = types.shift()
      argCount--
      var argN = new Array(argCount)
      var invokerFunction = (handle, name, destructors, args) => {
        var offset = 0
        for (var i = 0; i < argCount; ++i) {
          argN[i] = types[i]['readValueFromPointer'](args + offset)
          offset += types[i]['argPackAdvance']
        }
        var rv = handle[name].apply(handle, argN)
        for (var i = 0; i < argCount; ++i) {
          if (types[i].deleteObject) {
            types[i].deleteObject(argN[i])
          }
        }
        return retType['toWireType'](destructors, rv)
      }
      return emval_addMethodCaller(invokerFunction)
    }
    var __emval_get_property = (handle, key) => {
      handle = Emval.toValue(handle)
      key = Emval.toValue(key)
      return Emval.toHandle(handle[key])
    }
    var __emval_incref = (handle) => {
      if (handle > 4) {
        emval_handles.get(handle).refcount += 1
      }
    }
    var __emval_is_string = (handle) => {
      handle = Emval.toValue(handle)
      return typeof handle == 'string'
    }
    var craftEmvalAllocator = (argCount) => {
      var argsList = new Array(argCount + 1)
      return function (constructor, argTypes, args) {
        argsList[0] = constructor
        for (var i = 0; i < argCount; ++i) {
          var argType = requireRegisteredType(
            GROWABLE_HEAP_U32()[(argTypes + i * 4) >> 2],
            'parameter ' + i
          )
          argsList[i + 1] = argType['readValueFromPointer'](args)
          args += argType['argPackAdvance']
        }
        var obj = new (constructor.bind.apply(constructor, argsList))()
        return Emval.toHandle(obj)
      }
    }
    var emval_newers = {}
    var __emval_new = (handle, argCount, argTypes, args) => {
      handle = Emval.toValue(handle)
      var newer = emval_newers[argCount]
      if (!newer) {
        newer = craftEmvalAllocator(argCount)
        emval_newers[argCount] = newer
      }
      return newer(handle, argTypes, args)
    }
    var __emval_new_array = () => Emval.toHandle([])
    var __emval_new_cstring = (v) => Emval.toHandle(getStringOrSymbol(v))
    var __emval_new_object = () => Emval.toHandle({})
    var __emval_run_destructors = (handle) => {
      var destructors = Emval.toValue(handle)
      runDestructors(destructors)
      __emval_decref(handle)
    }
    var __emval_set_property = (handle, key, value) => {
      handle = Emval.toValue(handle)
      key = Emval.toValue(key)
      value = Emval.toValue(value)
      handle[key] = value
    }
    var __emval_take_value = (type, arg) => {
      type = requireRegisteredType(type, '_emval_take_value')
      var v = type['readValueFromPointer'](arg)
      return Emval.toHandle(v)
    }
    function __gmtime_js(time_low, time_high, tmPtr) {
      var time = convertI32PairToI53Checked(time_low, time_high)
      var date = new Date(time * 1e3)
      GROWABLE_HEAP_I32()[tmPtr >> 2] = date.getUTCSeconds()
      GROWABLE_HEAP_I32()[(tmPtr + 4) >> 2] = date.getUTCMinutes()
      GROWABLE_HEAP_I32()[(tmPtr + 8) >> 2] = date.getUTCHours()
      GROWABLE_HEAP_I32()[(tmPtr + 12) >> 2] = date.getUTCDate()
      GROWABLE_HEAP_I32()[(tmPtr + 16) >> 2] = date.getUTCMonth()
      GROWABLE_HEAP_I32()[(tmPtr + 20) >> 2] = date.getUTCFullYear() - 1900
      GROWABLE_HEAP_I32()[(tmPtr + 24) >> 2] = date.getUTCDay()
      var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0)
      var yday = ((date.getTime() - start) / (1e3 * 60 * 60 * 24)) | 0
      GROWABLE_HEAP_I32()[(tmPtr + 28) >> 2] = yday
    }
    var isLeapYear = (year) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)
    var MONTH_DAYS_LEAP_CUMULATIVE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335]
    var MONTH_DAYS_REGULAR_CUMULATIVE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334]
    var ydayFromDate = (date) => {
      var leap = isLeapYear(date.getFullYear())
      var monthDaysCumulative = leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE
      var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1
      return yday
    }
    function __localtime_js(time_low, time_high, tmPtr) {
      var time = convertI32PairToI53Checked(time_low, time_high)
      var date = new Date(time * 1e3)
      GROWABLE_HEAP_I32()[tmPtr >> 2] = date.getSeconds()
      GROWABLE_HEAP_I32()[(tmPtr + 4) >> 2] = date.getMinutes()
      GROWABLE_HEAP_I32()[(tmPtr + 8) >> 2] = date.getHours()
      GROWABLE_HEAP_I32()[(tmPtr + 12) >> 2] = date.getDate()
      GROWABLE_HEAP_I32()[(tmPtr + 16) >> 2] = date.getMonth()
      GROWABLE_HEAP_I32()[(tmPtr + 20) >> 2] = date.getFullYear() - 1900
      GROWABLE_HEAP_I32()[(tmPtr + 24) >> 2] = date.getDay()
      var yday = ydayFromDate(date) | 0
      GROWABLE_HEAP_I32()[(tmPtr + 28) >> 2] = yday
      GROWABLE_HEAP_I32()[(tmPtr + 36) >> 2] = -(date.getTimezoneOffset() * 60)
      var start = new Date(date.getFullYear(), 0, 1)
      var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset()
      var winterOffset = start.getTimezoneOffset()
      var dst =
        (summerOffset != winterOffset &&
          date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0
      GROWABLE_HEAP_I32()[(tmPtr + 32) >> 2] = dst
    }
    var __mktime_js = function (tmPtr) {
      var ret = (() => {
        var date = new Date(
          GROWABLE_HEAP_I32()[(tmPtr + 20) >> 2] + 1900,
          GROWABLE_HEAP_I32()[(tmPtr + 16) >> 2],
          GROWABLE_HEAP_I32()[(tmPtr + 12) >> 2],
          GROWABLE_HEAP_I32()[(tmPtr + 8) >> 2],
          GROWABLE_HEAP_I32()[(tmPtr + 4) >> 2],
          GROWABLE_HEAP_I32()[tmPtr >> 2],
          0
        )
        var dst = GROWABLE_HEAP_I32()[(tmPtr + 32) >> 2]
        var guessedOffset = date.getTimezoneOffset()
        var start = new Date(date.getFullYear(), 0, 1)
        var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset()
        var winterOffset = start.getTimezoneOffset()
        var dstOffset = Math.min(winterOffset, summerOffset)
        if (dst < 0) {
          GROWABLE_HEAP_I32()[(tmPtr + 32) >> 2] = Number(
            summerOffset != winterOffset && dstOffset == guessedOffset
          )
        } else if (dst > 0 != (dstOffset == guessedOffset)) {
          var nonDstOffset = Math.max(winterOffset, summerOffset)
          var trueOffset = dst > 0 ? dstOffset : nonDstOffset
          date.setTime(date.getTime() + (trueOffset - guessedOffset) * 6e4)
        }
        GROWABLE_HEAP_I32()[(tmPtr + 24) >> 2] = date.getDay()
        var yday = ydayFromDate(date) | 0
        GROWABLE_HEAP_I32()[(tmPtr + 28) >> 2] = yday
        GROWABLE_HEAP_I32()[tmPtr >> 2] = date.getSeconds()
        GROWABLE_HEAP_I32()[(tmPtr + 4) >> 2] = date.getMinutes()
        GROWABLE_HEAP_I32()[(tmPtr + 8) >> 2] = date.getHours()
        GROWABLE_HEAP_I32()[(tmPtr + 12) >> 2] = date.getDate()
        GROWABLE_HEAP_I32()[(tmPtr + 16) >> 2] = date.getMonth()
        GROWABLE_HEAP_I32()[(tmPtr + 20) >> 2] = date.getYear()
        return date.getTime() / 1e3
      })()
      return (
        setTempRet0(
          ((tempDouble = ret),
          +Math.abs(tempDouble) >= 1
            ? tempDouble > 0
              ? +Math.floor(tempDouble / 4294967296) >>> 0
              : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
            : 0)
        ),
        ret >>> 0
      )
    }
    var stringToNewUTF8 = (str) => {
      var size = lengthBytesUTF8(str) + 1
      var ret = _malloc(size)
      if (ret) stringToUTF8(str, ret, size)
      return ret
    }
    var __tzset_js = (timezone, daylight, tzname) => {
      var currentYear = new Date().getFullYear()
      var winter = new Date(currentYear, 0, 1)
      var summer = new Date(currentYear, 6, 1)
      var winterOffset = winter.getTimezoneOffset()
      var summerOffset = summer.getTimezoneOffset()
      var stdTimezoneOffset = Math.max(winterOffset, summerOffset)
      GROWABLE_HEAP_U32()[timezone >> 2] = stdTimezoneOffset * 60
      GROWABLE_HEAP_I32()[daylight >> 2] = Number(winterOffset != summerOffset)
      function extractZone(date) {
        var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/)
        return match ? match[1] : 'GMT'
      }
      var winterName = extractZone(winter)
      var summerName = extractZone(summer)
      var winterNamePtr = stringToNewUTF8(winterName)
      var summerNamePtr = stringToNewUTF8(summerName)
      if (summerOffset < winterOffset) {
        GROWABLE_HEAP_U32()[tzname >> 2] = winterNamePtr
        GROWABLE_HEAP_U32()[(tzname + 4) >> 2] = summerNamePtr
      } else {
        GROWABLE_HEAP_U32()[tzname >> 2] = summerNamePtr
        GROWABLE_HEAP_U32()[(tzname + 4) >> 2] = winterNamePtr
      }
    }
    var _abort = () => {
      abort('')
    }
    var readEmAsmArgsArray = []
    var readEmAsmArgs = (sigPtr, buf) => {
      readEmAsmArgsArray.length = 0
      var ch
      while ((ch = GROWABLE_HEAP_U8()[sigPtr++])) {
        var wide = ch != 105
        wide &= ch != 112
        buf += wide && buf % 8 ? 4 : 0
        readEmAsmArgsArray.push(
          ch == 112
            ? GROWABLE_HEAP_U32()[buf >> 2]
            : ch == 105
              ? GROWABLE_HEAP_I32()[buf >> 2]
              : GROWABLE_HEAP_F64()[buf >> 3]
        )
        buf += wide ? 8 : 4
      }
      return readEmAsmArgsArray
    }
    var runEmAsmFunction = (code, sigPtr, argbuf) => {
      var args = readEmAsmArgs(sigPtr, argbuf)
      return ASM_CONSTS[code].apply(null, args)
    }
    var _emscripten_asm_const_int = (code, sigPtr, argbuf) => runEmAsmFunction(code, sigPtr, argbuf)
    var warnOnce = (text) => {
      if (!warnOnce.shown) warnOnce.shown = {}
      if (!warnOnce.shown[text]) {
        warnOnce.shown[text] = 1
        err(text)
      }
    }
    var _emscripten_check_blocking_allowed = () => {}
    var _emscripten_date_now = () => Date.now()
    var _emscripten_exit_with_live_runtime = () => {
      runtimeKeepalivePush()
      throw 'unwind'
    }
    var _emscripten_get_now
    _emscripten_get_now = () => performance.timeOrigin + performance.now()
    var getHeapMax = () => 2147483648
    var growMemory = (size) => {
      var b = wasmMemory.buffer
      var pages = (size - b.byteLength + 65535) / 65536
      try {
        wasmMemory.grow(pages)
        updateMemoryViews()
        return 1
      } catch (e) {}
    }
    var _emscripten_resize_heap = (requestedSize) => {
      var oldSize = GROWABLE_HEAP_U8().length
      requestedSize >>>= 0
      if (requestedSize <= oldSize) {
        return false
      }
      var maxHeapSize = getHeapMax()
      if (requestedSize > maxHeapSize) {
        return false
      }
      var alignUp = (x, multiple) => x + ((multiple - (x % multiple)) % multiple)
      for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
        var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown)
        overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296)
        var newSize = Math.min(
          maxHeapSize,
          alignUp(Math.max(requestedSize, overGrownHeapSize), 65536)
        )
        var replacement = growMemory(newSize)
        if (replacement) {
          return true
        }
      }
      return false
    }
    var ENV = {}
    var getExecutableName = () => thisProgram || './this.program'
    var getEnvStrings = () => {
      if (!getEnvStrings.strings) {
        var lang =
          (
            (typeof navigator == 'object' && navigator.languages && navigator.languages[0]) ||
            'C'
          ).replace('-', '_') + '.UTF-8'
        var env = {
          USER: 'web_user',
          LOGNAME: 'web_user',
          PATH: '/',
          PWD: '/',
          HOME: '/home/web_user',
          LANG: lang,
          _: getExecutableName()
        }
        for (var x in ENV) {
          if (ENV[x] === undefined) delete env[x]
          else env[x] = ENV[x]
        }
        var strings = []
        for (var x in env) {
          strings.push(`${x}=${env[x]}`)
        }
        getEnvStrings.strings = strings
      }
      return getEnvStrings.strings
    }
    var stringToAscii = (str, buffer) => {
      for (var i = 0; i < str.length; ++i) {
        GROWABLE_HEAP_I8()[buffer++ >> 0] = str.charCodeAt(i)
      }
      GROWABLE_HEAP_I8()[buffer >> 0] = 0
    }
    var _environ_get = function (__environ, environ_buf) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(19, 1, __environ, environ_buf)
      var bufSize = 0
      getEnvStrings().forEach((string, i) => {
        var ptr = environ_buf + bufSize
        GROWABLE_HEAP_U32()[(__environ + i * 4) >> 2] = ptr
        stringToAscii(string, ptr)
        bufSize += string.length + 1
      })
      return 0
    }
    var _environ_sizes_get = function (penviron_count, penviron_buf_size) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(20, 1, penviron_count, penviron_buf_size)
      var strings = getEnvStrings()
      GROWABLE_HEAP_U32()[penviron_count >> 2] = strings.length
      var bufSize = 0
      strings.forEach((string) => (bufSize += string.length + 1))
      GROWABLE_HEAP_U32()[penviron_buf_size >> 2] = bufSize
      return 0
    }
    function _fd_close(fd) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(21, 1, fd)
      try {
        var stream = SYSCALLS.getStreamFromFD(fd)
        FS.close(stream)
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return e.errno
      }
    }
    var doReadv = (stream, iov, iovcnt, offset) => {
      var ret = 0
      for (var i = 0; i < iovcnt; i++) {
        var ptr = GROWABLE_HEAP_U32()[iov >> 2]
        var len = GROWABLE_HEAP_U32()[(iov + 4) >> 2]
        iov += 8
        var curr = FS.read(stream, GROWABLE_HEAP_I8(), ptr, len, offset)
        if (curr < 0) return -1
        ret += curr
        if (curr < len) break
        if (typeof offset !== 'undefined') {
          offset += curr
        }
      }
      return ret
    }
    function _fd_read(fd, iov, iovcnt, pnum) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(22, 1, fd, iov, iovcnt, pnum)
      try {
        var stream = SYSCALLS.getStreamFromFD(fd)
        var num = doReadv(stream, iov, iovcnt)
        GROWABLE_HEAP_U32()[pnum >> 2] = num
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return e.errno
      }
    }
    function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
      if (ENVIRONMENT_IS_PTHREAD)
        return proxyToMainThread(23, 1, fd, offset_low, offset_high, whence, newOffset)
      var offset = convertI32PairToI53Checked(offset_low, offset_high)
      try {
        if (isNaN(offset)) return 61
        var stream = SYSCALLS.getStreamFromFD(fd)
        FS.llseek(stream, offset, whence)
        ;((tempI64 = [
          stream.position >>> 0,
          ((tempDouble = stream.position),
          +Math.abs(tempDouble) >= 1
            ? tempDouble > 0
              ? +Math.floor(tempDouble / 4294967296) >>> 0
              : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
            : 0)
        ]),
          (GROWABLE_HEAP_I32()[newOffset >> 2] = tempI64[0]),
          (GROWABLE_HEAP_I32()[(newOffset + 4) >> 2] = tempI64[1]))
        if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return e.errno
      }
    }
    var doWritev = (stream, iov, iovcnt, offset) => {
      var ret = 0
      for (var i = 0; i < iovcnt; i++) {
        var ptr = GROWABLE_HEAP_U32()[iov >> 2]
        var len = GROWABLE_HEAP_U32()[(iov + 4) >> 2]
        iov += 8
        var curr = FS.write(stream, GROWABLE_HEAP_I8(), ptr, len, offset)
        if (curr < 0) return -1
        ret += curr
        if (typeof offset !== 'undefined') {
          offset += curr
        }
      }
      return ret
    }
    function _fd_write(fd, iov, iovcnt, pnum) {
      if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(24, 1, fd, iov, iovcnt, pnum)
      try {
        var stream = SYSCALLS.getStreamFromFD(fd)
        var num = doWritev(stream, iov, iovcnt)
        GROWABLE_HEAP_U32()[pnum >> 2] = num
        return 0
      } catch (e) {
        if (typeof FS == 'undefined' || !(e.name === 'ErrnoError')) throw e
        return e.errno
      }
    }
    var arraySum = (array, index) => {
      var sum = 0
      for (var i = 0; i <= index; sum += array[i++]) {}
      return sum
    }
    var MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    var MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    var addDays = (date, days) => {
      var newDate = new Date(date.getTime())
      while (days > 0) {
        var leap = isLeapYear(newDate.getFullYear())
        var currentMonth = newDate.getMonth()
        var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth]
        if (days > daysInCurrentMonth - newDate.getDate()) {
          days -= daysInCurrentMonth - newDate.getDate() + 1
          newDate.setDate(1)
          if (currentMonth < 11) {
            newDate.setMonth(currentMonth + 1)
          } else {
            newDate.setMonth(0)
            newDate.setFullYear(newDate.getFullYear() + 1)
          }
        } else {
          newDate.setDate(newDate.getDate() + days)
          return newDate
        }
      }
      return newDate
    }
    var writeArrayToMemory = (array, buffer) => {
      GROWABLE_HEAP_I8().set(array, buffer)
    }
    var _strftime = (s, maxsize, format, tm) => {
      var tm_zone = GROWABLE_HEAP_U32()[(tm + 40) >> 2]
      var date = {
        tm_sec: GROWABLE_HEAP_I32()[tm >> 2],
        tm_min: GROWABLE_HEAP_I32()[(tm + 4) >> 2],
        tm_hour: GROWABLE_HEAP_I32()[(tm + 8) >> 2],
        tm_mday: GROWABLE_HEAP_I32()[(tm + 12) >> 2],
        tm_mon: GROWABLE_HEAP_I32()[(tm + 16) >> 2],
        tm_year: GROWABLE_HEAP_I32()[(tm + 20) >> 2],
        tm_wday: GROWABLE_HEAP_I32()[(tm + 24) >> 2],
        tm_yday: GROWABLE_HEAP_I32()[(tm + 28) >> 2],
        tm_isdst: GROWABLE_HEAP_I32()[(tm + 32) >> 2],
        tm_gmtoff: GROWABLE_HEAP_I32()[(tm + 36) >> 2],
        tm_zone: tm_zone ? UTF8ToString(tm_zone) : ''
      }
      var pattern = UTF8ToString(format)
      var EXPANSION_RULES_1 = {
        '%c': '%a %b %d %H:%M:%S %Y',
        '%D': '%m/%d/%y',
        '%F': '%Y-%m-%d',
        '%h': '%b',
        '%r': '%I:%M:%S %p',
        '%R': '%H:%M',
        '%T': '%H:%M:%S',
        '%x': '%m/%d/%y',
        '%X': '%H:%M:%S',
        '%Ec': '%c',
        '%EC': '%C',
        '%Ex': '%m/%d/%y',
        '%EX': '%H:%M:%S',
        '%Ey': '%y',
        '%EY': '%Y',
        '%Od': '%d',
        '%Oe': '%e',
        '%OH': '%H',
        '%OI': '%I',
        '%Om': '%m',
        '%OM': '%M',
        '%OS': '%S',
        '%Ou': '%u',
        '%OU': '%U',
        '%OV': '%V',
        '%Ow': '%w',
        '%OW': '%W',
        '%Oy': '%y'
      }
      for (var rule in EXPANSION_RULES_1) {
        pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_1[rule])
      }
      var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      var MONTHS = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
      function leadingSomething(value, digits, character) {
        var str = typeof value == 'number' ? value.toString() : value || ''
        while (str.length < digits) {
          str = character[0] + str
        }
        return str
      }
      function leadingNulls(value, digits) {
        return leadingSomething(value, digits, '0')
      }
      function compareByDay(date1, date2) {
        function sgn(value) {
          return value < 0 ? -1 : value > 0 ? 1 : 0
        }
        var compare
        if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
          if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
            compare = sgn(date1.getDate() - date2.getDate())
          }
        }
        return compare
      }
      function getFirstWeekStartDate(janFourth) {
        switch (janFourth.getDay()) {
          case 0:
            return new Date(janFourth.getFullYear() - 1, 11, 29)
          case 1:
            return janFourth
          case 2:
            return new Date(janFourth.getFullYear(), 0, 3)
          case 3:
            return new Date(janFourth.getFullYear(), 0, 2)
          case 4:
            return new Date(janFourth.getFullYear(), 0, 1)
          case 5:
            return new Date(janFourth.getFullYear() - 1, 11, 31)
          case 6:
            return new Date(janFourth.getFullYear() - 1, 11, 30)
        }
      }
      function getWeekBasedYear(date) {
        var thisDate = addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday)
        var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4)
        var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4)
        var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear)
        var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear)
        if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
          if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
            return thisDate.getFullYear() + 1
          }
          return thisDate.getFullYear()
        }
        return thisDate.getFullYear() - 1
      }
      var EXPANSION_RULES_2 = {
        '%a': (date) => WEEKDAYS[date.tm_wday].substring(0, 3),
        '%A': (date) => WEEKDAYS[date.tm_wday],
        '%b': (date) => MONTHS[date.tm_mon].substring(0, 3),
        '%B': (date) => MONTHS[date.tm_mon],
        '%C': (date) => {
          var year = date.tm_year + 1900
          return leadingNulls((year / 100) | 0, 2)
        },
        '%d': (date) => leadingNulls(date.tm_mday, 2),
        '%e': (date) => leadingSomething(date.tm_mday, 2, ' '),
        '%g': (date) => getWeekBasedYear(date).toString().substring(2),
        '%G': (date) => getWeekBasedYear(date),
        '%H': (date) => leadingNulls(date.tm_hour, 2),
        '%I': (date) => {
          var twelveHour = date.tm_hour
          if (twelveHour == 0) twelveHour = 12
          else if (twelveHour > 12) twelveHour -= 12
          return leadingNulls(twelveHour, 2)
        },
        '%j': (date) =>
          leadingNulls(
            date.tm_mday +
              arraySum(
                isLeapYear(date.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR,
                date.tm_mon - 1
              ),
            3
          ),
        '%m': (date) => leadingNulls(date.tm_mon + 1, 2),
        '%M': (date) => leadingNulls(date.tm_min, 2),
        '%n': () => '\n',
        '%p': (date) => {
          if (date.tm_hour >= 0 && date.tm_hour < 12) {
            return 'AM'
          }
          return 'PM'
        },
        '%S': (date) => leadingNulls(date.tm_sec, 2),
        '%t': () => '\t',
        '%u': (date) => date.tm_wday || 7,
        '%U': (date) => {
          var days = date.tm_yday + 7 - date.tm_wday
          return leadingNulls(Math.floor(days / 7), 2)
        },
        '%V': (date) => {
          var val = Math.floor((date.tm_yday + 7 - ((date.tm_wday + 6) % 7)) / 7)
          if ((date.tm_wday + 371 - date.tm_yday - 2) % 7 <= 2) {
            val++
          }
          if (!val) {
            val = 52
            var dec31 = (date.tm_wday + 7 - date.tm_yday - 1) % 7
            if (dec31 == 4 || (dec31 == 5 && isLeapYear((date.tm_year % 400) - 1))) {
              val++
            }
          } else if (val == 53) {
            var jan1 = (date.tm_wday + 371 - date.tm_yday) % 7
            if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date.tm_year))) val = 1
          }
          return leadingNulls(val, 2)
        },
        '%w': (date) => date.tm_wday,
        '%W': (date) => {
          var days = date.tm_yday + 7 - ((date.tm_wday + 6) % 7)
          return leadingNulls(Math.floor(days / 7), 2)
        },
        '%y': (date) => (date.tm_year + 1900).toString().substring(2),
        '%Y': (date) => date.tm_year + 1900,
        '%z': (date) => {
          var off = date.tm_gmtoff
          var ahead = off >= 0
          off = Math.abs(off) / 60
          off = (off / 60) * 100 + (off % 60)
          return (ahead ? '+' : '-') + String('0000' + off).slice(-4)
        },
        '%Z': (date) => date.tm_zone,
        '%%': () => '%'
      }
      pattern = pattern.replace(/%%/g, '\0\0')
      for (var rule in EXPANSION_RULES_2) {
        if (pattern.includes(rule)) {
          pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_2[rule](date))
        }
      }
      pattern = pattern.replace(/\0\0/g, '%')
      var bytes = intArrayFromString(pattern, false)
      if (bytes.length > maxsize) {
        return 0
      }
      writeArrayToMemory(bytes, s)
      return bytes.length - 1
    }
    var _strftime_l = (s, maxsize, format, tm, loc) => _strftime(s, maxsize, format, tm)
    PThread.init()
    var FSNode = function (parent, name, mode, rdev) {
      if (!parent) {
        parent = this
      }
      this.parent = parent
      this.mount = parent.mount
      this.mounted = null
      this.id = FS.nextInode++
      this.name = name
      this.mode = mode
      this.node_ops = {}
      this.stream_ops = {}
      this.rdev = rdev
    }
    var readMode = 292 | 73
    var writeMode = 146
    Object.defineProperties(FSNode.prototype, {
      read: {
        get: function () {
          return (this.mode & readMode) === readMode
        },
        set: function (val) {
          val ? (this.mode |= readMode) : (this.mode &= ~readMode)
        }
      },
      write: {
        get: function () {
          return (this.mode & writeMode) === writeMode
        },
        set: function (val) {
          val ? (this.mode |= writeMode) : (this.mode &= ~writeMode)
        }
      },
      isFolder: {
        get: function () {
          return FS.isDir(this.mode)
        }
      },
      isDevice: {
        get: function () {
          return FS.isChrdev(this.mode)
        }
      }
    })
    FS.FSNode = FSNode
    FS.createPreloadedFile = FS_createPreloadedFile
    FS.staticInit()
    embind_init_charCodes()
    BindingError = Module['BindingError'] = class BindingError extends Error {
      constructor(message) {
        super(message)
        this.name = 'BindingError'
      }
    }
    InternalError = Module['InternalError'] = class InternalError extends Error {
      constructor(message) {
        super(message)
        this.name = 'InternalError'
      }
    }
    init_ClassHandle()
    init_embind()
    init_RegisteredPointer()
    UnboundTypeError = Module['UnboundTypeError'] = extendError(Error, 'UnboundTypeError')
    handleAllocatorInit()
    init_emval()
    var proxiedFunctionTable = [
      _proc_exit,
      exitOnMainThread,
      ___syscall__newselect,
      ___syscall_connect,
      ___syscall_faccessat,
      ___syscall_fcntl64,
      ___syscall_fstat64,
      ___syscall_ftruncate64,
      ___syscall_getsockopt,
      ___syscall_ioctl,
      ___syscall_lstat64,
      ___syscall_mkdirat,
      ___syscall_newfstatat,
      ___syscall_openat,
      ___syscall_pipe,
      ___syscall_poll,
      ___syscall_socket,
      ___syscall_stat64,
      ___syscall_unlinkat,
      _environ_get,
      _environ_sizes_get,
      _fd_close,
      _fd_read,
      _fd_seek,
      _fd_write
    ]
    var wasmImports = {
      h: ___assert_fail,
      Qa: __asyncjs__em_libusb_wait,
      A: ___cxa_begin_catch,
      F: ___cxa_end_catch,
      b: ___cxa_find_matching_catch_2,
      j: ___cxa_find_matching_catch_3,
      T: ___cxa_rethrow,
      z: ___cxa_throw,
      la: ___cxa_uncaught_exceptions,
      ya: ___emscripten_init_main_thread_js,
      ja: ___emscripten_thread_cleanup,
      e: ___resumeException,
      ra: ___syscall__newselect,
      ia: ___syscall_connect,
      Ia: ___syscall_faccessat,
      O: ___syscall_fcntl64,
      ea: ___syscall_ftruncate64,
      ha: ___syscall_getsockopt,
      Ca: ___syscall_ioctl,
      wa: ___syscall_mkdirat,
      Da: ___syscall_openat,
      va: ___syscall_pipe,
      ua: ___syscall_poll,
      ga: ___syscall_socket,
      qa: ___syscall_stat64,
      na: ___syscall_unlinkat,
      fa: __embind_register_bigint,
      Ka: __embind_register_bool,
      Ha: __embind_register_class,
      Ba: __embind_register_class_constructor,
      C: __embind_register_class_function,
      Ja: __embind_register_emval,
      W: __embind_register_float,
      x: __embind_register_integer,
      n: __embind_register_memory_view,
      X: __embind_register_std_string,
      R: __embind_register_std_wstring,
      La: __embind_register_void,
      Ga: __emscripten_get_now_is_monotonic,
      pa: __emscripten_notify_mailbox_postmessage,
      ta: __emscripten_receive_on_main_thread_js,
      xa: __emscripten_thread_mailbox_await,
      Fa: __emscripten_thread_set_strongref,
      G: __emval_as,
      Oa: __emval_await,
      Ta: __emval_call,
      t: __emval_call_method,
      Sa: __emval_decref,
      D: __emval_get_global,
      s: __emval_get_method_caller,
      r: __emval_get_property,
      u: __emval_incref,
      Ma: __emval_is_string,
      _: __emval_new,
      Ua: __emval_new_array,
      m: __emval_new_cstring,
      E: __emval_new_object,
      p: __emval_run_destructors,
      H: __emval_set_property,
      y: __emval_take_value,
      aa: __gmtime_js,
      ba: __localtime_js,
      ca: __mktime_js,
      oa: __tzset_js,
      N: _abort,
      Ra: em_libusb_notify,
      Z: em_promise_catch_impl,
      Pa: em_start_transfer_impl,
      Na: _emscripten_asm_const_int,
      sa: _emscripten_check_blocking_allowed,
      P: _emscripten_date_now,
      Ea: _emscripten_exit_with_live_runtime,
      v: _emscripten_get_now,
      ma: _emscripten_resize_heap,
      za: _environ_get,
      Aa: _environ_sizes_get,
      Y: _exit,
      Q: _fd_close,
      V: _fd_read,
      da: _fd_seek,
      U: _fd_write,
      M: invoke_diii,
      L: invoke_i,
      d: invoke_ii,
      c: invoke_iii,
      o: invoke_iiii,
      K: invoke_iiiii,
      w: invoke_iiiiiii,
      S: invoke_iiiiiiii,
      J: invoke_iiiiiiiiiiii,
      $: invoke_iiij,
      i: invoke_v,
      f: invoke_vi,
      g: invoke_vii,
      k: invoke_viii,
      l: invoke_viiii,
      q: invoke_viiiiiii,
      B: invoke_viiiiiiiiii,
      I: invoke_viiiiiiiiiiiiiii,
      a: wasmMemory || Module['wasmMemory'],
      ka: _strftime_l
    }
    var wasmExports = createWasm()
    var ___wasm_call_ctors = () => (___wasm_call_ctors = wasmExports['Va'])()
    var ___cxa_free_exception = (a0) =>
      (___cxa_free_exception = wasmExports['__cxa_free_exception'])(a0)
    var _pthread_self = (Module['_pthread_self'] = () =>
      (_pthread_self = Module['_pthread_self'] = wasmExports['Wa'])())
    var _free = (a0) => (_free = wasmExports['Xa'])(a0)
    var _malloc = (a0) => (_malloc = wasmExports['Ya'])(a0)
    var _htons = (a0) => (_htons = wasmExports['Za'])(a0)
    var ___errno_location = () => (___errno_location = wasmExports['_a'])()
    var _em_signal_transfer_completion = (Module['_em_signal_transfer_completion'] = (a0, a1) =>
      (_em_signal_transfer_completion = Module['_em_signal_transfer_completion'] =
        wasmExports['$a'])(a0, a1))
    var __emscripten_tls_init = (Module['__emscripten_tls_init'] = () =>
      (__emscripten_tls_init = Module['__emscripten_tls_init'] = wasmExports['ab'])())
    var ___getTypeName = (a0) => (___getTypeName = wasmExports['bb'])(a0)
    var __embind_initialize_bindings = (Module['__embind_initialize_bindings'] = () =>
      (__embind_initialize_bindings = Module['__embind_initialize_bindings'] = wasmExports['cb'])())
    var __emscripten_thread_init = (Module['__emscripten_thread_init'] = (a0, a1, a2, a3, a4, a5) =>
      (__emscripten_thread_init = Module['__emscripten_thread_init'] = wasmExports['eb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5
      ))
    var __emscripten_thread_crashed = (Module['__emscripten_thread_crashed'] = () =>
      (__emscripten_thread_crashed = Module['__emscripten_thread_crashed'] = wasmExports['fb'])())
    var _emscripten_main_thread_process_queued_calls = () =>
      (_emscripten_main_thread_process_queued_calls =
        wasmExports['emscripten_main_thread_process_queued_calls'])()
    var _emscripten_main_runtime_thread_id = () =>
      (_emscripten_main_runtime_thread_id = wasmExports['emscripten_main_runtime_thread_id'])()
    var _ntohs = (a0) => (_ntohs = wasmExports['gb'])(a0)
    var __emscripten_run_on_main_thread_js = (a0, a1, a2, a3) =>
      (__emscripten_run_on_main_thread_js = wasmExports['hb'])(a0, a1, a2, a3)
    var __emscripten_thread_free_data = (a0) =>
      (__emscripten_thread_free_data = wasmExports['ib'])(a0)
    var __emscripten_thread_exit = (Module['__emscripten_thread_exit'] = (a0) =>
      (__emscripten_thread_exit = Module['__emscripten_thread_exit'] = wasmExports['jb'])(a0))
    var __emscripten_check_mailbox = (Module['__emscripten_check_mailbox'] = () =>
      (__emscripten_check_mailbox = Module['__emscripten_check_mailbox'] = wasmExports['kb'])())
    var _setThrew = (a0, a1) => (_setThrew = wasmExports['lb'])(a0, a1)
    var setTempRet0 = (a0) => (setTempRet0 = wasmExports['mb'])(a0)
    var _emscripten_stack_set_limits = (a0, a1) =>
      (_emscripten_stack_set_limits = wasmExports['nb'])(a0, a1)
    var stackSave = () => (stackSave = wasmExports['ob'])()
    var stackRestore = (a0) => (stackRestore = wasmExports['pb'])(a0)
    var stackAlloc = (a0) => (stackAlloc = wasmExports['qb'])(a0)
    var ___cxa_decrement_exception_refcount = (a0) =>
      (___cxa_decrement_exception_refcount = wasmExports['rb'])(a0)
    var ___cxa_increment_exception_refcount = (a0) =>
      (___cxa_increment_exception_refcount = wasmExports['sb'])(a0)
    var ___cxa_can_catch = (a0, a1, a2) => (___cxa_can_catch = wasmExports['tb'])(a0, a1, a2)
    var ___cxa_is_pointer_type = (a0) => (___cxa_is_pointer_type = wasmExports['ub'])(a0)
    var dynCall_v = (Module['dynCall_v'] = (a0) =>
      (dynCall_v = Module['dynCall_v'] = wasmExports['vb'])(a0))
    var dynCall_ii = (Module['dynCall_ii'] = (a0, a1) =>
      (dynCall_ii = Module['dynCall_ii'] = wasmExports['wb'])(a0, a1))
    var dynCall_vi = (Module['dynCall_vi'] = (a0, a1) =>
      (dynCall_vi = Module['dynCall_vi'] = wasmExports['xb'])(a0, a1))
    var dynCall_i = (Module['dynCall_i'] = (a0) =>
      (dynCall_i = Module['dynCall_i'] = wasmExports['yb'])(a0))
    var dynCall_vii = (Module['dynCall_vii'] = (a0, a1, a2) =>
      (dynCall_vii = Module['dynCall_vii'] = wasmExports['zb'])(a0, a1, a2))
    var dynCall_iii = (Module['dynCall_iii'] = (a0, a1, a2) =>
      (dynCall_iii = Module['dynCall_iii'] = wasmExports['Ab'])(a0, a1, a2))
    var dynCall_viii = (Module['dynCall_viii'] = (a0, a1, a2, a3) =>
      (dynCall_viii = Module['dynCall_viii'] = wasmExports['Bb'])(a0, a1, a2, a3))
    var dynCall_viiii = (Module['dynCall_viiii'] = (a0, a1, a2, a3, a4) =>
      (dynCall_viiii = Module['dynCall_viiii'] = wasmExports['Cb'])(a0, a1, a2, a3, a4))
    var dynCall_diii = (Module['dynCall_diii'] = (a0, a1, a2, a3) =>
      (dynCall_diii = Module['dynCall_diii'] = wasmExports['Db'])(a0, a1, a2, a3))
    var dynCall_iiiii = (Module['dynCall_iiiii'] = (a0, a1, a2, a3, a4) =>
      (dynCall_iiiii = Module['dynCall_iiiii'] = wasmExports['Eb'])(a0, a1, a2, a3, a4))
    var dynCall_iiiiiii = (Module['dynCall_iiiiiii'] = (a0, a1, a2, a3, a4, a5, a6) =>
      (dynCall_iiiiiii = Module['dynCall_iiiiiii'] = wasmExports['Fb'])(a0, a1, a2, a3, a4, a5, a6))
    var dynCall_iiii = (Module['dynCall_iiii'] = (a0, a1, a2, a3) =>
      (dynCall_iiii = Module['dynCall_iiii'] = wasmExports['Gb'])(a0, a1, a2, a3))
    var dynCall_iidiiii = (Module['dynCall_iidiiii'] = (a0, a1, a2, a3, a4, a5, a6) =>
      (dynCall_iidiiii = Module['dynCall_iidiiii'] = wasmExports['Hb'])(a0, a1, a2, a3, a4, a5, a6))
    var dynCall_iiiiii = (Module['dynCall_iiiiii'] = (a0, a1, a2, a3, a4, a5) =>
      (dynCall_iiiiii = Module['dynCall_iiiiii'] = wasmExports['Ib'])(a0, a1, a2, a3, a4, a5))
    var dynCall_iiiji = (Module['dynCall_iiiji'] = (a0, a1, a2, a3, a4, a5) =>
      (dynCall_iiiji = Module['dynCall_iiiji'] = wasmExports['Jb'])(a0, a1, a2, a3, a4, a5))
    var dynCall_iiiiiiii = (Module['dynCall_iiiiiiii'] = (a0, a1, a2, a3, a4, a5, a6, a7) =>
      (dynCall_iiiiiiii = Module['dynCall_iiiiiiii'] = wasmExports['Kb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7
      ))
    var dynCall_jiji = (Module['dynCall_jiji'] = (a0, a1, a2, a3, a4) =>
      (dynCall_jiji = Module['dynCall_jiji'] = wasmExports['Lb'])(a0, a1, a2, a3, a4))
    var dynCall_iiij = (Module['dynCall_iiij'] = (a0, a1, a2, a3, a4) =>
      (dynCall_iiij = Module['dynCall_iiij'] = wasmExports['Mb'])(a0, a1, a2, a3, a4))
    var dynCall_viiiiiii = (Module['dynCall_viiiiiii'] = (a0, a1, a2, a3, a4, a5, a6, a7) =>
      (dynCall_viiiiiii = Module['dynCall_viiiiiii'] = wasmExports['Nb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7
      ))
    var dynCall_iiiiiiiiiiii = (Module['dynCall_iiiiiiiiiiii'] = (
      a0,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9,
      a10,
      a11
    ) =>
      (dynCall_iiiiiiiiiiii = Module['dynCall_iiiiiiiiiiii'] = wasmExports['Ob'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9,
        a10,
        a11
      ))
    var dynCall_viiiiiiiiii = (Module['dynCall_viiiiiiiiii'] = (
      a0,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9,
      a10
    ) =>
      (dynCall_viiiiiiiiii = Module['dynCall_viiiiiiiiii'] = wasmExports['Pb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9,
        a10
      ))
    var dynCall_viiiiiiiiiiiiiii = (Module['dynCall_viiiiiiiiiiiiiii'] = (
      a0,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9,
      a10,
      a11,
      a12,
      a13,
      a14,
      a15
    ) =>
      (dynCall_viiiiiiiiiiiiiii = Module['dynCall_viiiiiiiiiiiiiii'] = wasmExports['Qb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9,
        a10,
        a11,
        a12,
        a13,
        a14,
        a15
      ))
    var dynCall_iiiiijiiii = (Module['dynCall_iiiiijiiii'] = (
      a0,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9,
      a10
    ) =>
      (dynCall_iiiiijiiii = Module['dynCall_iiiiijiiii'] = wasmExports['Rb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9,
        a10
      ))
    var dynCall_iiijiii = (Module['dynCall_iiijiii'] = (a0, a1, a2, a3, a4, a5, a6, a7) =>
      (dynCall_iiijiii = Module['dynCall_iiijiii'] = wasmExports['Sb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7
      ))
    var dynCall_iiijii = (Module['dynCall_iiijii'] = (a0, a1, a2, a3, a4, a5, a6) =>
      (dynCall_iiijii = Module['dynCall_iiijii'] = wasmExports['Tb'])(a0, a1, a2, a3, a4, a5, a6))
    var dynCall_iiiiiiiii = (Module['dynCall_iiiiiiiii'] = (a0, a1, a2, a3, a4, a5, a6, a7, a8) =>
      (dynCall_iiiiiiiii = Module['dynCall_iiiiiiiii'] = wasmExports['Ub'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8
      ))
    var dynCall_iiiiiijii = (Module['dynCall_iiiiiijii'] = (
      a0,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9
    ) =>
      (dynCall_iiiiiijii = Module['dynCall_iiiiiijii'] = wasmExports['Vb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9
      ))
    var dynCall_iiijjii = (Module['dynCall_iiijjii'] = (a0, a1, a2, a3, a4, a5, a6, a7, a8) =>
      (dynCall_iiijjii = Module['dynCall_iiijjii'] = wasmExports['Wb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8
      ))
    var dynCall_iiiijii = (Module['dynCall_iiiijii'] = (a0, a1, a2, a3, a4, a5, a6, a7) =>
      (dynCall_iiiijii = Module['dynCall_iiiijii'] = wasmExports['Xb'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7
      ))
    var dynCall_iiiiji = (Module['dynCall_iiiiji'] = (a0, a1, a2, a3, a4, a5, a6) =>
      (dynCall_iiiiji = Module['dynCall_iiiiji'] = wasmExports['Yb'])(a0, a1, a2, a3, a4, a5, a6))
    var dynCall_viijii = (Module['dynCall_viijii'] = (a0, a1, a2, a3, a4, a5, a6) =>
      (dynCall_viijii = Module['dynCall_viijii'] = wasmExports['Zb'])(a0, a1, a2, a3, a4, a5, a6))
    var dynCall_iiiiij = (Module['dynCall_iiiiij'] = (a0, a1, a2, a3, a4, a5, a6) =>
      (dynCall_iiiiij = Module['dynCall_iiiiij'] = wasmExports['_b'])(a0, a1, a2, a3, a4, a5, a6))
    var dynCall_iiiiid = (Module['dynCall_iiiiid'] = (a0, a1, a2, a3, a4, a5) =>
      (dynCall_iiiiid = Module['dynCall_iiiiid'] = wasmExports['$b'])(a0, a1, a2, a3, a4, a5))
    var dynCall_iiiiijj = (Module['dynCall_iiiiijj'] = (a0, a1, a2, a3, a4, a5, a6, a7, a8) =>
      (dynCall_iiiiijj = Module['dynCall_iiiiijj'] = wasmExports['ac'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8
      ))
    var dynCall_iiiiiijj = (Module['dynCall_iiiiiijj'] = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) =>
      (dynCall_iiiiiijj = Module['dynCall_iiiiiijj'] = wasmExports['bc'])(
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9
      ))
    var dynCall_viiiiii = (Module['dynCall_viiiiii'] = (a0, a1, a2, a3, a4, a5, a6) =>
      (dynCall_viiiiii = Module['dynCall_viiiiii'] = wasmExports['cc'])(a0, a1, a2, a3, a4, a5, a6))
    var dynCall_viiiii = (Module['dynCall_viiiii'] = (a0, a1, a2, a3, a4, a5) =>
      (dynCall_viiiii = Module['dynCall_viiiii'] = wasmExports['dc'])(a0, a1, a2, a3, a4, a5))
    var _asyncify_start_unwind = (a0) => (_asyncify_start_unwind = wasmExports['ec'])(a0)
    var _asyncify_stop_unwind = () => (_asyncify_stop_unwind = wasmExports['fc'])()
    var _asyncify_start_rewind = (a0) => (_asyncify_start_rewind = wasmExports['gc'])(a0)
    var _asyncify_stop_rewind = () => (_asyncify_stop_rewind = wasmExports['hc'])()
    var ___start_em_js = (Module['___start_em_js'] = 472620)
    var ___stop_em_js = (Module['___stop_em_js'] = 473828)
    function invoke_vi(index, a1) {
      var sp = stackSave()
      try {
        dynCall_vi(index, a1)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_vii(index, a1, a2) {
      var sp = stackSave()
      try {
        dynCall_vii(index, a1, a2)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_iii(index, a1, a2) {
      var sp = stackSave()
      try {
        return dynCall_iii(index, a1, a2)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_diii(index, a1, a2, a3) {
      var sp = stackSave()
      try {
        return dynCall_diii(index, a1, a2, a3)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_viii(index, a1, a2, a3) {
      var sp = stackSave()
      try {
        dynCall_viii(index, a1, a2, a3)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_iiiii(index, a1, a2, a3, a4) {
      var sp = stackSave()
      try {
        return dynCall_iiiii(index, a1, a2, a3, a4)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_viiii(index, a1, a2, a3, a4) {
      var sp = stackSave()
      try {
        dynCall_viiii(index, a1, a2, a3, a4)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_ii(index, a1) {
      var sp = stackSave()
      try {
        return dynCall_ii(index, a1)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_iiii(index, a1, a2, a3) {
      var sp = stackSave()
      try {
        return dynCall_iiii(index, a1, a2, a3)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_i(index) {
      var sp = stackSave()
      try {
        return dynCall_i(index)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_iiiiiii(index, a1, a2, a3, a4, a5, a6) {
      var sp = stackSave()
      try {
        return dynCall_iiiiiii(index, a1, a2, a3, a4, a5, a6)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_v(index) {
      var sp = stackSave()
      try {
        dynCall_v(index)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_iiiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
      var sp = stackSave()
      try {
        return dynCall_iiiiiiii(index, a1, a2, a3, a4, a5, a6, a7)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
      var sp = stackSave()
      try {
        dynCall_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_iiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) {
      var sp = stackSave()
      try {
        return dynCall_iiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_viiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
      var sp = stackSave()
      try {
        dynCall_viiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_viiiiiiiiiiiiiii(
      index,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9,
      a10,
      a11,
      a12,
      a13,
      a14,
      a15
    ) {
      var sp = stackSave()
      try {
        dynCall_viiiiiiiiiiiiiii(
          index,
          a1,
          a2,
          a3,
          a4,
          a5,
          a6,
          a7,
          a8,
          a9,
          a10,
          a11,
          a12,
          a13,
          a14,
          a15
        )
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    function invoke_iiij(index, a1, a2, a3, a4) {
      var sp = stackSave()
      try {
        return dynCall_iiij(index, a1, a2, a3, a4)
      } catch (e) {
        stackRestore(sp)
        if (e !== e + 0) throw e
        _setThrew(1, 0)
      }
    }
    Module['wasmMemory'] = wasmMemory
    Module['keepRuntimeAlive'] = keepRuntimeAlive
    Module['ExitStatus'] = ExitStatus
    Module['PThread'] = PThread
    var calledRun
    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run()
      if (!calledRun) dependenciesFulfilled = runCaller
    }
    function run() {
      if (runDependencies > 0) {
        return
      }
      if (ENVIRONMENT_IS_PTHREAD) {
        readyPromiseResolve(Module)
        initRuntime()
        startWorker(Module)
        return
      }
      preRun()
      if (runDependencies > 0) {
        return
      }
      function doRun() {
        if (calledRun) return
        calledRun = true
        Module['calledRun'] = true
        if (ABORT) return
        initRuntime()
        readyPromiseResolve(Module)
        if (Module['onRuntimeInitialized']) Module['onRuntimeInitialized']()
        postRun()
      }
      if (Module['setStatus']) {
        Module['setStatus']('Running...')
        setTimeout(function () {
          setTimeout(function () {
            Module['setStatus']('')
          }, 1)
          doRun()
        }, 1)
      } else {
        doRun()
      }
    }
    if (Module['preInit']) {
      if (typeof Module['preInit'] == 'function') Module['preInit'] = [Module['preInit']]
      while (Module['preInit'].length > 0) {
        Module['preInit'].pop()()
      }
    }
    run()

    return moduleArg.ready
  }
})()
export default Module
